export const formDataSaqC = [
  // Page 09
  {
    _uid: "e9f0354a-d2d4-457f-a3c0-212b1ede86c0",
    layout: "form",
    component: "page",
    title: "Assessment Information",
    label: "Instructions for Submission",
    simplifiedLabel: "",
    caption:
      "This document must be completed as a declaration of the results of the merchant’s self-assessment against the Payment Card Industry Data Security Standard (PCI DSS) Requirements and Testing Procedures. Complete all sections. The merchant is responsible for ensuring that each section is completed by the relevant parties, as applicable. Contact the entity(ies) to which the Attestation of Compliance (AOC) will be submitted for reporting and submission procedures.",
    simplifiedCaption: "",
    fields: [
      {
        _uid: "d8286d28-f60b-43c2-b392-f969ad4993bb",
        component: "text",
        type: "text",
        label: "Company Name",
        simplifiedLabel: "Company Name",
        maxLength: "120",
      },
      {
        _uid: "5174ec78-8bc2-43d7-ba07-cff93ab2e737",
        component: "text",
        type: "text",
        label: "DBA (doing business as):",
        simplifiedLabel: "DBA (doing business as):",
        maxLength: "120",
      },
      {
        _uid: "4595839c-90fc-4692-84dc-a4597e635b13",
        component: "text",
        type: "text",
        label: "Company mailing address:",
        simplifiedLabel: "Company mailing address:",
        maxLength: "120",
      },
      {
        _uid: "7e6768ef-c046-4d39-82d0-6bdc6af3f79d",
        component: "text",
        type: "text",
        label: "Company main website:",
        simplifiedLabel: "Company main website:",
        maxLength: "120",
      },
      {
        _uid: "0ab0a774-b4c2-43fe-bcfc-77155900ae1c",
        component: "text",
        type: "text",
        label: "Company contact name:",
        simplifiedLabel: "Company contact name:",
        maxLength: "58",
      },
      {
        _uid: "a67c6ac6-d624-4843-bbfb-947dff788695",
        component: "text",
        type: "text",
        label: "Company contact title:",
        simplifiedLabel: "Company contact title:",
        maxLength: "120",
      },
      {
        _uid: "68ef902a-7f26-43c4-b493-ceab3c6d69e2",
        component: "text",
        type: "text",
        label: "Contact phone number:",
        simplifiedLabel: "Contact phone number:",
        maxLength: "120",
      },
      {
        _uid: "248627b6-0c99-402d-9ab8-1118f4fbca46",
        component: "text",
        type: "text",
        label: "Contact e-mail address:",
        simplifiedLabel: "Contact e-mail address:",
        maxLength: "120",
      },
      {
        _uid: "efcc2336-cfb1-4dbf-96c7-7ed83b9b1894",
        component: "label",
        type: "",
        label:
          "Provide the following information for all assessors involved in the assessment. If there was no assessor for a given assessor type, followings are Not Applicable.",
        simplifiedLabel: "",
        maxLength: "120",
      },
      {
        _uid: "7dd93e19-49cb-430c-b1f3-8841a5aba091",
        component: "label",
        type: "",
        label: "PCI SSC Internal Security Assessor(s)",
        simplifiedLabel: "",
        maxLength: "13",
      },
      {
        _uid: "76603005-75e8-4992-b248-da95ddcdbe4b",
        component: "text",
        type: "text",
        label: "ISA name(s):",
        simplifiedLabel: "",
        maxLength: "13",
        col: "12",
      },
      {
        _uid: "c8d8d852-50fd-4440-8082-814073afe5eb",
        component: "label",
        type: "",
        label: "Qualified Security Assessor",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "bfa8f531-460c-4b37-8743-fd09797942b4",
        component: "text",
        type: "text",
        label: "Company name:",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "39ba999d-b41a-4fcb-8312-aa1a05c16d87",
        component: "text",
        type: "text",
        label: "Company mailing address: ",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "e3b3b310-9079-4df9-8767-d152a7e1b6f7",
        component: "text",
        type: "text",
        label: "Company website:",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "862d75b4-2710-42cc-be34-26c82a56d8a6",
        component: "text",
        type: "text",
        label: "Lead Assessor Name:",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "bea46930-82b4-40ac-9d2b-a40254c9c4f4",
        component: "text",
        type: "text",
        label: "Assessor phone number:",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "91e3cf83-2ff3-438f-b828-b4ff656533b3",
        component: "text",
        type: "text",
        label: "Assessor e-mail address: ",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "4bdda341-517c-44a9-ac6e-cecbd8800af6",
        component: "text",
        type: "text",
        label: "Assessor certificate number:",
        simplifiedLabel: "",
        maxLength: "68",
      },
    ],
  },
  // Page 10
  {
    _uid: "a465fe58-b84c-453d-b45a-fe96e6b60f4d",
    layout: "form",
    component: "page",
    title: "",
    label: "",
    simplifiedLabel: "Part 2. Executive Summary",
    caption: "",
    simplifiedCaption: "",
    fields: [
      {
        _uid: "2a1a0ed9-9510-468c-b574-f1d5d6bb6904",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: [
          "Part 2a. Merchant Business Payment Channels (select all that apply):",
          "Indicate all payment channels used by the business that are included in this assessment.",
        ],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "e0119add-86a8-4c41-9c89-edcdef842b86",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Mail order/telephone order (MOTO)",
                value: "Mail order/telephone order (MOTO)",
                col: 4,
              },
              {
                _uid: "3337cc28-09e7-43c5-b42f-1bcf81b2b336",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "E-Commerce",
                value: "E-Commerce",
                col: 4,
              },
              {
                _uid: "e8608b32-69d1-4030-a480-5ed6db79117d",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Card-present",
                value: "Card-present",
                col: 4,
              },
            ],
          },
          {
            fields: [
              {
                _uid: "756ddf69-eb1c-4961-a641-89f2b2cf22d5",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Are any payment channels not included in this assessment?",
                  "If yes, indicate which channel(s) is not included in the assessment and provide a brief explanation about why the channel was excluded.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "70%",
                colSpan: "2",
              },
              {
                _uid: "becc5fbd-536b-4344-a8f2-569560cdcf83",
                component: "col",
                label:
                  "Are any payment channels not included in this assessment? If yes, indicate which channel(s) is not included in the assessment and provide a brief explanation about why the channel was excluded. ",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "30%",
                doNotDisplayLabel: "",
                resetFields: {
                  value: ["no"],
                  _uids: [
                    "d18c2852-aa25-417d-875e-4e4df19e01c3",
                    "f6a6fedd-d5ed-4ad3-9bca-f4db89ace559",
                    "36804892-0122-42c9-a8dc-cfe8252a1fa6",
                    "d7f6d72c-e605-444e-be81-0ca0271b6748",
                    "2f961a8b-4b0c-4566-8952-5f6b7c7fbf9d",
                    "cc5d42b9-2842-4d02-be70-b6083baf0bd8",
                  ],
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f892cf83-57a2-4ca2-9462-677052bd693a",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Note: If the organization has a payment channel that is not covered by this SAQ, consult with the entity(ies) to which this AOC will be submitted about validation for the other channels.",
                  ,
                ],
                boldLabel: "Part 2b. Description of Role with Payment Cards",
                subBoldLabel:
                  "For each payment channel included in this assessment as selected in Part 2a above, describe how the business stores, processes, and/or transmits account data.",
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 3,
                width: "100%",
                conditional: {
                  value: "yes",
                  field:
                    "786da4a1-6f7a-4b4b-9a77-78b81c142841_becc5fbd-536b-4344-a8f2-569560cdcf83",
                },
              },
            ],
          },
        ],
      },
      {
        _uid: "efdd7555-1f29-458b-a1dd-816e87283495",
        component: "table",
        label: "",
        simplifiedLabel: "Part 2b. Description of Role with Payment Cards",
        type: "table",
        caption: "",
        headers: [
          "Channel",
          "How Business Stores, Processes, and/or Transmits Account Data",
        ],
        conditional: {
          value: "yes",
          field:
            "9cd9ade3-19c3-4d87-b053-b9e0b6a48321_becc5fbd-536b-4344-a8f2-569560cdcf83",
        },
        fields: [
          {
            fields: [
              {
                _uid: "d18c2852-aa25-417d-875e-4e4df19e01c3",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "40",
              },
              {
                _uid: "f6a6fedd-d5ed-4ad3-9bca-f4db89ace559",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "60%",
                maxLength: "75",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "36804892-0122-42c9-a8dc-cfe8252a1fa6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "40",
              },
              {
                _uid: "d7f6d72c-e605-444e-be81-0ca0271b6748",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "60%",
                maxLength: "75",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2f961a8b-4b0c-4566-8952-5f6b7c7fbf9d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "40",
              },
              {
                _uid: "cc5d42b9-2842-4d02-be70-b6083baf0bd8",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "60%",
                maxLength: "75",
              },
            ],
          },
        ],
      },
      {
        _uid: "31a9db8f-58ef-4652-98ce-b95eac326dff",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: ["Part 2c. Description of Payment Card Environment"],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "2bde7286-8572-48ce-9ad4-e87e48e35b54",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Provide a high-level description of the environment covered by this assessment.",
                  "For example:",
                  "Connections into and out of the cardholder data environment (CDE).",
                  "Critical system components within the CDE, such as POI devices, databases, web servers, etc., and any other necessary payment components, as applicable.",
                  "System components that could impact the security of account data.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "50%",
              },
              {
                _uid: "65c8932a-c344-4919-bd76-f9040a57ec25",
                component: "col",
                label: "",
                simplifiedLabel: [],
                hasLi: "",
                type: "textarea",
                textareaRows: "8",
                maxLength: 500,
                col: "12",
                width: "50%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2c352136-6c7c-47b7-a88b-13c9381f4982",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Indicate whether the environment includes segmentation to reduce the scope of the assessment.",
                  "(Refer to “Segmentation” section of PCI DSS for guidance on segmentation.)",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "70%",
              },

              {
                _uid: "d64b5973-1566-43e1-9b8f-874b1fde5985",
                component: "col",
                label: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "30%",
                doNotDisplayLabel: "",
              },
            ],
          },
        ],
      },
    ],
  },
  // Page 11
  {
    _uid: "d5869fe8-b683-4af8-8f4d-9e078a6397d7",
    layout: "form",
    component: "page",
    title: "",
    label: "",
    simplifiedLabel: "Part 2. Executive Summary (continued)",
    caption: "",
    simplifiedCaption: [],
    fields: [
      {
        _uid: "c928b6b0-95c5-4f74-97f9-aa4337210a12",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: [],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "e3ad86e1-1c6e-4073-a9f4-da9860600702",
                component: "col",
                label: "",
                simplifiedLabel: "",
                boldLabel: "Part 2d. In-Scope Locations/Facilities",
                subBoldLabel:
                  "List all types of physical locations/facilities (for example, retail locations, corporate offices, data centers, call centers, and mail rooms) in scope for the PCI DSS assessment.",
                hasLi: "yes",
                type: "",
                col: "12",
                width: "100%",
                colSpan: "2",
              },
            ],
          },
        ],
      },
      {
        _uid: "f532f41b-7a47-4164-9665-2d6497998370",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: [],
        headers: [
          "Facility Type",
          [
            "Total number of locations",
            "(How many locations of this type are in scope)",
          ],
          "Location(s) of facility (city, country)",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "f538e4fb-d0ac-4a62-a9f2-528eda4a4e10",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
              {
                _uid: "acf5d0af-3f42-442f-800e-4d6c222b6351",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "9d917ce7-1041-4f79-870f-1b4c39ee603c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4e21fb8b-f941-41a2-baba-728508c9d5e7",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
              {
                _uid: "cc43fff6-bf6d-4fd2-8f27-dd05739eb088",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "8976e226-42f4-4623-873e-253d2e9b813a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7dafe126-42b5-43ad-af9d-f9b1c04292d9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "43",
              },
              {
                _uid: "99d91a88-dc68-4ccd-86b5-f9062f0634cd",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "87469c76-72f0-4c65-a4aa-3ad546651328",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "3fd13af2-ff06-4a89-8065-49d9312289b9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
              {
                _uid: "38480e9b-5ba4-4c37-be48-32033a5f1cce",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "afe658c1-09ca-43bc-a1c6-d9c27d50930a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8a41379e-f356-4293-a495-5feee49f0b73",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
              {
                _uid: "003752c8-ce7b-4082-963b-e822647a915f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "6bbac7ef-44fe-418f-aa3d-033ff84d30f2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e172cf04-218b-4289-b04f-0da438a8df10",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
              {
                _uid: "51a688d4-e852-409b-b521-49ca21d681e6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "14f3a088-0a71-4190-af9c-dddfc05edcd7",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "216d893f-c246-4c7a-a4ba-6bc4bd82a3d2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
              {
                _uid: "a1709a35-c76f-40e5-9163-b022945aef2b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "a38dbab5-d50b-48e7-a952-1aa490b4186e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "be1c6190-cf0d-4811-a1d5-2a0ccac73702",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
              {
                _uid: "57fb74a7-b50f-4792-9291-32d1fb8a80be",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "66f7fe42-0057-4e43-84cc-cf28e2577ab1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
        ],
      },
      {
        _uid: "a89467ec-e1b2-4db7-9910-d0bb46c97936",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: [],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "328cb050-79f9-4945-a06c-50feba6d6f5a",
                component: "col",
                label: "",
                simplifiedLabel: "",
                boldLabel: "Part 2e. PCI SSC Validated Products and Solutions",
                subBoldLabel: "",
                hasLi: "yes",
                type: "",
                col: "12",
                width: "100%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8dc8633d-b76c-46cb-9d7f-945fba5fe4ab",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Does the merchant use any item identified on any PCI SSC Lists of Validated Products and Solutions*?",
                boldLabel: "",
                subBoldLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "80%",
              },
              {
                _uid: "cd991465-68c7-49d9-82ba-2769db9bb9f8",
                component: "col",
                label: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "20%",
                doNotDisplayLabel: "",
                resetFields: {
                  value: ["no"],
                  _uids: [
                    "857d8004-08b2-4aea-b555-d72df62dce09",
                    "af826cd7-9a19-4125-a398-1daca49c93b0",
                    "2825014b-e992-463f-bc4a-9cf9195e509a",
                    "4df9f04a-07f5-4770-9d75-ebd77c0a1896",
                    "6ae39d41-7512-4548-8961-587d4df0197a",
                    "4ea9b5d7-3616-46bf-ac0a-53ae99959724",
                    "2eef5cb4-f928-455d-8cfb-b6f0f36bed53",
                    "f971e7b0-2b1f-40af-a24f-83429fc13077",
                    "82aa6ede-c17b-4d1f-a7e3-bd483c568b14",
                    "ce066dfd-332a-4aed-ba09-1ca15acb0eb2",
                    "0052d931-bdc3-44ec-b63e-43a66b7cd9e2",
                    "ebd07abd-71e3-4d65-9ec7-b0215ce104a0",
                    "bd11db13-964a-4d58-8e5c-fbd3f928d6a9",
                    "e26d57c6-3a3b-4908-ba34-32ce92edbb1a",
                    "c7ed367f-43d0-4ae2-8c1a-c6045c801ee6",
                    "0aa1aeb9-3855-4252-b555-6c0bdb43dcd0",
                    "610d8d7f-5e35-44bf-99b8-2bbc4fa9beb9",
                    "65527b4a-b7f3-4a0c-902b-39a57ac6d2dc",
                    "e3b24f73-2afd-4a73-97bf-55ddf596cf85",
                    "da5394e3-10e8-4508-baa3-81999f827530",
                    "eb96339c-3c4c-4b39-8dbb-46967128fe1f",
                    "e3589b4b-efc8-448e-a5af-5f41bfe45638",
                    "3fe30fc7-1ec7-45b7-824e-de1033c9ab2c",
                    "4041dfdc-cff4-407f-b5f2-2798986d9d7f",
                    "10858523-2cc8-42fe-8c64-b81d620b5602",
                    "9aca9baf-fe5a-4690-910a-bc184d4393b0",
                    "70398dd7-a086-45ac-b91e-72912d800505",
                    "cfbb800e-d27e-4f53-94ee-b07ed951e057",
                    "cb6cdb85-004e-44a6-b15a-1fab33d5ba8d",
                    "d97f3c62-8e0e-4578-b4fc-ff5cf1a78b2b",
                    "8c9550d9-f51b-40dc-b9b1-0baf2710b295",
                    "baedccd9-9b99-4088-9912-cc5d5f7d8db1",
                    "72e92d2c-0158-4ab3-8194-2ab827652d49",
                    "73dc086f-719a-43ad-a5a4-77ae1e702737",
                    "a63a6f8c-62e8-47ef-80ab-797aa7787dfe",
                    "1e5f30f3-db60-41fc-be94-99394652aab5",
                    "1bc8df3e-0a42-407c-9f65-0d74bcb978af",
                    "470582c3-2690-4bdc-9482-c21593e80306",
                    "e15ab8bc-f493-43d3-9bc2-50c736e8ee3a",
                    "d9918a42-a4ad-4c24-a00e-7fab87cd2892",
                    "8413cd02-9a1e-4e99-a021-da94cb98964d",
                    "e1d91b30-35d8-4a4f-b61d-d5da2fe1e31b",
                    "d82e5669-4111-45c0-ac13-2fba7e575e91",
                    "3e0115af-7b42-481f-acee-badb6ed4cee9",
                    "f5674449-542b-4fa6-a2eb-eb465ddf60f9",
                    "da9bd7e1-7756-4680-9791-7f6e96431209",
                    "8cece52a-5580-4f53-b4a5-d4d3cb645e1b",
                    "28ff9b09-8bc3-4ed4-b958-06ef93afed1f",
                    "22f1cffe-98c5-4c82-a1c3-e5b481888280",
                    "72b89f3e-2f02-4e69-925d-b31f19ff38b0",
                  ],
                },
              },
            ],
          },
        ],
      },
      {
        _uid: "025ab84f-6a71-4eb7-8f04-2689074c13ab",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: [],
        headers: [
          "Name of PCI SSC validated Product or Solution",
          "Version of Product or Solution",
          "PCI SSC Standard to which product or solution was validated",
          "PCI SSC listing reference number",
          ["Expiry date of listing", "(YYYY-MM-DD)"],
        ],
        conditional: {
          value: "yes",
          field:
            "51ca7282-7b1f-4a2f-b782-79be8343e7c1_cd991465-68c7-49d9-82ba-2769db9bb9f8",
        },
        fields: [
          {
            fields: [
              {
                _uid: "857d8004-08b2-4aea-b555-d72df62dce09",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "af826cd7-9a19-4125-a398-1daca49c93b0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "2825014b-e992-463f-bc4a-9cf9195e509a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "4df9f04a-07f5-4770-9d75-ebd77c0a1896",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "6ae39d41-7512-4548-8961-587d4df0197a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ce066dfd-332a-4aed-ba09-1ca15acb0eb2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "82aa6ede-c17b-4d1f-a7e3-bd483c568b14",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "f971e7b0-2b1f-40af-a24f-83429fc13077",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "2eef5cb4-f928-455d-8cfb-b6f0f36bed53",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "9e74c805-23ee-4d16-a51f-f6c74cced99d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c7ed367f-43d0-4ae2-8c1a-c6045c801ee6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "e26d57c6-3a3b-4908-ba34-32ce92edbb1a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "bd11db13-964a-4d58-8e5c-fbd3f928d6a9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "ebd07abd-71e3-4d65-9ec7-b0215ce104a0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "0052d931-bdc3-44ec-b63e-43a66b7cd9e2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "da5394e3-10e8-4508-baa3-81999f827530",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "e3b24f73-2afd-4a73-97bf-55ddf596cf85",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "65527b4a-b7f3-4a0c-902b-39a57ac6d2dc",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "610d8d7f-5e35-44bf-99b8-2bbc4fa9beb9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "0aa1aeb9-3855-4252-b555-6c0bdb43dcd0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "10858523-2cc8-42fe-8c64-b81d620b5602",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "4041dfdc-cff4-407f-b5f2-2798986d9d7f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "3fe30fc7-1ec7-45b7-824e-de1033c9ab2c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "e3589b4b-efc8-448e-a5af-5f41bfe45638",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "eb96339c-3c4c-4b39-8dbb-46967128fe1f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d97f3c62-8e0e-4578-b4fc-ff5cf1a78b2b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "cb6cdb85-004e-44a6-b15a-1fab33d5ba8d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "cfbb800e-d27e-4f53-94ee-b07ed951e057",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "70398dd7-a086-45ac-b91e-72912d800505",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "9aca9baf-fe5a-4690-910a-bc184d4393b0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a63a6f8c-62e8-47ef-80ab-797aa7787dfe",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "73dc086f-719a-43ad-a5a4-77ae1e702737",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "72e92d2c-0158-4ab3-8194-2ab827652d49",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "baedccd9-9b99-4088-9912-cc5d5f7d8db1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "8c9550d9-f51b-40dc-b9b1-0baf2710b295",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d9918a42-a4ad-4c24-a00e-7fab87cd2892",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "e15ab8bc-f493-43d3-9bc2-50c736e8ee3a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "470582c3-2690-4bdc-9482-c21593e80306",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "1bc8df3e-0a42-407c-9f65-0d74bcb978af",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "1e5f30f3-db60-41fc-be94-99394652aab5",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f5674449-542b-4fa6-a2eb-eb465ddf60f9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "3e0115af-7b42-481f-acee-badb6ed4cee9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "d82e5669-4111-45c0-ac13-2fba7e575e91",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "e1d91b30-35d8-4a4f-b61d-d5da2fe1e31b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "8413cd02-9a1e-4e99-a021-da94cb98964d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "da9bd7e1-7756-4680-9791-7f6e96431209",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "8cece52a-5580-4f53-b4a5-d4d3cb645e1b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "28ff9b09-8bc3-4ed4-b958-06ef93afed1f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "22f1cffe-98c5-4c82-a1c3-e5b481888280",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "72b89f3e-2f02-4e69-925d-b31f19ff38b0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2db59afe-278f-4b86-bbc4-ac81bfc7e65f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "aba94212-b44a-4db1-a4f7-6fedcee8a088",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "10",
              },
              {
                _uid: "66b7e2f1-acdb-4e88-bba1-16952457391b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "50e7d770-6fdb-4263-bfd3-80221c923409",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "5fde4761-84ea-4bfa-9373-deec9de1e5d9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "10",
              },
            ],
          },
        ],
      },
    ],
  },
  // Page 12
  {
    _uid: "4458e8f7-e370-4374-9236-fedb568d386c",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: ["Part 2. Executive Summary (continued)"],
    caption: "",
    simplifiedCaption: [],
    fields: [
      {
        _uid: "12dd2ae9-c92c-4cbb-a27b-508800ccd13d",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        description: "",
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "64c692c1-9203-42d1-afd0-4f9f92f1c627",
                component: "col",
                label: "",
                simplifiedLabel: "",
                boldLabel: "Part 2f. Third-Party Service Providers",
                subBoldLabel:
                  "Does the merchant have relationships with one or more third-party service providers that:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "100%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "77a713ed-4ff6-452a-b734-da1efd99d5ca",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Store, process, or transmit account data on the merchant’s behalf (for example, payment gateways, payment processors, payment service providers (PSPs), and off-site storage)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "75%",
              },
              {
                _uid: "f6008d00-b75a-4365-ba05-d8bf3ecbc1ef",
                component: "col",
                label: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "25%",
                doNotDisplayLabel: "",
                resetFields: {
                  value: ["no"],
                  _uids: [],
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6db36531-1ce3-4165-b52d-9a2374fb8c42",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Manage system components included in the scope of the merchant’s PCI DSS assessment⎯for example, via network security control services, anti-malware services, security incident and event management (SIEM), contact and call centers, web-hosting services, and IaaS, PaaS, SaaS, and FaaS cloud providers.",
                hasLi: "no",
                type: "",
                col: "12",
                width: "75%",
              },
              {
                _uid: "81f787dd-10d8-46b1-a23a-ee14b6023f9d",
                component: "col",
                label: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "25%",
                doNotDisplayLabel: "",
                resetFields: {
                  value: ["no"],
                  _uids: [],
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "23c7a84b-4643-4273-b554-3f91d30b3e77",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Could impact the security of the merchant’s CDE (for example, vendors providing support via remote access, and/or bespoke software developers)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "80%",
              },
              {
                _uid: "8f9739c3-7fc5-4f0c-b332-f162c9d7aed1",
                component: "col",
                label: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "25%",
                doNotDisplayLabel: "",
                resetFields: {
                  value: ["no"],
                  _uids: [],
                },
              },
            ],
          },
        ],
      },
      {
        _uid: "078a098c-1de1-42b0-a949-53901fb446b1",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        description: "",
        headers: "",
        marginBottom: 0,
        fields: [
          {
            fields: [
              {
                _uid: "",
                component: "col",
                label: "",
                simplifiedLabel: "",
                boldLabel: "If Yes:",
                subBoldLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "100%",
                colSpan: "2",
              },
            ],
          },
        ],
      },
      {
        _uid: "2f338460-a095-4ffb-b4a8-22a3d9fb5893",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        description: "",
        headers: [
          "Name of service provider:",
          "Description of service(s) provided:",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "f35caf1e-3a60-4746-9ef5-d007213511dc",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "45",
              },
              {
                _uid: "28bfc7d7-e540-4e88-95a2-547518438ba6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "65",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "84b9c58d-9986-4eb0-bc08-7f8cf0c0e524",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "45",
              },
              {
                _uid: "fbd53ce8-3f9e-46b0-aabe-79323c139bfb",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "65",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "fd603daf-0b36-4383-aeeb-f58e5692e985",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "45",
              },
              {
                _uid: "399fb414-c456-4931-8808-33c05cfab7bc",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "65",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "eb0bc36b-82dc-40fa-b7aa-7ff5e0af4cfb",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "45",
              },
              {
                _uid: "0101ea03-da19-4f76-a45b-857dfb4ee9f4",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "65",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1970ac65-2a00-4f3c-b8d2-5c21077d1719",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "45",
              },
              {
                _uid: "42aeb606-9f62-40f7-99b3-a1f6b12a4b5a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "65",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d23c6de6-160a-40e4-b881-e498e2d51259",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "45",
              },
              {
                _uid: "64a6951d-2d21-42ab-9f79-cd0f3366382e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "65",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "fe9f7390-8933-4d12-8a05-df59c6cdf31e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "45",
              },
              {
                _uid: "ef7743a3-aa47-45c9-949d-685025e9f75c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "65",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8c646ef1-b638-4136-970d-7871d2eeffa0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "45",
              },
              {
                _uid: "135d1557-8797-43f0-a0c8-efc873846530",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "65",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "878df552-46e2-4fdd-ae6e-b21c32d017ab",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "45",
              },
              {
                _uid: "9bdaab35-c22e-430a-a756-84d69d7f084a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "65",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b84a619d-150f-45a6-be23-0080e3572762",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "45",
              },
              {
                _uid: "9f4dfcce-65a5-4cc6-9508-225e668ea9da",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "65",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "07b21b02-0f67-4a37-acba-d860060e9b21",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Note: Requirement 12.8 applies to all entities in this list.",
                placeholder: "",
                type: "",
                textareaRows: "2",
                col: "12",
                width: "100%",
                maxLength: "320",
                colSpan: "2",
              },
            ],
          },
        ],
      },
    ],
  },
  // 13
  {
    _uid: "1979dffb-311b-4c6b-a5bd-728b94f3a09a",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: ["Part 2. Executive Summary (continued)"],
    caption: "",
    simplifiedCaption: [],
    fields: [
      {
        _uid: "7ffdc48b-43c6-4c98-b0be-708567a854d1",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "ccc08788-a53e-4573-b624-b94ea78b2736",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Part 2g. Summary of Assessment",
                  "(SAQ Section 2 and related appendices)",
                  "Indicate below all responses that were selected for each PCI DSS requirement.",
                ],
                boldLabel: "",
                subBoldLabel: "",
                type: "",
                width: "100%",
                col: "12",
              },
            ],
          },
        ],
      },
      {
        _uid: "28b86930-17c4-4d25-ab53-d3fccacec03d",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        headers: ["PCI DSS Requirement *", "", "", "Requirement Responses", ""],
        fields: [
          {
            fields: [
              {
                _uid: "4a042793-9fa8-40e4-a886-910b49be7f64",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "894c0e11-bdec-4d35-9c08-053a4e0892c5",
                component: "col",
                label: "",
                simplifiedLabel: "In Place",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "2a5ef996-9789-4d82-9a7a-85b6ceea4edf",
                component: "col",
                label: "",
                simplifiedLabel: "In Place with CCW",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "dd4bf0c5-bcc7-4fa5-8ffa-916c69770fd5",
                component: "col",
                label: "",
                simplifiedLabel: "Not Applicable",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "35d88a10-345f-4474-9c5a-d36b8f4164a0",
                component: "col",
                label: "",
                simplifiedLabel: "Not in Place",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "51d357ee-4d64-4701-971e-b0bcd5bff181",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 1:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6a2e1eb7-0335-40eb-9e70-c57038e41aeb",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_1_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "30283186-8784-45bf-b8a1-f1a3287a5c23",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_1_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "58a2ee47-768f-4c63-a131-fd126a5c125f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_1_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "d4807ba0-29ce-490a-8aec-f17fb1d85595",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_1_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "be7e92ae-e202-4df9-8340-8c8e38738fdd",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 2:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "83483870-440a-4692-87c0-bd4b452cc5e6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_2_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3f957dfe-807a-44ea-9d07-5341d0c04327",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_2_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "99b311d0-504d-4835-a4e6-d918a461561c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_2_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3320a5b6-414d-4d2d-8cf2-38a54f01a264",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_2_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a89de058-db5e-4a7d-907f-340c6cc5b873",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 3:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "d74498b3-96f3-4ea3-9bd2-8a054d8fc876",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_3_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "2b03a47c-d91f-4853-92f9-5e7e80fcc6d0",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_3_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e94cee9b-0a6f-4677-ae95-4f69775b638d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_3_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "f763fa5e-8e3e-4058-9a34-088057f216dd",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_3_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7a3a33b7-8928-4d72-bd5d-bf22e96eb715",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 4:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "dc2f913b-9138-4add-b5da-3c5492b86527",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_4_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "55b4351d-3e10-4770-bf24-e9e076ced7af",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_4_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "a9a188ae-5ff3-4b48-80aa-6494150b0a10",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_4_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e61db5c5-bdaf-4064-844e-c231ca0bad07",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_4_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a30443b1-95c9-4769-aae3-0a816c102b5e",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 5:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c4cc5916-8e94-47b4-a07a-8a4e49ae5a80",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_5_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "f4b84bf1-344c-4e17-82f2-e94faf1b50d9",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_5_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "43a7e864-dc18-433c-b328-a6d367d66089",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_5_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "8252e2f6-96ed-45b8-be11-c5973253ce14",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_5_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b4d424b9-913d-4c37-a468-8b7f57d705d1",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 6:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "a19bb29e-d722-4863-90d0-3c486cb85118",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_6_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "68e7f630-a0b1-491c-89a2-f6115f3e3316",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_6_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "859de499-676f-4ddd-84ff-bbd282d3d616",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_6_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "07299892-5bf3-480d-888f-8cdb4f097f7e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_6_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "871e1bac-9b07-402b-acff-e5830369b8bf",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 7:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "5004e877-881d-48dd-a07a-bbdf08734692",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_7_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ec5fe712-203f-47c0-92fc-f03c3aa702e4",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_7_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ae0dbf9f-b780-490f-9b82-ec3e70e7786f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_7_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "4c9f1905-43ee-4b19-b37d-ddb00553c2e9",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_7_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8e249f70-e94c-4fea-a0d8-2ef0f4e3a168",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 8:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6785db61-e5fa-4ee6-a999-0b77dd7c2492",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_8_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "7b7a9017-5ad1-4e63-b999-9f32b48a8e54",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_8_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "cee30fd0-06b2-4e5e-9df5-27eb3ded7f74",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_8_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c47fbe40-d723-41ff-a616-2dd335369c08",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_8_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "afc55d56-558c-4972-999c-647b52b319c0",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 9:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "112fdc6c-d2ba-4884-be04-8ffd5eccafb5",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_9_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c0700179-ddd9-413c-a9f0-9bdc04b00108",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_9_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3d1bdb4f-532a-4b89-94ed-1af2c997b866",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_9_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "bffb79f6-dbb8-4f1b-8ac5-0f2bb32d5210",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_9_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b1c2e826-1f53-4085-b667-73641e15621a",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 10:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "f8e36543-61f1-4766-906c-d395210b15ff",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_10_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "994e3f62-4bc4-4928-a24c-e6ef705e55ce",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_10_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "257fe755-9846-48bb-b31c-6fd2948ad229",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_10_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c152ecc3-6a36-4001-ab17-25237af736fb",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_10_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a1c4e1fa-d2ef-4eec-aa61-93d01419b8b5",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 11:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "d985904e-543b-46c5-abf3-496c389a0c67",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_11_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6ea5fa98-f6cd-4e59-9758-91fc6d703c82",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_11_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "526b27a9-f398-4940-96e2-37afe1393309",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_11_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "eeee435a-0da8-4611-af63-6cc6367af20b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_11_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "56c7306a-4cbb-46ab-8f21-c84926a5ffff",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 12:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "fca7f4a9-f065-4f18-a367-130e62dc1e04",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_12_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "fb698b06-b4a8-4614-bc58-8357e5c2dad6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_12_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e863bdc1-4d51-449e-ba9b-f8cfa68f7b07",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_12_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "20e88de4-ff63-491d-9422-d1db9a480d77",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_12_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "73efe58a-f8df-40e1-8de4-4168f9405396",
                component: "col",
                label: "",
                simplifiedLabel: "Appendix A2:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "adfcf7ba-09f7-40ae-b59b-eb134c0003b6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "appendix_a2_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "bd001013-355a-4571-a888-d16a377e77d3",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "appendix_a2_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ba36db02-2f73-41ed-a131-000de0bf3e03",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "appendix_a2_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "207972eb-b828-47af-bf7d-a9a07a51666a",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "appendix_a2_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
        ],
      },
    ],
  },
  // 14
  {
    _uid: "d4743fff-6b3c-430b-80df-928c513df125",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: ["Part 2. Executive Summary (continued)"],
    caption: "",
    simplifiedCaption: [],
    fields: [
      {
        _uid: "205acfb3-c1d6-490e-9228-4cf5a6345fb4",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        description: "",
        fields: [
          {
            fields: [
              {
                _uid: "48174c70-534d-4286-97a4-09fe65326e98",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Part 2h. Eligibility to Complete SAQ C",
                  "Merchant certifies eligibility to complete this Self-Assessment Questionnaire because, for this payment channel:",
                ],
                boldLabel: "",
                subBoldLabel: "",
                type: "",
                width: "100%",
                col: "12",
                colSpan: 2,
              },
            ],
          },
          {
            fields: [
              {
                _uid: "af4d9fc5-487a-4a63-ab8a-3d9c0a21c180",
                component: "col",
                label: "",
                simplifiedLabel: "",
                boldLabel: "",
                subBoldLabel: "",
                type: "",
                width: "100%",
                col: "12",
                colSpan: 2,
              },
            ],
          },
          {
            fields: [
              {
                _uid: "24dd15f3-a29c-4234-bcff-6ff3a1dbff59",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "10%",
                col: "12",
              },
              {
                _uid: "a6b34cdb-23f7-4200-9c33-82e74843690b",
                component: "col",
                label: "",
                simplifiedLabel:
                  "The merchant has a payment application system and an Internet connection on the same device and/or same local area network (LAN).",
                boldLabel: "",
                subBoldLabel: "",
                type: "",
                width: "90%",
                col: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "81f1895d-249d-41d6-9deb-0453906ec813",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "10%",
                col: "12",
              },
              {
                _uid: "51da8a41-09b8-402d-8148-d3eb658fbc04",
                component: "col",
                label: "",
                simplifiedLabel:
                  "The payment application system is not connected to any other system within the merchant environment.",
                boldLabel: "",
                subBoldLabel: "",
                type: "",
                width: "90%",
                col: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a734c4c6-1bb3-4787-9da1-3e517e83dbd6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "10%",
                col: "12",
              },
              {
                _uid: "a734c4c6-1bb3-4787-9da1-3e517e83dbd6",
                component: "col",
                label: "",
                simplifiedLabel:
                  "The physical location of the POS environment is not connected to other premises or locations, and any LAN is for a single location only.",
                boldLabel: "",
                subBoldLabel: "",
                type: "",
                width: "90%",
                col: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e57c3fdb-e7a0-4f89-948e-fc14ea95b5f1",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "10%",
                col: "12",
              },
              {
                _uid: "ead03aa9-64d9-4691-8d7c-f8fd02f433d1",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Merchant does not store account data in electronic format.",
                boldLabel: "",
                subBoldLabel: "",
                type: "",
                width: "90%",
                col: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f7d69f00-ab9c-4602-a526-9caf06c009a6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "10%",
                col: "12",
              },
              {
                _uid: "24897c64-579a-4dfa-a74a-2c1bf87f5336",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Any account data the merchant might retain is on paper (for example, printed reports or receipts), and these documents are not received electronically.",
                boldLabel: "",
                subBoldLabel: "",
                type: "",
                width: "90%",
                col: "12",
              },
            ],
          },
        ],
      },
    ],
  },
  // page 15 - 70
  {
    _uid: "f239cdfc-6976-4ab0-8155-9e0af1f9e8e7",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: "Section 2: Self-Assessment Questionnaire C",
    caption: "",
    simplifiedCaption: [
      "Note: The following requirements mirror the requirements in the PCI DSS Requirements and Testing Procedures document.",
    ],
    fields: [
      {
        _uid: "e5988b84-e67e-46f2-a1bd-7dd082524f62",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        headers: [
          "",
          "PCI DSS Requirement",
          "Expected Testing",
          "Response (Check one response for each question)",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "3b5ca71f-e339-4c63-9426-3973a292a5d3",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "65%",
                colSpan: 3,
              },
              {
                _uid: "c05aa970-2112-450b-bdad-d542eaa88dd6",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "select",
                options: [
                  {
                    value: "in_place",
                    label: "In Place",
                  },
                  {
                    value: "in_place_with_CCW",
                    label: "In Place with CCW",
                  },
                  {
                    value: "na",
                    label: "Not Applicable",
                  },
                  {
                    value: "not_in_place",
                    label: "Not in Place",
                  },
                ],
                col: "12",
                width: "35%",
                colSpan: 2,
              },
            ],
          },
          // 15
          {
            fields: [
              {
                _uid: "2e7ad09e-e0f9-4133-98e5-80f08fc1cf98",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Build and Maintain a Secure Network and Systems",
                  "Requirement 1: Install and maintain network security controls",
                  "1.3 Network access to and from the cardholder data environment is restricted.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1e7e8818-1f0b-4317-85b4-9b755e518588",
                component: "col",
                label: "",
                simplifiedLabel: "1.3.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "e2143499-aabc-46f8-a49f-78d80d33977a",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Inbound traffic to the CDE is restricted as follows:",
                  "To only traffic that is necessary.",
                  "All other traffic is specifically denied.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "57d8db79-5520-473d-888e-5d673652002e",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine NSC configuration standards.",
                  "Examine NSC configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "4678fed8-63e6-4034-9ddf-8328ee39723d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["42623776-9ad9-4eab-89a1-49319a289ec5"],
                },
              },
              {
                _uid: "42623776-9ad9-4eab-89a1-49319a289ec5",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "f1135384-47f5-4898-b4d5-295ce91b0b33_4678fed8-63e6-4034-9ddf-8328ee39723d",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c9ae6797-c1d6-4ca1-b713-812da006216d",
                component: "col",
                label: "",
                simplifiedLabel: "1.3.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "bad106e7-f8d0-4fe1-8bdc-c2918567dc71",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Outbound traffic from the CDE is restricted as follows:",
                  "To only traffic that is necessary.",
                  "All other traffic is specifically denied.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3b52bdd2-0145-4bbc-8d0c-54a2911a159f",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine NSC configuration standards.",
                  "Examine NSC configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "1c53e5dd-477e-41a4-bc53-faaa0766eda2",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["42e91e2f-4736-433e-ac29-8561d3656164"],
                },
              },
              {
                _uid: "42e91e2f-4736-433e-ac29-8561d3656164",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "a4064168-9828-4d4c-9b85-904a940c1d90_1c53e5dd-477e-41a4-bc53-faaa0766eda2",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "27d19e7c-51cf-47bb-b8a3-bd335c8cce2a",
                component: "col",
                label: "",
                simplifiedLabel: "1.3.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "ab6d4ce5-55a8-4dcc-8816-9029b0691e7d",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "NSCs are installed between all wireless networks and the CDE, regardless of whether the wireless network is a CDE, such that:",
                  "All wireless traffic from wireless networks into the CDE is denied by default.",
                  "Only wireless traffic with an authorized business purpose is allowed into the CDE.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "310a3da8-d22b-40b1-bdb9-71980d84b3a3",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine configuration settings.",
                  "Examine network diagrams.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "699249cb-f9c4-4740-9ad4-bfcbcff91201",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["ba651261-2902-4de1-bf06-8ccbc0efdcb3"],
                },
              },
              {
                _uid: "ba651261-2902-4de1-bf06-8ccbc0efdcb3",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "f72de983-6086-46e7-9bad-447290a1b7bd_699249cb-f9c4-4740-9ad4-bfcbcff91201",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 16
          {
            fields: [
              {
                _uid: "2aa579d2-aaeb-461b-82a0-023d781e77af",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Requirement 2: Apply Secure Configurations to All System Components",
                  "Note: For SAQ A-EP, Requirement 2 applies to configurations and accounts on webservers and supporting systems that could impact the security of the webserver.",
                  "2.1 Processes and mechanisms for applying secure configurations to all system components are defined and understood.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "eab987e2-7430-4763-9507-32996082bce51",
                component: "col",
                label: "",
                simplifiedLabel: "2.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "adc72997-386f-4e05-a632-fc6f30118033",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "All security policies and operational procedures that are identified in Requirement 2 are:",
                  "Documented.",
                  "Kept up to date.",
                  "In use.",
                  "Known to all affected parties.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "6936f7ff-7df0-4a3e-b148-2484db0574ad",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documentation.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ddfb1986-af32-4a94-a729-b0573b86c7ae",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["d0d26f26-8b98-4ed6-9250-72026a7be1d2"],
                },
              },
              {
                _uid: "d0d26f26-8b98-4ed6-9250-72026a7be1d2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "3cfb22f0-d832-4bc3-bafb-67579f7bb29a_ddfb1986-af32-4a94-a729-b0573b86c7ae",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "63f66c03-d8af-4780-a228-45c6342c646c",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "2.2 System components are configured and managed securely.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "45d1f3cc-5809-4404-9399-a2b949a18a5e",
                component: "col",
                label: "",
                simplifiedLabel: "2.2.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "a19d0232-e18b-42ea-93f8-729a6d4a29b4",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Configuration standards are developed, implemented, and maintained to:",
                  "Cover all system components.",
                  "Address all known security vulnerabilities.",
                  "Be consistent with industry-accepted system hardening standards or vendor hardening recommendations.",
                  "Be updated as new vulnerability issues are identified, as defined in Requirement 6.3.1.",
                  "Be applied when new systems are configured and verified as in place before or immediately after a system component is connected to a production environment.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "0e3ae496-da4f-4d44-a374-d39b2518b52a",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine system configuration standards.",
                  "Review industry-accepted hardening standards.",
                  "Examine configuration settings.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "2b45c9c6-41fe-44cc-aa62-ef9bb8067781",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["a05bcca3-e235-4668-9c96-172ccf56b36c"],
                },
              },
              {
                _uid: "a05bcca3-e235-4668-9c96-172ccf56b36c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "20794f12-1818-424f-9b76-105b7dfed068_2b45c9c6-41fe-44cc-aa62-ef9bb8067781",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 17
          {
            fields: [
              {
                _uid: "b0a7d632-4606-4f25-8f56-e43beaf0e32d",
                component: "col",
                label: "",
                simplifiedLabel: "2.2.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "3536f837-4c81-4c84-b27d-559cca72ba50",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Vendor default accounts are managed as follows:",
                  "If the vendor default account(s) will be used, the default password is changed per Requirement 8.3.6.",
                  "If the vendor default account(s) will not be used, the account is removed or disabled.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "55a03abf-69ac-4813-8b22-4817d8b31dd3",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine system configuration standards.",
                  "Examine vendor documentation.",
                  "Observe a system administrator logging on using vendor default accounts.",
                  "Examine configuration files.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "2ced54de-5b80-4f48-8f4b-4e4e72861154",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["25d7650f-ccf2-4af6-9a73-18a1f2974d35"],
                },
              },
              {
                _uid: "25d7650f-ccf2-4af6-9a73-18a1f2974d35",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "4605b800-5271-44a2-a442-a97b6ef71fd7_2ced54de-5b80-4f48-8f4b-4e4e72861154",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2dc183d4-76b0-41b9-8e3e-bdd6072cd776",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This applies to ALL vendor default accounts and passwords, including, but not limited to, those used by operating systems, software that provides security services, application and system accounts, point-of-sale (POS) terminals, payment applications, and Simple Network Management Protocol (SNMP) defaults.",
                  "This requirement also applies where a system component is not installed within an entity’s environment, for example, software and applications that are part of the CDE and are accessed via a cloud subscription service.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ef2e78e2-3f29-40f9-ba2e-6c473866fcac",
                component: "col",
                label: "",
                simplifiedLabel: "2.2.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "25a11d0c-2552-44e9-9e91-425b4f5358a0",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Primary functions requiring different security levels are managed as follows:",
                  "Only one primary function exists on a system component,",
                  "OR",
                  "Primary functions with differing security levels that exist on the same system component are isolated from each other,",
                  "OR",
                  "Primary functions with differing security levels on the same system component are all secured to the level required by the function with the highest security need.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "aec4076a-935d-4692-8f36-5f968e9c5293",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine system configuration standards.",
                  "Examine system configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "640e46ca-d2d5-4a17-9555-390ef9cdbe49",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["7499eff9-c2d2-45da-8342-d24fdeb5fc79"],
                },
              },
              {
                _uid: "7499eff9-c2d2-45da-8342-d24fdeb5fc79",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "3c0377d1-ac4e-4af9-816d-304c975b8ce5_640e46ca-d2d5-4a17-9555-390ef9cdbe49",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6d244fda-cc37-4593-8fea-b7c52986a223",
                component: "col",
                label: "",
                simplifiedLabel: "2.2.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "79d7e467-c59e-47b5-8a6a-e4f8e628a29a",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Only necessary services, protocols, daemons, and functions are enabled, and all unnecessary functionality is removed or disabled.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "580193c4-9844-4335-84ac-938f0c0afd0d",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine system configuration standards.",
                  "Examine system configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "e43637ef-202c-42f9-b11d-bbfb35f7b064",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["ab03c23a-9342-485e-8d65-aad4c24f6521"],
                },
              },
              {
                _uid: "ab03c23a-9342-485e-8d65-aad4c24f6521",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "7ef36047-331c-485f-b2f7-4c09eeda97b8_e43637ef-202c-42f9-b11d-bbfb35f7b064",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 18
          {
            fields: [
              {
                _uid: "c0ecfc55-083b-44d6-ac9c-871fdd5cda02",
                component: "col",
                label: "",
                simplifiedLabel: "2.2.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "45941c24-84ec-46f8-ad3c-64302034d718",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "If any insecure services, protocols, or daemons are present:",
                  "Business justification is documented.",
                  "Additional security features are documented and implemented that reduce the risk of using insecure services, protocols, or daemons.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "9a323138-24ff-4d15-a580-aac47173faff",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine configuration standards.",
                  "Interview personnel.",
                  "Examine configuration settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "101bec8b-e69c-4d83-850f-26ab9c73e428",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["d2c8cfb4-89cb-4337-b1b2-3636e5aeff6f"],
                },
              },
              {
                _uid: "d2c8cfb4-89cb-4337-b1b2-3636e5aeff6f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "8a194216-2198-4d7f-970f-a6ee5ae0f7d9_101bec8b-e69c-4d83-850f-26ab9c73e428",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ce60c4bf-fa90-4126-a896-42a4670e5b36",
                component: "col",
                label: "",
                simplifiedLabel: "2.2.6",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "da621350-5326-494c-9506-207ed736c969",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "System security parameters are configured to prevent misuse.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "7849bce4-e2dc-4ffb-8dc1-49f1cef79a8c",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine system configuration standards.",
                  "Interview personnel.",
                  "Examine system configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "dee26b3c-b40b-4049-a59f-ee4fa8ce96d0",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["cd9de4f9-19ab-4aca-ac9c-d4e9202c2f7d"],
                },
              },
              {
                _uid: "cd9de4f9-19ab-4aca-ac9c-d4e9202c2f7d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "f437381f-f243-4e59-8a98-4a68b50f67a3_dee26b3c-b40b-4049-a59f-ee4fa8ce96d0",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c01ecfc5-fb52-421c-8bd5-feea742a213a",
                component: "col",
                label: "",
                simplifiedLabel: "2.2.7",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "97b96f6a-9560-4879-a6ac-21667a986af1",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "All non-console administrative access is encrypted using strong cryptography.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e25f9990-8d12-4a0a-975c-64ea43df5cf5",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine system configuration standards.",
                  "Observe an administrator log on.",
                  "Examine system configurations.",
                  "Examine vendor documentation.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "cba3a8cd-1c4b-4c82-a3b0-cab2693b025a",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["6a23a131-b26b-456b-a27f-d4218c43f351"],
                },
              },
              {
                _uid: "6a23a131-b26b-456b-a27f-d4218c43f351",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "2dc578c7-be16-4ed7-8bf6-4110a19667b5_cba3a8cd-1c4b-4c82-a3b0-cab2693b025a",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "263d4c02-981e-4525-a645-7f738044cbc0",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This includes administrative access via browser-based interfaces and application programming interfaces (APIs).",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 19
          {
            fields: [
              {
                _uid: "0833530b-ac5d-4062-94dd-a798fc4e998b",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "2.3 Wireless environments are configured and managed securely.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5ca622cb-0a9b-480c-a3ee-ac0ecb530f58",
                component: "col",
                label: "",
                simplifiedLabel: "2.3.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "1bfee4f6-2610-4b72-ba05-5038bbe94222",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "For wireless environments connected to the CDE or transmitting account data, all wireless vendor defaults are changed at installation or are confirmed to be secure, including but not limited to:",
                  "Default wireless encryption keys.",
                  "Passwords on wireless access points.",
                  "SNMP defaults.",
                  "Any other security-related wireless vendor defaults.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "39b3b912-7bfb-4210-b7b4-3abda74e1883",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Review vendor documentation.",
                  "Examine wireless configuration settings.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "1a1bfa4b-5f0a-4534-bb00-13abb8f62b93",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["5ced3def-eaf1-4bec-bc35-a844dc093bf2"],
                },
              },
              {
                _uid: "5ced3def-eaf1-4bec-bc35-a844dc093bf2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "4209ba0e-60b0-4b32-a5d1-ef6de2c30f48_1a1bfa4b-5f0a-4534-bb00-13abb8f62b93",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f4905d02-f145-4539-bc57-653fea50e093",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This includes, but is not limited to, default wireless encryption keys, passwords on wireless access points, SNMP defaults, and any other security-related wireless vendor defaults.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "465fbc77-08f3-4980-b434-ddc2382af3f6",
                component: "col",
                label: "",
                simplifiedLabel: "2.3.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "adc8a4bb-6dce-40c2-8397-b0deb23db50e",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "For wireless environments connected to the CDE or transmitting account data, wireless encryption keys are changed as follows:",
                  "Whenever personnel with knowledge of the key leave the company or the role for which the knowledge was necessary.",
                  "Whenever a key is suspected of or known to be compromised.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "83518355-32a5-4194-83b4-11d609c922cf",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine key-management documentation.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "8a7c019a-5b68-48c9-975f-7d2299ca9254",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["40b09f2e-79fe-418b-b037-7331c2614d7a"],
                },
              },
              {
                _uid: "40b09f2e-79fe-418b-b037-7331c2614d7a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "aab11913-e6c3-40fd-a021-474372586f62_8a7c019a-5b68-48c9-975f-7d2299ca9254",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 20
          {
            fields: [
              {
                _uid: "13a7b01d-93d4-4e63-a658-75711d55cb20",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Protect Account Data",
                  "Requirement 3: Protect Stored Account Data",
                  "Note: For SAQ A-EP, Requirement 3 applies only to merchants with paper records that include account data (for example, receipts or printed reports)",
                  "3.1 Processes and mechanisms for protecting stored account data are defined and understood.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "aa8978a1-43d0-4ae6-b1e0-bf3958f39568",
                component: "col",
                label: "",
                simplifiedLabel: "3.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "38aaf92a-fbc8-492c-a298-6ca4499deebf",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "All security policies and operational procedures that are identified in Requirement 3 are:",
                  "Documented",
                  "Kept up to date.",
                  "In use.",
                  "Known to all affected parties.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "506bae8e-f2c2-42ae-b9a5-06bb2764dc7d",
                component: "col",
                label: [],
                simplifiedLabel: [
                  " Examine documentation.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "e23446ac-19c4-400a-b0c2-4db5aabf4883",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["ad89e3b1-280a-49e7-8cb1-2236289caa4e"],
                },
              },
              {
                _uid: "ad89e3b1-280a-49e7-8cb1-2236289caa4e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "4b6f145b-92ab-42d2-b2b9-e15b6a7d8080_e23446ac-19c4-400a-b0c2-4db5aabf4883",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "75d01791-ac6c-4c84-904f-68f3df0ddcdc",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for Requirement 3.1.1 means that, if the merchant has paper storage of account data, the merchant has policies and procedures in place that govern merchant activities for Requirement 3. This helps to ensure personnel are aware of and following security policies and documented operational procedures for managing the secure storage of any paper records with account data.",
                  "If merchant does not store paper records with account data, mark this requirement as Not Applicable and complete Appendix C: Explanation of Requirements Noted as Not Applicable.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 21
          {
            fields: [
              {
                _uid: "c0218266-0d5d-4875-ba35-9f4737b40444",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "3.3 Sensitive authentication data (SAD) is not stored after authorization.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b95618f5-8064-4294-a9c3-91c722a82998",
                component: "col",
                label: "",
                simplifiedLabel: "3.3.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "5ec314eb-4a33-4b66-ab00-c4277f258484",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "SAD is not retained after authorization, even if encrypted. All sensitive authentication data received is rendered unrecoverable upon completion of the authorization process.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "a0d0e0b6-bac0-420c-b795-ec3349de31aa",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented policies and procedures.",
                  "Examine system configurations.",
                  "Observe the secure data deletion processes.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "884a2baa-c99e-4314-9197-34b8f13fb120",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["8c3072bf-c752-4177-aaa7-9a34540061e1"],
                },
              },
              {
                _uid: "8c3072bf-c752-4177-aaa7-9a34540061e1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "afc61f16-89ea-4657-b119-b54401f85372_884a2baa-c99e-4314-9197-34b8f13fb120",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "bf50620b-2158-422b-a566-44b4fa168a8d",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "Part of this Applicability Note was intentionally removed for this SAQ as it does not apply to merchant assessments.",
                  "Sensitive authentication data includes the data cited in Requirements 3.3.1.2 through 3.3.1.3.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f1a444bc-db9c-42fe-b7d6-1275cab35b34",
                component: "col",
                label: "",
                simplifiedLabel: "3.3.1.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "13d76fcd-09cd-4482-b52d-a6cb8746dcaa",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "The card verification code is not retained upon completion of the authorization process.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "d39df6bb-412f-4612-a2e4-c2e4674c2618",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine data sources."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "bbcb5406-b3b0-44f2-bc67-f05e64ba8080",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["6c9ab849-3896-4df7-b259-8df68143f010"],
                },
              },
              {
                _uid: "6c9ab849-3896-4df7-b259-8df68143f010",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "2caffed6-23f8-4ebc-86c1-a0b557d25656_bbcb5406-b3b0-44f2-bc67-f05e64ba8080",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a2452436-c68a-48bd-b754-b850dc350828",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "The card verification code is the three- or four-digit number printed on the front or back of a payment card used to verify card-not-present transactions.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a9fb669f-0e0f-4b15-a04c-83c039fbe25b",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for Requirement 3.3.1.2 means that if the merchant writes down the card verification code while a transaction is being conducted, the merchant either securely destroys the paper (for example, with a shredder) immediately after the transaction is complete, or obscures the code (for example, by “blacking it out” with a marker) before the paper is stored.",
                  "If the merchant never requests the three-digit or four-digit number printed on the front or back of a payment card (“card verification code”), mark this requirement as Not Applicable and complete Appendix C: Explanation of Requirements Noted as Not Applicable.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f1a444bc-db9c-42fe-b7d6-1275cab35b34",
                component: "col",
                label: "",
                simplifiedLabel: "3.3.1.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "13d76fcd-09cd-4482-b52d-a6cb8746dcaa",
                component: "col",
                label: [],
                simplifiedLabel: [
                  " The personal identification number (PIN) and the PIN block are not retained upon completion of the authorization process.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "d39df6bb-412f-4612-a2e4-c2e4674c2618",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine data sources."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "4433a0e5-0224-44b7-8285-18dcf1eeebe0",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["6c9ab849-3896-4df7-b259-8df68143f010"],
                },
              },
              {
                _uid: "6c9ab849-3896-4df7-b259-8df68143f010",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "2caffed6-23f8-4ebc-86c1-a0b557d25656_4433a0e5-0224-44b7-8285-18dcf1eeebe0",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a2452436-c68a-48bd-b754-b850dc350828",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "PIN blocks are encrypted during the natural course of transaction processes, but even if an entity encrypts the PIN block again, it is still not allowed to be stored after the completion of the authorization process.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 22
          {
            fields: [
              {
                _uid: "6ba0fee2-3d80-428f-8578-ccd82c6d8168",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "3.4 Access to displays of full PAN and ability to copy PAN is restricted.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0fa700d1-c198-4b67-b054-88bd4d4aa779",
                component: "col",
                label: "",
                simplifiedLabel: "3.4.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "0559907f-b0b1-4222-8fc9-0028a7e653e9",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "PAN is masked when displayed (the BIN and last four digits are the maximum number of digits to be displayed), such that only personnel with a legitimate business need can see more than the BIN and last four digits of the PAN.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "03353e62-83f8-4885-af49-398db189ce97",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented policies and procedures.",
                  "Examine system configurations.",
                  "Examine the documented list of roles that need access to more than the BIN and last four digits of the PAN (includes full PAN).",
                  "Examine displays of PAN (for example, on screen, on paper receipts).",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "7897dd44-388e-4287-969a-c59e20b21924",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["ec90c4e1-dda6-4272-8b4f-9afdc01040de"],
                },
              },
              {
                _uid: "ec90c4e1-dda6-4272-8b4f-9afdc01040de",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "a6a88dbc-5655-4f85-88fa-47c1f1575dc3_7897dd44-388e-4287-969a-c59e20b21924",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "192e6093-78aa-453b-ad54-6bdf95d02991",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement does not supersede stricter requirements in place for displays of cardholder data—for example, legal or payment brand requirements for point-of-sale (POS) receipts.",
                  "This requirement relates to protection of PAN where it is displayed on screens, paper receipts, printouts, etc., and is not to be confused with Requirement 3.5.1 for protection of PAN when stored, processed, or transmitted.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 23
          {
            fields: [
              {
                _uid: "79fac08b-04d1-41e9-9570-97b633e1b61e",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Requirement 4: Protect Cardholder Data with Strong Cryptography During Transmission Over Open, Public Networks",
                  "Note: For SAQ A-EP, Requirement 4 applies to merchants when sending payment related data to their TPSP.",
                  "4.1 Processes and mechanisms for protecting cardholder data with strong cryptography during transmission over open, public networks are defined and documented.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "822a977d-71b4-413b-b05f-69f5c5ae1cb7",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "4.2 PAN is protected with strong cryptography during transmission.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e21846f8-094a-47d1-941f-0b15befa3550",
                component: "col",
                label: "",
                simplifiedLabel: ["4.2.1"],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: "",
                width: "5%",
              },
              {
                _uid: "9a47e5d3-5a84-4113-8b3a-e5a1e4f0bb80",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Strong cryptography and security protocols are implemented as follows to safeguard PAN during transmission over open, public networks:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 4,
                width: "95%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0fc56d9e-03e6-4feb-8220-2c060e323657",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "0f105191-19a1-4575-918e-db137e25dd3b",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Only trusted keys and certificates are accepted.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "74f310ab-324c-4eb8-9462-31a33930c472",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented policies and procedures.",
                  "Interview personnel.",
                  "Examine system configurations.",
                  "Examine cardholder data transmissions.",
                  "Examine keys and certificates.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6977ca94-a321-42b6-a181-754e9842c3e9",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["d5ae7c57-42fa-4b01-b6ef-bea804fd24a1"],
                },
              },
              {
                _uid: "d5ae7c57-42fa-4b01-b6ef-bea804fd24a1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "2b89241a-739a-4206-8cbb-52b5ab88b912_6977ca94-a321-42b6-a181-754e9842c3e9",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6d50df8a-deb9-485c-8a53-dd0ff37be045",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "3ad431ac-9855-4fb0-9f40-99f3b89a20e2",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Certificates used to safeguard PAN during transmission over open, public networks are confirmed as valid and are not expired or revoked. This bullet is a best practice until its effective date; refer to Applicability Notes below for details.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c2dba022-17bc-41ad-8746-7e4f1e82692e",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented policies and procedures.",
                  "Interview personnel.",
                  "Examine system configurations.",
                  "Examine cardholder data transmissions.",
                  "Examine keys and certificates.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ac1fc75d-dccf-4988-9529-1f9836a0c53d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["13d03319-63ef-4f28-9df0-32b69c45e28d"],
                },
              },
              {
                _uid: "13d03319-63ef-4f28-9df0-32b69c45e28d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "dbfb0191-b807-4a1e-bcfe-326a3fce83df_ac1fc75d-dccf-4988-9529-1f9836a0c53d",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "16ea6227-f3be-48a0-a99d-e84a3dc1a8f9",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "1c2adfca-51da-4c84-aae8-4ce7bf76a381",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "The protocol in use supports only secure versions or configurations and does not support fallback to, or use of insecure versions, algorithms, key sizes, or implementations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "04594f91-0334-4f28-ac6f-e19b90345443",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented policies and procedures.",
                  "Interview personnel.",
                  "Examine system configurations.",
                  "Examine cardholder data transmissions.",
                  "Examine keys and certificates.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e413cf69-a333-454e-abea-53e7de37dd1d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["7e1d14a1-0b51-418b-b028-a1191aaaea97"],
                },
              },
              {
                _uid: "7e1d14a1-0b51-418b-b028-a1191aaaea97",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "7cbb742e-8bff-47e0-ae64-1a2f84179972_e413cf69-a333-454e-abea-53e7de37dd1d",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f6912b62-cb33-4564-b3f3-ce18269d7873",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "4b2c96af-bfde-4861-a65c-1bf048fe7f09",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "The encryption strength is appropriate for the encryption methodology in use.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "66f2c9f1-b49d-41b1-b9bc-3f754b2d9632",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented policies and procedures.",
                  "Interview personnel.",
                  "Examine system configurations.",
                  "Examine cardholder data transmissions.",
                  "Examine keys and certificates.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6c6f9fff-7f23-4f0e-a3e7-4645436eff8d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["a319d784-603b-458d-8425-4acf63bf8561"],
                },
              },
              {
                _uid: "a319d784-603b-458d-8425-4acf63bf8561",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "8ee0fae9-7401-41fe-bbd4-880ce0bb10a5_6c6f9fff-7f23-4f0e-a3e7-4645436eff8d",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "63a23a79-ce4b-4a06-aad9-4a5107f56a92",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes ",
                  "There could be occurrences where an entity receives cardholder data unsolicited via an insecure communication channel that was not intended for the purpose of receiving sensitive data. In this situation, the entity can choose to either include the channel in the scope of their CDE and secure it according to PCI DSS or implement measures to prevent the channel from being used for cardholder data.",
                  "A self-signed certificate may also be acceptable if the certificate is issued by an internal CA within the organization, the certificate’s author is confirmed, and the certificate is verified—for example, via hash or signature—and has not expired. Note that self-signed certificates where the Distinguished Name (DN) field in the “issued by” and “issued to” field is the same are not acceptable.",
                  "The bullet above (for confirming that certificates used to safeguard PAN during transmission over open, public networks are valid and are not expired or revoked) is a best practice until 31 March 2025, after which it will be required as part of Requirement 4.2.1 and must be fully considered during a PCI DSS assessment.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 24
          {
            fields: [
              {
                _uid: "488a3a4e-c289-4052-a9c1-6a2381dd496e",
                component: "col",
                label: "",
                simplifiedLabel: "4.2.1.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "ee0f2938-288f-4d61-b1c5-2bf98352f6ae",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Wireless networks transmitting PAN or connected to the CDE use industry best practices to implement strong cryptography for authentication and transmission.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "04387491-1aa4-4e6f-8f93-417223e4b157",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine system configurations."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "a6415f4a-9381-437f-a828-73bd56184d39",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["275e6aed-def3-401a-9f42-ce8e55d05881"],
                },
              },
              {
                _uid: "275e6aed-def3-401a-9f42-ce8e55d05881",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "22c5855d-bdca-415b-8d4f-da14f5788919_a6415f4a-9381-437f-a828-73bd56184d39",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d172474e-171c-4252-99a1-bc1925f530fa",
                component: "col",
                label: "",
                simplifiedLabel: "4.2.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "f7fd413c-2754-4ead-9d3e-294342940503",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "PAN is secured with strong cryptography whenever it is sent via end-user messaging technologies.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "816d0e52-a831-4081-9a58-12e0235aa616",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented policies and procedures.",
                  "Examine system configurations and vendor documentation.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "d28e1f71-f3e4-491f-ad1d-2df0501cf631",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["8be14e16-fe42-4db7-85a5-7a13257587c2"],
                },
              },
              {
                _uid: "8be14e16-fe42-4db7-85a5-7a13257587c2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "5694efa2-384c-453d-8c39-077fb65682d1_d28e1f71-f3e4-491f-ad1d-2df0501cf631",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "3c419148-e36f-4a6e-bbc6-8724e5e53067",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes ",
                  "This requirement also applies if a customer, or other third-party, requests that PAN is sent to them via end-user messaging technologies.",
                  "There could be occurrences where an entity receives unsolicited cardholder data via an insecure communication channel that was not intended for transmissions of sensitive data. In this situation, the entity can choose to either include the channel in the scope of their CDE and secure it according to PCI DSS or delete the cardholder data and implement measures to prevent the channel from being used for cardholder data.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 25
          {
            fields: [
              {
                _uid: "3509f7f3-c61c-4639-aa1c-4310a3dce318",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: [
                  "Maintain a Vulnerability Management Program",
                  "Requirement 5: Protect All Systems and Networks from Malicious Software",
                ],
                subBoldLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "88ed2bc3-fa7b-4d07-bb41-faeeaff4e7c1",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: [
                  "5.1 Processes and mechanisms for protecting all systems and networks from malicious software are defined and understood",
                ],
                subBoldLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "40a7d97d-fa7c-4606-ab0e-f32a48c917e2",
                component: "col",
                label: "",
                simplifiedLabel: "5.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "381e8ce7-f3df-4ee8-95b5-a26964705f85",
                component: "col",
                label: [],
                simplifiedLabel: [],
                labelWithUl: {
                  label: "",
                  simplifiedLabel:
                    "All security policies and operational procedures that are identified in Requirement 5 are:",
                  ul: [
                    "Documented.",
                    "Kept up to date.",
                    "In use.",
                    "Known to all affected parties.",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "4316f314-a635-4c01-aceb-c67614285def",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documentation.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "634bb0b1-4ea5-4fb0-9c4f-bac730b5d22a",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["1a6854f8-7f58-4697-8076-5de5f6aff15f"],
                },
              },
              {
                _uid: "1a6854f8-7f58-4697-8076-5de5f6aff15f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "ef29af90-a942-46e5-958a-e59893e0e747_634bb0b1-4ea5-4fb0-9c4f-bac730b5d22a",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a9d18738-b62a-4103-9f2a-aa4f4a5e7256",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for Requirement 5.1.1 means that the merchant has policies and procedures in place that govern merchant activities for Requirement 5.",
                ],
                boldLabel: [""],
                subBoldLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "062cee0b-5e22-4325-8428-95e6397ffc8b",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: [
                  "5.2 Malicious software (malware) is prevented, or detected and addressed.",
                ],
                subBoldLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "27797ae8-ed91-4244-ad3b-2b7dedd0003a",
                component: "col",
                label: "",
                simplifiedLabel: "5.2.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "f81397b2-6cca-48c6-8fab-62710cc5d121",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "An anti-malware solution(s) is deployed on all system components, except for those system components identified in periodic evaluations per Requirement 5.2.3 that concludes the system components are not at risk from malware.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "cbc4fed8-b417-419a-876f-3e7ba2a30683",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine system components",
                  "• Examine the periodic evaluations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "edc64438-0429-4499-abeb-6e19b94d1630",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["4573adf6-6e39-471f-9bf9-498e01608ae0"],
                },
              },
              {
                _uid: "4573adf6-6e39-471f-9bf9-498e01608ae0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "1082383d-76d0-420e-be89-198309af7a59_edc64438-0429-4499-abeb-6e19b94d1630",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2d474c04-4f89-4194-91c8-a87f423cce44",
                component: "col",
                label: "",
                simplifiedLabel: "5.2.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "0dbe2ec7-041e-403d-af41-c7af466f7e52",
                component: "col",
                label: [],
                simplifiedLabel: [],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "The deployed anti-malware solution(s):",
                  ul: [
                    "Detects all known types of malware.",
                    "Removes, blocks, or contains all known types of malware.",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "b08694c7-e570-49e3-9201-ed4d97ca632a",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine vendor documentation.",
                  "Examine system configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "f4d6e6de-8740-49b6-8890-1030b0d83094",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["bf43c4c3-373a-457a-b609-dd21da6e9828"],
                },
              },
              {
                _uid: "bf43c4c3-373a-457a-b609-dd21da6e9828",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "cdf9c5ef-bbb1-436e-90c9-4137fa267c24_f4d6e6de-8740-49b6-8890-1030b0d83094",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 26
          {
            fields: [
              {
                _uid: "5c63b065-253a-4e09-9db8-a8f664e0a3cd",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: "Applicability Notes for 5.2.3",
                subBoldLabel: [
                  "System components covered by this requirement are those for which there is no anti-malware solution deployed per Requirement 5.2.1.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "461dc80d-587b-469d-ab26-e3adab0d160f",
                component: "col",
                label: "",
                simplifiedLabel: "5.2.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "984762d0-0a96-4153-ada5-742fbecdcc43",
                component: "col",
                label: [],
                simplifiedLabel: [],
                labelWithUl: {
                  label: "",
                  simplifiedLabel:
                    "Any system components that are not at risk for malware are evaluated periodically to include the following:",
                  ul: [
                    "A documented list of all system components not at risk for malware.",
                    "Identification and evaluation of evolving malware threats for those system components",
                    "Confirmation whether such system components continue to not require anti-malware protection.",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7780c861-5b75-4d77-bbe0-9a0391b41021",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented policies and procedures.",
                  "Interview personnel.",
                  "Examine the list of system components not at risk for malware and compare against the system components without an anti-malware solution deployed.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "a049b982-8a08-4513-94b3-e02050ece2a8",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["4e2d7a42-65d9-4108-91f2-fb4d627e66a7"],
                },
              },
              {
                _uid: "4e2d7a42-65d9-4108-91f2-fb4d627e66a7",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "e8681aec-07b0-4c25-be80-e6b68f96d01e_a049b982-8a08-4513-94b3-e02050ece2a8",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5c63b065-253a-4e09-9db8-a8f664e0a3cd",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: "Applicability Notes for 5.2.3.1",
                subBoldLabel: [
                  "This requirement is a best practice until 31 March 2025, after which it will be required and must be  fully considered during a PCI DSS assessment.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "fa06c710-9a39-4b24-8365-02cf3897f24d",
                component: "col",
                label: "",
                simplifiedLabel: "5.2.3.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "c9c623a0-6376-4c7e-9e93-5bd1f3851eb5",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "The frequency of periodic evaluations of system components identified as not at risk for malware is defined in the entity’s targeted risk analysis, which is performed according to all elements specified in Requirement 12.3.1.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "26b2e8bd-999b-4355-8642-d17dbe164952",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine the targeted risk analysis.",
                  "Examine documented results of periodic evaluations.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3114324c-32b1-444a-9e9f-a9cb2f644eb4",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["8c32252b-f52c-4d2a-affc-816c644aefff"],
                },
              },
              {
                _uid: "8c32252b-f52c-4d2a-affc-816c644aefff",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "9ab2d478-727f-4aef-9150-ef0218e31a3a_3114324c-32b1-444a-9e9f-a9cb2f644eb4",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f000ab4d-9b6b-4bae-a9c8-47cc911c0aa2",
                component: "col",
                label: "",
                simplifiedLabel: "5.3.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "a9bbf6d9-1a7c-4ef6-9477-2d7f45fa0eae",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "The anti-malware solution(s) is kept current via automatic updates.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "445db6f0-cd47-4dd2-bb0c-16760988d4ce",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine anti-malware solution(s) configurations, including any master installation",
                  "Examine system components and logs.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "8a2e8b27-ef43-460f-b9a0-e05e36109f82",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["f6e682df-7be2-4232-89c5-5ad1ddb3f42a"],
                },
              },
              {
                _uid: "f6e682df-7be2-4232-89c5-5ad1ddb3f42a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "cbe82dea-853d-4814-81cc-6e16face7cc5_8a2e8b27-ef43-460f-b9a0-e05e36109f82",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 27
          {
            fields: [
              {
                _uid: "8af46790-bea6-4379-b1b4-ccfbf3f8a4a7",
                component: "col",
                label: "",
                simplifiedLabel: "5.3.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "5f050469-d72e-48ca-ad45-be81ded70ed5",
                component: "col",
                label: [],
                simplifiedLabel: [],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "The anti-malware solution(s):",
                  ul: [
                    "Performs periodic scans and active or real-time scans",
                    "OR",
                    "Performs continuous behavioral analysis of systems or processes.",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "6e104e35-c4cb-491b-a83c-cf4bbe9490ae",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine anti-malware solution(s) configurations, including any master installation.",
                  "Examine system components.",
                  "Examine logs and scan results.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "a8f8af09-efc3-4c31-a1fe-a258e03ba596",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["6c904e40-1f83-400b-b4f5-8b662616f27c"],
                },
              },
              {
                _uid: "6c904e40-1f83-400b-b4f5-8b662616f27c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "4c95357e-d577-43fd-8430-f0ed2afd86cb_a8f8af09-efc3-4c31-a1fe-a258e03ba596",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "75e1b102-ca81-401a-8660-06ff89b51e4a",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: "Applicability Notes for 5.3.2.1",
                subBoldLabel: [
                  "This requirement applies to entities conducting periodic malware scans to meet Requirement 5.3.2.",
                  "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "38543db3-c385-471a-9c43-74f86c607931",
                component: "col",
                label: "",
                simplifiedLabel: "5.3.2.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "d831d656-4b49-4d6e-957c-5877f648cc4f",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "If periodic malware scans are performed to meet Requirement 5.3.2, the frequency of scans is defined in the entity’s targeted risk analysis, which is performed according to all elements specified in Requirement 12.3.1. ",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "5586ed57-6fe7-48f3-8047-49af3d293122",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine the targeted risk analysis.",
                  "Examine documented results of periodic malware scans.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "b54150bc-ff5c-4a4e-89ed-e464738c8fe1",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["24484943-947e-4c55-8315-0991f1b26607"],
                },
              },
              {
                _uid: "24484943-947e-4c55-8315-0991f1b26607",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "c60886d5-d448-46ae-9cfe-f082a09d6337_b54150bc-ff5c-4a4e-89ed-e464738c8fe1",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f8ab2c33-3b94-4e59-b084-5bf9218c7ecf",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: "Applicability Notes for 5.3.3",
                subBoldLabel: [
                  "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "84ba0ca1-48ee-49b7-973c-7b89818edec1",
                component: "col",
                label: "",
                simplifiedLabel: "5.3.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "4d52522b-bfc2-4364-b6fc-3e3bdfe96a88",
                component: "col",
                label: [],
                simplifiedLabel: [],
                labelWithUl: {
                  label: "",
                  simplifiedLabel:
                    "For removable electronic media, the anti-malware solution(s): ",
                  ul: [
                    "Performs automatic scans of when the media is inserted, connected, or logically mounted,",
                    "OR",
                    "Performs continuous behavioral analysis of systems or processes when the media is inserted, connected, or logically mounted.",
                  ],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "2f93396d-66a0-4a0c-b316-02330229c134",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine anti-malware solution(s) configurations.",
                  "Examine system components with removable electronic media.",
                  "Examine logs and scan results.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ed428593-9b0d-4bfb-a0a3-bfdb1f07b867",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["bb9d776a-b64d-4a71-bab6-af06ee2715f1"],
                },
              },
              {
                _uid: "bb9d776a-b64d-4a71-bab6-af06ee2715f1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "6bbfc3a7-0808-485c-a5d2-ebae2a2b2b44_ed428593-9b0d-4bfb-a0a3-bfdb1f07b867",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a13390ec-e29a-4beb-a032-99aad057aaaa",
                component: "col",
                label: "",
                simplifiedLabel: "5.3.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "2de7417f-bd51-4829-988f-b20520222950",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Audit logs for the anti-malware solution(s) are enabled and retained in accordance with Requirement 10.5.1.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "457949f1-b1d8-46e0-bb42-3f15889495b2",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine anti-malware solution(s) configurations.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "1078d1eb-8b26-43e6-8a7c-f50baace4493",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["ec9098c2-381c-42f9-a845-f9d0137caf6e"],
                },
              },
              {
                _uid: "ec9098c2-381c-42f9-a845-f9d0137caf6e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "1007e69c-0aff-4cc5-b4cd-a16058811aa7_1078d1eb-8b26-43e6-8a7c-f50baace4493",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 28
          {
            fields: [
              {
                _uid: "f411ba15-1356-438a-88d7-24f352427b12",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: "Applicability Notes for 5.3.5",
                subBoldLabel: [
                  "Anti-malware solutions may be temporarily disabled only if there is a legitimate technical need, as authorized by management on a case-by-case basis. If anti-malware protection needs to be disabled for a specific purpose, it must be formally authorized. Additional security measures may also need to be implemented for the period during which anti-malware protection is not active.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "9d19b2b7-1792-4640-b10c-6e0089aa37b1",
                component: "col",
                label: "",
                simplifiedLabel: "5.3.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "4d49a480-047e-4c31-a9e9-cbb4f0164d37",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Anti-malware mechanisms cannot be disabled or altered by users, unless specifically documented, and authorized by management on a case-by-case basis for a limited time period.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "82526f72-23ad-48e5-b909-d2c1c0f05487",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine anti-malware configurations.",
                  "Observe processes.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "52b8d052-eb27-45ef-937b-4d805624e1d8",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["cfed242a-d796-4005-b91d-38a5c725e07d"],
                },
              },
              {
                _uid: "cfed242a-d796-4005-b91d-38a5c725e07d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "ebca1527-6a62-4731-99cc-f58bd54956b4_52b8d052-eb27-45ef-937b-4d805624e1d8",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "3f7f4d88-c07b-4f42-be14-fc659dd3c749",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: [
                  "5.4 Anti-phishing mechanisms protect users against phishing attacks.",
                ],
                subBoldLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5851539c-ced6-4fda-82eb-808e1142e13c",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: "Applicability Notes for 5.4.1",
                subBoldLabel: [
                  "This requirement applies to the automated mechanism. It is not intended that the systems and services providing such automated mechanisms (such as e-mail servers) are brought into scope for PCI DSS.",
                  "The focus of this requirement is on protecting personnel with access to system components inscope for PCI DSS.",
                  "Meeting this requirement for technical and automated controls to detect and protect personnel against phishing is not the same as Requirement 12.6.3.1 for security awareness training. Meeting this requirement does not also meet the requirement for providing personnel with security awareness training, and vice versa.",
                  "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e810b824-5418-433b-97a2-9feb8e772a72",
                component: "col",
                label: "",
                simplifiedLabel: "5.4.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "bf14c310-93a7-4b53-a319-2df5c34d6429",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Processes and automated mechanisms are in place to detect and protect personnel against phishing attacks.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "5f32152c-591d-4fbb-8a32-dc821df68731",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Observe implemented processes",
                  "Examine mechanisms.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "7ba3c36e-fe1d-4a1c-b128-4ef28914e3b1",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["3db0e72f-ebe7-4c0b-aa40-41c1000db6fd"],
                },
              },
              {
                _uid: "3db0e72f-ebe7-4c0b-aa40-41c1000db6fd",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "d301ef8c-2640-4407-8070-f148f0521a49_7ba3c36e-fe1d-4a1c-b128-4ef28914e3b1",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 29
          {
            fields: [
              {
                _uid: "12da06ab-9d37-48cf-846f-89f68728e271",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Requirement 6: Develop and Maintain Secure Systems and Software",
                  "6.2 Bespoke and custom software are developed securely",
                  "6.2 Bespoke and custom software are developed securely",
                  "Note: For SAQ C, requirements at 6.2 apply to merchants with bespoke software (developed to the entity's specifications by a third party) or custom software (developed by the entity). If merchant does not have such software, mark these requirements as Not Applicable and complete Appendix C: Explanation of Requirements Noted as Not Applicable. ",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c566c8c2-0632-4932-987f-fa2ff386b983",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes For 6.2.1",
                  "This applies to all software developed for or by the entity for the entity’s own use. This includes both bespoke and custom software. This does not apply to third-party software.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0db047e4-ed06-4b51-bf52-90600d69bd19",
                component: "col",
                label: "",
                simplifiedLabel: "6.2.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "0a559e6a-8768-4151-a7d9-e5e2831b037e",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Bespoke and custom software are developed securely, as follows:",
                  "Based on industry standards and/or best practices for secure development.",
                  "Bullet intentionally left blank for this SAQ.",
                  "Bullet intentionally left blank for this SAQ.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "96364df6-f29a-411a-8c3f-0bfb015bf28e",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented software development procedures.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "18fb448b-e1e3-4609-b2c8-4ddb03ffbaec",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["c3c54abc-76a9-4ce2-a4a1-d8e0faeea075"],
                },
              },
              {
                _uid: "c3c54abc-76a9-4ce2-a4a1-d8e0faeea075",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "244004a9-17d5-44af-a76a-cfab4366f31a_18fb448b-e1e3-4609-b2c8-4ddb03ffbaec",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "57cf5645-c647-466b-afd8-b7681e12338a",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes For 6.2.2",
                  "Software development personnel remain knowledgeable about secure development practices; software security; and attacks against the languages, frameworks, or applications they develop. Personnel are able to access assistance and guidance when required.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c8d82987-67cd-4dc5-9c13-a71d6d9c7170",
                component: "col",
                label: "",
                simplifiedLabel: "6.2.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "90ce6015-61bb-4186-bc81-eaae623690a6",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Software development personnel working on bespoke and custom software are trained at least once every 12 months as follows:",
                  "On software security relevant to their job function and development languages.",
                  "Including secure software design and secure coding techniques.",
                  "Including, if security testing tools are used, how to use the tools for detecting vulnerabilities in software.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "fd2c5174-ffe6-47a3-8bd3-d0c7f93b877f",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented software development procedures.",
                  "Examine training records.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "f88b4e60-1b70-41e2-a093-ad6b56b0b2c7",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["f39d5178-9751-45cc-9be8-5d29747ad464"],
                },
              },
              {
                _uid: "f39d5178-9751-45cc-9be8-5d29747ad464",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "641b7e87-c062-4abf-84bd-d6be5b5714f0_f88b4e60-1b70-41e2-a093-ad6b56b0b2c7",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 30
          {
            fields: [
              {
                _uid: "f4b17f78-392c-4473-bd8f-c03d0b0730d5",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes For 6.2.3.1",
                  "Manual code reviews can be conducted by knowledgeable internal personnel or knowledgeable third-party personnel.",
                  "An individual that has been formally granted accountability for release control and who is neither the original code author nor the code reviewer fulfills the criteria of being management.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e53de14b-58a5-4421-8e39-d89298a1d7d9",
                component: "col",
                label: "",
                simplifiedLabel: "6.2.3.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "122423ed-5bca-40ea-8104-82689f822519",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "If manual code reviews are performed for bespoke and custom software prior to release to production, code changes are:",
                  "Reviewed by individuals other than the originating code author, and who are knowledgeable about codereview techniques and secure coding practices.",
                  "Reviewed and approved by management prior to release.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c56afd4f-b1e8-4351-8a26-78f75064e70e",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented software development procedures.",
                  "Interview responsible personnel.",
                  "Examine evidence of changes to bespoke and custom software.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "7ba9c223-de24-4a6d-b3f9-565e1356adcf",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["547119cf-5c02-441d-8e18-80e00f1af294"],
                },
              },
              {
                _uid: "547119cf-5c02-441d-8e18-80e00f1af294",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "7033aefa-b54f-4f23-a169-ad9842e39edb_7ba9c223-de24-4a6d-b3f9-565e1356adcf",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 31
          {
            fields: [
              {
                _uid: "589c0d59-caf1-4802-97a5-4888cd07c7bf",
                component: "col",
                label: "",
                simplifiedLabel: ["6.2.4"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "7e197bf1-92fd-44a1-be9c-afef33374eec",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Software engineering techniques or other methods are defined and in use by software development personnel to prevent or mitigate common software attacks and related vulnerabilities in bespoke and custom software, including but not limited to the following:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 4,
                width: "95%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b589682c-9781-49bf-be09-73c77554bbfb",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "f0975326-e8b7-43dc-bcf6-bcc2cabe8816",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Injection attacks, including SQL, LDAP, XPath, or other command, parameter, object, fault, or injection-type flaws.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "236abe9b-5f47-4926-b609-c2e1de3d8293",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented procedures.",
                  "Interview responsible software development personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e4bd43f0-523e-4aca-b763-abd0d4452765",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["0bc633ba-cb44-44c8-a9f4-6d9852136694"],
                },
              },
              {
                _uid: "0bc633ba-cb44-44c8-a9f4-6d9852136694",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "4d1513f5-ca72-4ccf-83d4-121566ba1038_e4bd43f0-523e-4aca-b763-abd0d4452765",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f3dee26d-3aba-4374-9385-b9ea7c5732ee",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "e529a785-7327-41e4-8b33-e30fe0aaec54",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Attacks on data and data structures, including attempts to manipulate buffers, pointers, input data, or shared data.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "51190034-7659-462d-9192-76f662bcc9a2",
                component: "col",
                label: [],
                simplifiedLabel: [""],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "f742e5ee-866c-4ecc-853b-5bb7a3aa8e0e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["1bf6e5fd-6472-466a-bf7f-9d24e423271d"],
                },
              },
              {
                _uid: "1bf6e5fd-6472-466a-bf7f-9d24e423271d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "eb03bd3c-9669-4605-b1dd-713fc783022f_f742e5ee-866c-4ecc-853b-5bb7a3aa8e0e",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c3973a39-e9a8-475d-8fa6-7d067e71eddd",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "34d7bd1a-89f3-4bde-886e-47ca7a660f69",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Attacks on cryptography usage, including attempts to exploit weak, insecure, or inappropriate cryptographic implementations, algorithms, cipher suites, or modes of operation.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "d19dfdbb-6f79-468f-b69c-0c0a8a68e8f1",
                component: "col",
                label: [],
                simplifiedLabel: [""],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e1d90790-67b0-4cf8-a1b0-adc93af5dd11",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["cbd362f3-cf69-4d0a-b6bd-5c269639a185"],
                },
              },
              {
                _uid: "cbd362f3-cf69-4d0a-b6bd-5c269639a185",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "8febe301-abf5-4671-99cb-28e7d973e8a2_e1d90790-67b0-4cf8-a1b0-adc93af5dd11",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b3319a7e-0704-4f91-a17c-a1d5b6ead5c1",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "da9a2fba-f8d1-4ac6-86ea-8398cf11eaef",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Attacks on business logic, including attempts to abuse or bypass application features and functionalities through the manipulation of APIs, communication protocols and channels, client-side functionality, or other system/application functions and resources. This includes cross-site scripting (XSS) and cross-site request forgery (CSRF).",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "53a126e8-eec9-4cfe-8635-bf7702f90a4b",
                component: "col",
                label: [],
                simplifiedLabel: [""],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "5734f093-fe98-433c-8f55-381d77d2e914",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["e0f8b880-b475-44ab-b297-19f87340798d"],
                },
              },
              {
                _uid: "e0f8b880-b475-44ab-b297-19f87340798d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "bca48008-6ef4-4f5a-a7a8-dfa5311ebc29_5734f093-fe98-433c-8f55-381d77d2e914",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "25f5d398-9139-4db6-9c0d-4ddfd84a4ff7",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "93f7d8a6-a515-43ca-b7b4-3f0265cd7876",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "SAttacks on access control mechanisms, including attempts to bypass or abuse identification, authentication, or authorization mechanisms, or attempts to exploit weaknesses in the implementation of such mechanisms.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7dcbb581-e368-43ff-ae19-c1daff542348",
                component: "col",
                label: [],
                simplifiedLabel: [],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "b1376447-ec2c-467f-bdf3-213ff8d87e88",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["d2457aa2-78b5-4251-9258-266edf7168c0"],
                },
              },
              {
                _uid: "d2457aa2-78b5-4251-9258-266edf7168c0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "19f1a181-7222-4cb7-9226-6e3980fbd900_b1376447-ec2c-467f-bdf3-213ff8d87e88",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f7437cea-852e-4473-972f-185e4afb7087",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "75e197a8-e1a7-4f65-9886-7d245fc5d4be",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Attacks via any “high-risk” vulnerabilities identified in the vulnerability identification process, as defined in Requirement 6.3.1.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "244d4b03-8b23-4ea4-8492-d39c1e862f73",
                component: "col",
                label: [],
                simplifiedLabel: [],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "81293d49-5af5-4f63-9986-3f05286030a4",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["259cdf9b-be5f-419a-af05-3e212cf5d60e"],
                },
              },
              {
                _uid: "259cdf9b-be5f-419a-af05-3e212cf5d60e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "2e1a6c2f-faa4-4c6d-96c4-9287eb3bec20_81293d49-5af5-4f63-9986-3f05286030a4",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "bd59c599-2f05-49eb-894c-f144ba69a175",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This applies to all software developed for or by the entity for the entity’s own use. This includes both bespoke and custom software. This does not apply to third-party software.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 32
          {
            fields: [
              {
                _uid: "12da06ab-9d37-48cf-846f-89f68728e271",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "6.3 Security vulnerabilities are identified and addressed.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7a553f38-167f-40c9-851d-4c95e0589ab1",
                component: "col",
                label: "",
                simplifiedLabel: "6.3.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "c1117aa8-39b4-4e8d-813f-5aed71cd19ae",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Security vulnerabilities are identified and managed as follows:",
                  "New security vulnerabilities are identified using industry-recognized sources for security vulnerability information, including alerts from international and national computer emergency response teams (CERTs)",
                  "Vulnerabilities are assigned a risk ranking based on industry best practices and consideration of potential impact.",
                  "Risk rankings identify, at a minimum, all vulnerabilities considered to be a high-risk or critical to the environment.",
                  "Bullet intentionally left blank for this SAQ.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7dcbb581-e368-43ff-ae19-c1daff542348",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures",
                  "Interview responsible personnel.",
                  "Examine documentation.",
                  "Observe processes.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "0d0c3531-eb15-43b7-950b-4d638136c650",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["b6c4dcc2-eca7-4d71-9140-30fd51c51437"],
                },
              },
              {
                _uid: "b6c4dcc2-eca7-4d71-9140-30fd51c51437",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "54fe3bca-5e7f-4eff-a678-2f0a1f2a4292_0d0c3531-eb15-43b7-950b-4d638136c650",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e74bf7b4-87a6-4784-a3a4-f534905c4623",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement is not achieved by, nor is it the same as, vulnerability scans performed for Requirements 11.3.1 and 11.3.2. This requirement is for a process to actively monitor industry sources for vulnerability information and for the entity to determine the risk ranking to be associated with each vulnerability.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e869cd09-3289-4ece-8f2c-50a91babb8f7",
                component: "col",
                label: "",
                simplifiedLabel: "6.3.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "a918fb51-9dc6-4f7e-94a6-b205be8771fc",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "All system components are protected from known vulnerabilities by installing applicable security patches/updates as follows:",
                  "Critical or high-security patches/updates are installed within one month of release.",
                  "Bullet intentionally left blank for this SAQ.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "047f88e2-a726-4ab4-8025-37ee9788c4c2",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine system components and related software.",
                  "Compare list of security patches installed to recent vendor patch lists.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "4d7772bb-b114-4f5d-8a59-7a10522f9edb",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["1d980035-33ce-4dba-a148-760180419abd"],
                },
              },
              {
                _uid: "1d980035-33ce-4dba-a148-760180419abd",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "085d8b7f-ade1-4389-8d44-c528a96965ba_4d7772bb-b114-4f5d-8a59-7a10522f9edb",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 33
          {
            fields: [
              {
                _uid: "8881e26a-63b9-40bb-8903-d44c006f9045",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "6.5 Changes to all system components are managed securely.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "42912d77-8072-42fc-80d9-211a8e6edf82",
                component: "col",
                label: "",
                simplifiedLabel: "6.5.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "befb54b6-be2c-4ca0-ab00-e648d7ec3cab",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Changes to all system components in the production environment are made according to established procedures that include:",
                  "Reason for, and description of, the change.",
                  "Documentation of security impact.",
                  "Documented change approval by authorized parties.",
                  "Testing to verify that the change does not adversely impact system security.",
                  "For bespoke and custom software changes, all updates are tested for compliance with Requirement 6.2.4 before being deployed into production.",
                  "Procedures to address failures and return to a secure state.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "6b5a0621-3706-49f6-b1ee-31c9f90bbd69",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented change control procedures.",
                  "Examine recent changes to system components and trace changes to change control documentation.",
                  "Examine change control documentation.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "32eb36ba-7fc1-498a-89bd-9a57e089ea28",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["62f5f29a-d14b-4051-aee3-40609f8ae084"],
                },
              },
              {
                _uid: "62f5f29a-d14b-4051-aee3-40609f8ae084",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "0f26db00-8db3-4446-8f26-6f29009d1775_32eb36ba-7fc1-498a-89bd-9a57e089ea28",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "42912d77-8072-42fc-80d9-211a8e6edf82",
                component: "col",
                label: "",
                simplifiedLabel: "6.5.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "befb54b6-be2c-4ca0-ab00-e648d7ec3cab",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Upon completion of a significant change, all applicable PCI DSS requirements are confirmed to be in place on all new or changed systems and networks, and documentation is updated as applicable.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "6b5a0621-3706-49f6-b1ee-31c9f90bbd69",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documentation for significant changes.",
                  "Interview personnel.",
                  "Observe the affected systems/networks.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "0404379c-9953-4bd2-a753-104cb6956a91",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["62f5f29a-d14b-4051-aee3-40609f8ae084"],
                },
              },
              {
                _uid: "62f5f29a-d14b-4051-aee3-40609f8ae084",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "0f26db00-8db3-4446-8f26-6f29009d1775_0404379c-9953-4bd2-a753-104cb6956a91",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4442f0e5-1236-4178-babf-9864b35e705e",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This Applicability Note was intentionally removed as it does not apply to this SAQ.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 34
          {
            fields: [
              {
                _uid: "23e7dcf7-da44-4125-b043-ea9eeb293f22",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Implement Strong Access Control Measures",
                  "Requirement 7: Restrict Access to System Components and Cardholder Data by Business Need to Know",
                  "7.2 Access to system components and data is appropriately defined and assigned.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4d4cfddb-540a-41d8-8293-97a0daa4e363",
                component: "col",
                label: "",
                simplifiedLabel: "7.2.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "befc4c5f-8509-492d-9479-b77166d5588e",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Access is assigned to users, including privileged users, based on:",
                  "Job classification and function.",
                  "Least privileges necessary to perform job responsibilities.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "fb9c675f-b5ed-4b72-b609-f6e50d396804",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine user access settings, including for privileged users.",
                  "Interview responsible management personnel.",
                  "Interview personnel responsible for assigning access.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ff63fbeb-db1c-4325-baca-3a8432dbe7b7",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["19155fad-c31d-4958-8e6e-3a100134b1b6"],
                },
              },
              {
                _uid: "19155fad-c31d-4958-8e6e-3a100134b1b6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "a7b770fc-ec17-40e4-90f0-8769f2b099cc_ff63fbeb-db1c-4325-baca-3a8432dbe7b7",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d332a58f-91df-4dc2-9d5d-45353f15552b",
                component: "col",
                label: "",
                simplifiedLabel: "7.2.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "5a7f3fae-93e6-4ed0-b8ca-689681753fa6",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Required privileges are approved by authorized personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7fc6ae4f-8b48-4c17-ab8d-07b8088e8182",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine user IDs and assigned privileges.",
                  "Examine documented approvals.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "37b133a1-e6ba-4808-987a-9a709354e4a3",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["0e17c8b7-f94f-4f2a-b0cb-5ba6fdb9993b"],
                },
              },
              {
                _uid: "0e17c8b7-f94f-4f2a-b0cb-5ba6fdb9993b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "9ccfad93-5bca-4701-9825-9788518e3be6_37b133a1-e6ba-4808-987a-9a709354e4a3",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 35
          {
            fields: [
              {
                _uid: "066382ec-e66c-4143-8546-2fbef1004380",
                component: "col",
                label: "",
                simplifiedLabel: "7.2.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "f8313104-9772-4508-b5af-d1132dccdce8",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "All user accounts and related access privileges, including third-party/vendor accounts, are reviewed as follows:",
                  "At least once every six months.",
                  "To ensure user accounts and access remain appropriate based on job function.",
                  "Any inappropriate access is addressed.",
                  "Management acknowledges that access remains appropriate.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "0be44d02-bacb-44d6-a7ee-1c68f620ebc5",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Interview responsible personnel.",
                  "Examine documented results of periodic reviews of user accounts.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "d9784db8-2699-4408-9d11-94dd8f4950e0",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["5c5c727e-5255-4b20-8cd4-3942e2bb6cd1"],
                },
              },
              {
                _uid: "5c5c727e-5255-4b20-8cd4-3942e2bb6cd1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "349c3cb8-0550-4eee-9543-62071866d383_d9784db8-2699-4408-9d11-94dd8f4950e0",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e84867e2-79de-4a49-826b-3ddf8c358d0a",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement applies to all user accounts and related access privileges, including those used by personnel and third parties/vendors, and accounts used to access third-party cloud services.",
                  "See Requirements 7.2.5 and 7.2.5.1 and 8.6.1 through 8.6.3 for controls for application and system accounts.",
                  "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6d569fbe-09f2-48f6-9049-0299c754ae60",
                component: "col",
                label: "",
                simplifiedLabel: "7.2.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "c341f456-a2e6-4f55-bb3b-2bd50dbf9602",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "All application and system accounts and related access privileges are assigned and managed as follows:",
                  "Based on the least privileges necessary for the operability of the system or application.",
                  "Access is limited to the systems, applications, or processes that specifically require their use.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "cf62b635-e7c3-4e9d-8756-7a6277304315",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine privileges associated with system and application accounts.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "509cf493-4e2c-464d-89f5-94aa8ff7536e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["4f952d87-c6e4-47c7-9bc5-2eedf8bf4f94"],
                },
              },
              {
                _uid: "4f952d87-c6e4-47c7-9bc5-2eedf8bf4f94",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "dd35848d-cfd6-437e-9d3d-6d7c8c5ca3d8_509cf493-4e2c-464d-89f5-94aa8ff7536e",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6122cd70-5b67-4e62-a855-e001bf2beb03",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 36
          {
            fields: [
              {
                _uid: "cf98f849-cbcd-425d-933c-385eaee10472",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Requirement 8: Identify Users and Authenticate Access to System Components",
                  "8.1 Processes and mechanisms for identifying users and authenticating access to system components are defined and understood.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "935f4feb-6904-4e40-b350-bbe3f0ef4232",
                component: "col",
                label: "",
                simplifiedLabel: "8.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "e35876f9-5ace-46bc-8593-e50a24691a6b",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "All security policies and operational procedures that are identified in Requirement 8 are:",
                  "Documented.",
                  "Kept up to date.",
                  "In use.",
                  "Known to all affected parties.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "cf6faa36-d4f8-454e-bd4c-4844e0be95e1",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documentation.",
                  "Interview personnel",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c46eba6c-442d-4889-be80-948496820222",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["22667b31-88cd-4ab7-a210-7052ac23ace3"],
                },
              },
              {
                _uid: "22667b31-88cd-4ab7-a210-7052ac23ace3",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "c4798097-316d-4b59-9588-0319cd0a3b35_c46eba6c-442d-4889-be80-948496820222",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8256fabd-6692-470d-81ce-9a933533e1f4",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for Requirement 8.1.1 means that the merchant has policies and procedures in place that govern merchant activities for Requirement 8.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8d6498d8-2cdd-4d8c-bf5a-154fc255988b",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "8.2 User identification and related accounts for users and administrators are strictly managed throughout an account’s lifecycle.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "59cc92ec-d73a-4bec-ad3e-fbc7231e57ff",
                component: "col",
                label: "",
                simplifiedLabel: "8.2.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "f19a517e-1312-4c0d-a813-dd905d58fcde",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "All users are assigned a unique ID before access to system components or cardholder data is allowed.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "ec116060-df10-41ce-bd38-cc7add5e057d",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Interview responsible personnel",
                  "Examine audit logs and other evidence.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "697b2020-5b53-41ad-8833-10ca32041cc7",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["a493012a-ddda-48d0-b0f2-c17c9b356147"],
                },
              },
              {
                _uid: "a493012a-ddda-48d0-b0f2-c17c9b356147",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "4bb007ce-1574-4125-bced-4783d3f150f7_697b2020-5b53-41ad-8833-10ca32041cc7",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1ebe5fab-3375-4a80-bafb-efe25f0d350b",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement is not intended to apply to user accounts within point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals).",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 37
          {
            fields: [
              {
                _uid: "ea1f1537-ac35-4346-84ba-3b4337d9903e",
                component: "col",
                label: "",
                simplifiedLabel: "8.2.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "1fef28b4-fac7-4574-8e90-f384c22c77a4",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Group, shared, or generic accounts, or other shared authentication credentials are only used when necessary on an exception basis, and are managed as follows:",
                  "Account use is prevented unless needed for an exceptional circumstance.",
                  "Use is limited to the time needed for the exceptional circumstance.",
                  "Business justification for use is documented.",
                  "Use is explicitly approved by management.",
                  "Individual user identity is confirmed before access to an account is granted.",
                  "Every action taken is attributable to an individual user.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "edd8b309-883f-4fd5-b055-a3e2062d4432",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine user account lists on system components and applicable documentation.",
                  "Examine authentication policies and procedures.",
                  "Interview system administrators.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "d0c21492-395c-4ebc-906a-90aa3b4751df",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["fff8c025-dc66-4447-846d-4a796d2298a6"],
                },
              },
              {
                _uid: "fff8c025-dc66-4447-846d-4a796d2298a6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "894ab185-0398-41bd-b828-456fdf382749_d0c21492-395c-4ebc-906a-90aa3b4751df",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2cbf1a8f-1e16-4398-aa05-c9068f98ff55",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement is not intended to apply to user accounts within point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals).",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f30767e6-0e25-4f51-9acb-80bca7b42c9e",
                component: "col",
                label: "",
                simplifiedLabel: "8.2.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "59147999-2588-407b-89f8-ef34eeb7a19b",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Addition, deletion, and modification of user IDs, authentication factors, and other identifier objects are managed as follows:",
                  "Authorized with the appropriate approval.",
                  "Implemented with only the privileges specified on the documented approval.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "8fff5730-e05f-4502-ac76-58c9a063bdb3",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented authorizations across various phases of the account lifecycle (additions, modifications, and deletions).",
                  "Examine system settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "010f5e3b-71ed-404d-9dc7-661104068560",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["da3af7a7-3f56-4ef3-8d7d-47a757e049dc"],
                },
              },
              {
                _uid: "da3af7a7-3f56-4ef3-8d7d-47a757e049dc",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "7345b20b-bde1-4e75-9f8b-f34723ba2f1f_010f5e3b-71ed-404d-9dc7-661104068560",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1030cea0-d765-44bb-9480-eeac49c9cf31",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement applies to all user accounts, including employees, contractors, consultants, temporary workers, and third-party vendors.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4fe2c236-efc9-4485-901b-1ce33417ed87",
                component: "col",
                label: "",
                simplifiedLabel: "8.2.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "7dc341e0-d63e-4ec4-88e5-0db780347f19",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Access for terminated users is immediately revoked.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "f5c7394d-c143-4918-abcc-fc9713682e4b",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine information sources for terminated users.",
                  "Review current user access lists.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "9590a764-ff2d-40c2-a416-6a2b1927808e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["828dd2e4-a894-4acb-b5dc-26bd0203e154"],
                },
              },
              {
                _uid: "828dd2e4-a894-4acb-b5dc-26bd0203e154",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "a76c5f10-b2ff-459b-bb5f-8fe16d4e9fdd_9590a764-ff2d-40c2-a416-6a2b1927808e",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 38
          {
            fields: [
              {
                _uid: "28a548fc-ed75-467e-8aef-fecdb1378979",
                component: "col",
                label: "",
                simplifiedLabel: "8.2.6",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "c40ba643-a85b-4518-ab19-360555407d12",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Inactive user accounts are removed or disabled within 90 days of inactivity.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "ca908ffd-e4f4-4bc2-9c32-6ca6d7d6c91f",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine user accounts and last logon information.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c8e5bac5-df1f-45b5-ba4e-50fff1161c14",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["8d0e4ee8-d08e-4ffd-918b-3c34def91604"],
                },
              },
              {
                _uid: "8d0e4ee8-d08e-4ffd-918b-3c34def91604",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "904dcf74-dafc-4d1a-b02e-0a306f4b1780_c8e5bac5-df1f-45b5-ba4e-50fff1161c14",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "22714580-0729-45d2-9a8d-a0f0b6bb3b0c",
                component: "col",
                label: "",
                simplifiedLabel: "8.2.7",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "e35d93fe-c3e3-405b-a8dd-3ddb0e0b6af9",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Accounts used by third parties to access, support, or maintain system components via remote access are managed as follows:",
                  "Enabled only during the time period needed and disabled when not in use.",
                  "Use is monitored for unexpected activity.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "ca3b4115-45bb-48db-88a3-282021dd2159",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Interview responsible personnel.",
                  "Examine documentation for managing accounts.",
                  "Examine evidence.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e0d026f0-88af-4b64-8358-c1cb103602ea",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["fe565243-5504-4070-b1ec-488a1427fd76"],
                },
              },
              {
                _uid: "fe565243-5504-4070-b1ec-488a1427fd76",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "8544417d-8efa-424e-a587-b2b51794675d_e0d026f0-88af-4b64-8358-c1cb103602ea",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4709e9d9-fd26-4652-b147-4d1fc295d174",
                component: "col",
                label: "",
                simplifiedLabel: "8.2.8",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "1130daa4-ab7f-431b-b139-4841a098f99b",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "If a user session has been idle for more than 15 minutes, the user is required to re-authenticate to reactivate the terminal or session.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "350d7769-0903-4084-a249-4a38ee1df94a",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine system configuration settings."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3969900b-7498-45ae-a67b-a42fee1f3357",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["24e0374e-c223-452d-b4ae-43e6875d96a2"],
                },
              },
              {
                _uid: "24e0374e-c223-452d-b4ae-43e6875d96a2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "ad3a47f7-8ce5-42be-93f5-2351fdd37b62_3969900b-7498-45ae-a67b-a42fee1f3357",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7648b67f-acc8-472b-8661-89efe84212e3",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement is not intended to apply to user accounts on point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals).",
                  "This requirement is not meant to prevent legitimate activities from being performed while the console/PC is unattended.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 39
          {
            fields: [
              {
                _uid: "0c2404bf-0348-4a02-b4eb-17751056ba12",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "8.3 Strong authentication for users and administrators is established and managed.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4d891bb2-645b-4c34-b0c5-5d56e263e8b7",
                component: "col",
                label: "",
                simplifiedLabel: "8.3.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "e6a6ac6a-08d3-476c-ad1b-72b7085f7300",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "All user access to system components for users and administrators is authenticated via at least one of the following authentication factors:",
                  "Something you know, such as a password or passphrase.",
                  "Something you have, such as a token device or smart card.",
                  "Something you are, such as a biometric element.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "598e6f6d-0a31-4bda-a2b5-7069dc5ec230",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documentation describing the authentication factor(s) used.",
                  "For each type of authentication factor used with each type of system component, observe the authentication process.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c24e59ab-bd97-41f3-b931-8f67fd77ed20",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["966b5fe7-d69f-45a8-b75e-1ce490e1e5d3"],
                },
              },
              {
                _uid: "966b5fe7-d69f-45a8-b75e-1ce490e1e5d3",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "db67e93b-5a5b-47e5-bfe3-afad41425063_c24e59ab-bd97-41f3-b931-8f67fd77ed20",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f6f6c1d8-82db-4db2-8fce-14d252a19e6e",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement is not intended to apply to user accounts on point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals).",
                  "This requirement does not supersede multi-factor authentication (MFA) requirements but applies to those in-scope systems not otherwise subject to MFA requirements.",
                  "A digital certificate is a valid option for “something you have” if it is unique for a particular user.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "543419f5-e78c-4396-900f-46907d71e2a2",
                component: "col",
                label: "",
                simplifiedLabel: "8.3.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "75d5cff6-680f-49a9-bb43-6c9b960f1c87",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Strong cryptography is used to render all authentication factors unreadable during transmission and storage on all system components.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "da6b0ac3-0344-4689-9ebd-c23a31dfba4a",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine vendor documentation.",
                  "Examine system configuration settings.",
                  "Examine repositories of authentication factors.",
                  "Examine data transmissions.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "1e64147e-8248-4431-b987-6b43c0a87b72",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["da740389-046e-4afd-975f-a999a1dafbaa"],
                },
              },
              {
                _uid: "da740389-046e-4afd-975f-a999a1dafbaa",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "76b383d4-c683-4c09-a5e7-4fbb86d6878b_1e64147e-8248-4431-b987-6b43c0a87b72",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "766c3a5c-c1d1-4bdd-bf22-da8b9f82f559",
                component: "col",
                label: "",
                simplifiedLabel: "8.3.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "279fae04-ed03-4960-b6b0-404e72bfb0d3",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "User identity is verified before modifying any authentication factor.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "510c4c3b-ab4b-4754-ba6b-05d995d58c82",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine procedures for modifying authentication factors.",
                  "Observe security personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "aceb2cf5-7241-45af-925f-33e038def041",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["9461e5b5-1202-45f7-8378-8b7093e77197"],
                },
              },
              {
                _uid: "9461e5b5-1202-45f7-8378-8b7093e77197",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "ab45fe2c-7147-4dd6-a8fc-8d475b5e743e_aceb2cf5-7241-45af-925f-33e038def041",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 40
          {
            fields: [
              {
                _uid: "8daa3b0e-d25c-442f-bc7d-0557f6e4a1bc",
                component: "col",
                label: "",
                simplifiedLabel: "8.3.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "867e2c3c-93b5-420b-ae26-21b9d20d3644",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Invalid authentication attempts are limited by:",
                  "Locking out the user ID after not more than 10 attempts.",
                  "Setting the lockout duration to a minimum of 30 minutes or until the user’s identity is confirmed.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "6a04380a-da08-4d42-93a3-07c0184c45d6",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine system configuration settings."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "a9c7f4f1-ef9c-416a-9976-72e028628074",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["817a616b-5cef-4497-af1c-f5b05663a7d2"],
                },
              },
              {
                _uid: "817a616b-5cef-4497-af1c-f5b05663a7d2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "69e438c0-0dc9-43cf-bd96-bfed70a2fc8f_a9c7f4f1-ef9c-416a-9976-72e028628074",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "db51907a-e243-4d79-ab61-602425ac64b3",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement is not intended to apply to user accounts within point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals).",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "216d3f23-7b61-4859-bc2e-e8e57d8daef4",
                component: "col",
                label: "",
                simplifiedLabel: "8.3.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "1d8fa345-59fa-4a65-af73-9202c37d399b",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "If passwords/passphrases are used as authentication factors to meet Requirement 8.3.1, they are set and reset for each user as follows:",
                  "Set to a unique value for first-time use and upon reset.",
                  "Forced to be changed immediately after the first use.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7ee884c2-e85f-4b86-8c43-1602586cbac1",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine procedures for setting and resetting passwords/passphrases.",
                  "Observe security personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "32b9e151-ac03-405e-b1b7-3ac1593c64cc",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["5203277d-bb88-4a4d-a747-bcae4ab04ae3"],
                },
              },
              {
                _uid: "5203277d-bb88-4a4d-a747-bcae4ab04ae3",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "53dee0b2-bf62-4b05-8f9d-e843efd62e5c_32b9e151-ac03-405e-b1b7-3ac1593c64cc",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "bd78a6dc-5a65-4a74-9662-c8eb980364cd",
                component: "col",
                label: "",
                simplifiedLabel: "8.3.6",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "7c03cf66-6a9a-46d6-8417-071256cd3f12",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "If passwords/passphrases are used as authentication factors to meet Requirement 8.3.1, they meet the following minimum level of complexity:",
                  "A minimum length of 12 characters (or IF the system does not support 12 characters, a minimum length of eight characters).",
                  "Contain both numeric and alphabetic characters.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c44255b1-3760-4dc0-b00a-03c555048c72",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine system configuration settings."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "69868741-8916-44b5-987d-ff409346bbc6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["3e9d1ad8-5d11-4647-b9d0-7ec663c55802"],
                },
              },
              {
                _uid: "3e9d1ad8-5d11-4647-b9d0-7ec663c55802",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "c310118e-25a8-41c7-b38d-3c440b3151f8_69868741-8916-44b5-987d-ff409346bbc6",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ac039ae5-6c62-4641-84f2-f9b0724cec4e",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement is not intended to apply to:",
                  "User accounts on point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals)",
                  "Application or system accounts, which are governed by requirements in section 8.6.",
                  "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
                  "Until 31 March 2025, passwords must be a minimum length of seven characters in accordance with PCI DSS v3.2.1 Requirement 8.2.3.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 41
          {
            fields: [
              {
                _uid: "b01174cf-cdee-49d1-9502-b695c0c0f804",
                component: "col",
                label: "",
                simplifiedLabel: "8.3.7",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "2f34005a-f311-4ddf-9420-780c17a567d0",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Individuals are not allowed to submit a new password/passphrase that is the same as any of the last four passwords/passphrases used.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c5b7fdc0-2d8b-480f-bcfd-723862f27c81",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine system configuration settings"],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "b3247b69-da29-4cfe-82f9-af09212d724f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["f1d906fe-3cb1-48ef-b8fb-2cbdb11b9ceb"],
                },
              },
              {
                _uid: "f1d906fe-3cb1-48ef-b8fb-2cbdb11b9ceb",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "8b0ef447-e9b0-4445-89bc-a807e78abd31_b3247b69-da29-4cfe-82f9-af09212d724f",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a5bf8266-4b6f-47c7-b60b-fe8540c91c90",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement is not intended to apply to user accounts within point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals).",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e5725162-c53f-47d0-882e-fb29814d123f",
                component: "col",
                label: "",
                simplifiedLabel: "8.3.8",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "ffb4fd30-de9f-482c-8b27-586b65ccaf8c",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Authentication policies and procedures are documented and communicated to all users including:",
                  "Guidance on selecting strong authentication factors.",
                  "Guidance for how users should protect their authentication factors.",
                  "Instructions not to reuse previously used passwords/passphrases.",
                  "Instructions to change passwords/passphrases if there is any suspicion or knowledge that the password/passphrases have been compromised and how to report the incident.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "43c4a6fc-d894-4ed8-aabd-0c8790d6c078",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine procedures.",
                  "Interview personnel.",
                  "Review authentication policies and procedures that are distributed to users.",
                  "Interview users.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "f381e3ab-d51d-4cd5-88e2-2fb251a767ea",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["bff226a7-24ac-433f-a67c-bb36971da9f2"],
                },
              },
              {
                _uid: "bff226a7-24ac-433f-a67c-bb36971da9f2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "543f8cc4-16c9-4f82-bae9-cc1bcf22df1c_f381e3ab-d51d-4cd5-88e2-2fb251a767ea",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 42
          {
            fields: [
              {
                _uid: "66cab423-4b8e-4dbc-92ab-f6df88a22a7b",
                component: "col",
                label: "",
                simplifiedLabel: "8.3.9",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "d74788a1-32c6-4e57-9488-d6fb5318f2c4",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "If passwords/passphrases are used as the only authentication factor for user access (i.e., in any singlefactor authentication implementation) then either:",
                  "Passwords/passphrases are changed at least once every 90 days,",
                  "OR",
                  "The security posture of accounts is dynamically analyzed, and real-time access to resources is automatically determined accordingly.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "95fd771c-9321-45ed-ae12-cf92b6a27295",
                component: "col",
                label: [],
                simplifiedLabel: ["Inspect system configuration settings."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c04e9d48-f2e3-4667-b836-d76b09697fb1",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["678c3c00-a2b8-48cb-bbc0-427d82b8f135"],
                },
              },
              {
                _uid: "678c3c00-a2b8-48cb-bbc0-427d82b8f135",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "7eee08b0-4539-40b5-851b-3dce6d7e6ce5_c04e9d48-f2e3-4667-b836-d76b09697fb1",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "cd62d353-b5b8-4305-95bd-b8111d5193f6",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement applies to in-scope system components that are not in the CDE because these components are not subject to MFA requirements.",
                  "This requirement is not intended to apply to user accounts on point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals).",
                  "This requirement does not apply to service providers’ customer accounts but does apply to accounts for service provider personnel.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a3b32a17-c61f-43bf-9d6a-4b99841212cc",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "8.4 Multi-factor authentication (MFA) is implemented to secure access into the CDE.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c1c1ab3e-c846-4250-b130-de74e13d98c8",
                component: "col",
                label: "",
                simplifiedLabel: "8.4.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "c63d52d1-fa62-4f41-aa6b-1f856a923a60",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "MFA is implemented for all non-console access into the CDE for personnel with administrative access.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "e1023dc6-fdc0-4718-ba08-5a2e80a542d9",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine network and/or system configurations.",
                  "Observe administrator personnel logging into the CDE.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "9d22302f-75d3-48e1-aad6-1449c30c6ba8",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["108de7fb-40f0-44b9-b059-6bd1b45905e5"],
                },
              },
              {
                _uid: "108de7fb-40f0-44b9-b059-6bd1b45905e5",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "f5f0b6c5-1934-43d0-ad99-006ec6b8714e_9d22302f-75d3-48e1-aad6-1449c30c6ba8",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6b276bf9-a51f-4a1f-bfc7-416f9317aeda",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "The requirement for MFA for non-console administrative access applies to all personnel with elevated or increased privileges accessing the CDE via a non-console connection—that is, via logical access occurring over a network interface rather than via a direct, physical connection.",
                  "MFA is considered a best practice for non-console administrative access to in-scope system components that are not part of the CDE.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 43
          {
            fields: [
              {
                _uid: "58d6134f-5fe9-487f-94c3-5b368a33ced1",
                component: "col",
                label: "",
                simplifiedLabel: "8.4.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "58249164-6524-4dec-96e1-8b6c7febc8e5",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "MFA is implemented for all access into the CDE.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "01de56a2-ca6b-4d9c-befd-e6a101e41ace",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine network and/or system configurations.",
                  "Observe personnel logging in to the CDE.Examine evidence.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c444739f-b439-42b8-8d1a-cec6de08badc",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["e64b2fdf-f14a-4c03-a8ca-b0dea000baff"],
                },
              },
              {
                _uid: "e64b2fdf-f14a-4c03-a8ca-b0dea000baff",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "54dc12a4-372b-4e89-837f-de0d965ca0a6_c444739f-b439-42b8-8d1a-cec6de08badc",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "84120890-22be-41f0-9fa1-cc9bb699735d",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement does not apply to:",
                  "MFA is considered a best practice for non-console administrative access to in-scope system components that are not part of the CDE.",
                  "User accounts on point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals).",
                  "MFA is required for both types of access specified in Requirements 8.4.2 and 8.4.3. Therefore, applying MFA to one type of access does not replace the need to apply another instance of MFA to the other type of access. If an individual first connects to the entity’s network via remote access, and then later initiates a connection into the CDE from within the network, per this requirement the individual would authenticate using MFA twice, once when connecting via remote access to the entity’s network and once when connecting via non-console administrative access from the entity’s network into the CDE.",
                  "The MFA requirements apply for all types of system components, including cloud, hosted systems, and on-premises applications, network security devices, workstations, servers, and endpoints, and includes access directly to an entity’s networks or systems as well as web-based access to an application or function.",
                  "MFA for remote access into the CDE can be implemented at the network or system/application level; it does not have to be applied at both levels. For example, if MFA is used when a user connects to the CDE network, it does not have to be used when the user logs into each system or application within the CDE.",
                  "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 44
          {
            fields: [
              {
                _uid: "0c26c53c-23aa-4ecb-b0e2-ae34228e4ac6",
                component: "col",
                label: "",
                simplifiedLabel: "8.4.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "41615fae-f822-4218-831a-b5c19beea915",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "MFA is implemented for all remote network access originating from outside the entity’s network that could access or impact the CDE as follows:",
                  "All remote access by all personnel, both users and administrators, originating from outside the entity’s network.",
                  "All remote access by third parties and vendors.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "4e976d20-9c1e-4f6d-b9e9-212d21b6a549",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine network and/or system configurations for remote access servers and systems.",
                  "Observe personnel (for example, users and administrators) connecting remotely to the network.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "2dbbaf98-0f34-479c-a150-be4f75a95a35",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["4b385bb5-79e7-4639-85a1-a2974366070a"],
                },
              },
              {
                _uid: "4b385bb5-79e7-4639-85a1-a2974366070a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "235aff7a-2a09-467a-9a16-f2b225eadcd5_2dbbaf98-0f34-479c-a150-be4f75a95a35",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4d5150af-e5a4-4386-b3a0-11e26b99326a",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "The requirement for MFA for remote access originating from outside the entity’s network applies to all user accounts that can access the network remotely, where that remote access leads to or could lead to access into the CDE.",
                  "If remote access is to a part of the entity’s network that is properly segmented from the CDE, such that remote users cannot access or impact the CDE, MFA for remote access to that part of the network is not required. However, MFA is required for any remote access to networks with access to the CDE and is recommended for all remote access to the entity’s networks.",
                  "The MFA requirements apply for all types of system components, including cloud, hosted systems, and on-premises applications, network security devices, workstations, servers, and endpoints, and includes access directly to an entity’s networks or systems as well as web-based access to an application or function.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 45
          {
            fields: [
              {
                _uid: "c362c8ad-8c01-4d58-890c-3acfebe21bda",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "8.5 Multi-factor authentication (MFA) systems are configured to prevent misuse.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a731ac80-5726-4c72-854f-9ae4b751e647",
                component: "col",
                label: "",
                simplifiedLabel: "8.5.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "5d2fab98-5084-4a2d-b964-9799c69d77aa",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "MFA systems are implemented as follows:",
                  "The MFA system is not susceptible to replay attacks.",
                  "MFA systems cannot be bypassed by any users, including administrative users unless specifically documented, and authorized by management on an exception basis, for a limited time period.",
                  "At least two different types of authentication factors are used.",
                  "Success of all authentication factors is required before access is granted.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "1f44d720-8c20-4f6d-bf85-e3083372f8b3",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine vendor system documentation.",
                  "Examine system configurations for the MFA implementation.",
                  "Interview responsible personnel and observe processes.",
                  "Observe personnel logging into system components in the CDE.",
                  "Observe personnel connecting remotely from outside the entity’s network.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e7908971-3a76-4188-93ef-fc2b10b17ab8",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["da6ef752-f600-45b8-8fa0-83b0a126a326"],
                },
              },
              {
                _uid: "da6ef752-f600-45b8-8fa0-83b0a126a326",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "10c7b9e2-d95d-4957-99b4-179a6cbe29fe_e7908971-3a76-4188-93ef-fc2b10b17ab8",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "855ad24d-56a8-4a11-a5be-1a04b0344dac",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 46
          {
            fields: [
              {
                _uid: "b6a89697-f0ed-41b3-bdf9-5cf44173dbf1",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "8.6 Use of application and system accounts and associated authentication factors is strictly managed.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ada64ca0-279e-485e-bca3-9995fd258a67",
                component: "col",
                label: "",
                simplifiedLabel: "8.6.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "79ce9938-757f-4138-bc48-8269b8f32d21",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "If accounts used by systems or applications can be used for interactive login, they are managed as follows:",
                  "Interactive use is prevented unless needed for an exceptional circumstance.",
                  "Interactive use is limited to the time needed for the exceptional circumstance.",
                  "Business justification for interactive use is documented.",
                  "Interactive use is explicitly approved by management. ",
                  "Individual user identity is confirmed before access to account is granted.",
                  "Every action taken is attributable to an individual user.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "f8db322a-b1de-44a5-9b7b-e6bd99d13b0a",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine application and system accounts that can be used interactively.",
                  "Interview administrative personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6f15115f-c352-4f9f-a1e7-30be29367fec",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["11cfcc62-38b6-4506-a2c2-a9e04c8e91c0"],
                },
              },
              {
                _uid: "11cfcc62-38b6-4506-a2c2-a9e04c8e91c0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "2b5b44c7-9fcf-4edb-bab1-dc6d8a4cd02b_6f15115f-c352-4f9f-a1e7-30be29367fec",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "35af2ce3-1c1d-4a86-8019-d63903b3802b",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 47
          {
            fields: [
              {
                _uid: "9c4dcf3a-cd24-485f-bcaf-49be7351b4e2",
                component: "col",
                label: "",
                simplifiedLabel: "8.6.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "eaccbb82-d3c3-4882-80bf-05d785499db6",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Passwords/passphrases for any application and system accounts that can be used for interactive login are not hard coded in scripts, configuration/property files, or bespoke and custom source code.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "eaccbb82-d3c3-4882-80bf-05d785499db6",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Interview personnel.",
                  "Examine system development procedures.",
                  "Examine scripts, configuration/property files, and bespoke and custom source code for application and system accounts that can be used for interactive login.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "1268a0cf-cef2-43db-9ee7-61059ae1b579",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["8cd77e1e-7271-4e7b-a24e-be1c4e8e3a6a"],
                },
              },
              {
                _uid: "8cd77e1e-7271-4e7b-a24e-be1c4e8e3a6a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "fde1da7b-44a2-46a9-aea8-87aebefd3fa3_1268a0cf-cef2-43db-9ee7-61059ae1b579",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f7114d40-969d-4a18-b40e-9706342cba24",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "Stored passwords/passphrases are required to be encrypted in accordance with PCI DSS Requirement 8.3.2.",
                  "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "290e646c-4729-436e-8f9d-267b83213cdb",
                component: "col",
                label: "",
                simplifiedLabel: "8.6.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "0ded9dd7-766e-4f9e-961d-b6a021bf3973",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Passwords/passphrases for any application and system accounts are protected against misuse as follows:",
                  "Passwords/passphrases are changed periodically (at the frequency defined in the entity’s targeted risk analysis, which is performed according to all elements specified in Requirement 12.3.1) and upon suspicion or confirmation of compromise.",
                  "Passwords/passphrases are constructed with sufficient complexity appropriate for how frequently the entity changes the passwords/passphrases.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "fe1dee4d-fe07-488c-8e63-6f11817eaf66",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine the targeted risk analysis.",
                  "Interview responsible personnel.",
                  "Examine system configuration settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "56867429-4f9c-4ac3-9612-d8e4690441a6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["06fe46d3-6c1f-465a-80ce-a0fe63a43997"],
                },
              },
              {
                _uid: "06fe46d3-6c1f-465a-80ce-a0fe63a43997",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "69d7cd6f-38b3-468d-83eb-a0fe5a677f42_56867429-4f9c-4ac3-9612-d8e4690441a6",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2abc9f49-8587-42ce-aa08-aaa854bd4dd7",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 48
          {
            fields: [
              {
                _uid: "5ff2d3cc-81a4-4980-ad5f-75ba593bc2ba",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Requirement 9: Restrict Physical Access to Cardholder Data",
                  "9.1 Processes and mechanisms for restricting physical access to cardholder data are defined and understood.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "48ebf674-42fa-4a67-8079-eecc59db7f74",
                component: "col",
                label: "",
                simplifiedLabel: "9.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "5765427a-3e13-420f-a5ae-072194fb985c",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "All security policies and operational procedures that are identified in Requirement 9 are:",
                  "Documented.",
                  "Kept up to date.",
                  "In use.",
                  "Known to all affected parties.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "dbf515a5-0e5b-46f5-9078-fb6cd7f33c34",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documentation.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "243e3d46-9aff-4b8b-bb52-4026204038b7",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["d79a4fb2-1fa9-4463-9ef4-464e4c478b2e"],
                },
              },
              {
                _uid: "d79a4fb2-1fa9-4463-9ef4-464e4c478b2e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "cd718d02-1f34-44a7-8f33-3c1a1c11585f_243e3d46-9aff-4b8b-bb52-4026204038b7",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "24bcc4dd-0301-4b10-b4cb-0478c2c4030e",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "9.2 Physical access controls manage entry into facilities and systems containing cardholder data.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "94745004-b9f8-40e0-bbdc-2ca7bf397498",
                component: "col",
                label: "",
                simplifiedLabel: "9.2.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "8d42f66c-eee4-4591-92d0-0d5310d67008",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Appropriate facility entry controls are in place to restrict physical access to systems in the CDE.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "9c257aa1-22d9-43c2-bae4-90a3fd9c6094",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Observe physical entry controls.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3d9893fc-fa09-4ac4-b178-e1099bce48f1",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["aebffedf-6179-48c3-90f1-481bc13fa6f6"],
                },
              },
              {
                _uid: "aebffedf-6179-48c3-90f1-481bc13fa6f6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "598a46fc-38b0-4f87-8c46-d7fdf23da0d7_3d9893fc-fa09-4ac4-b178-e1099bce48f1",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d02160ea-74b4-44c0-a2a7-e49e255cb2fb",
                component: "col",
                label: "",
                simplifiedLabel: "9.2.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "5a9f3472-0fbf-43d1-a9bd-acb08d158cfa",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Individual physical access to sensitive areas within the CDE is monitored with either video cameras or physical access control mechanisms (or both) as follows:",
                  "Entry and exit points to/from sensitive areas within the CDE are monitored.",
                  "Monitoring devices or mechanisms are protected from tampering or disabling.",
                  "Collected data is reviewed and correlated with other entries.",
                  "Collected data is stored for at least three months, unless otherwise restricted by law.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "0fca3374-1201-428a-bace-f7e07a78f197",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Observe locations where individual physical access to sensitive areas within the CDE occurs.",
                  "Observe the physical access control mechanisms and/or examine video cameras",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e98ceedd-20ca-473b-b815-a2f448e79c99",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["6ffea6fd-a801-413c-9b3b-b6d33cd85834"],
                },
              },
              {
                _uid: "6ffea6fd-a801-413c-9b3b-b6d33cd85834",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "67e3c291-f699-41c1-8f7e-cede9dbb2b9a_e98ceedd-20ca-473b-b815-a2f448e79c99",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 49
          {
            fields: [
              {
                _uid: "4fed6408-ec90-4137-8f84-68fba9b83845",
                component: "col",
                label: "",
                simplifiedLabel: "9.2.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "4d4fbfa2-16f0-49e0-977f-ced87eb61ef8",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Physical and/or logical controls are implemented to restrict use of publicly accessible network jacks within the facility.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "4697d81a-2c1a-40f4-9d7c-c427a2fd601c",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Interview responsible personnel.",
                  "Observe locations of publicly accessible network jacks.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "d73b8a97-5d86-4d97-950d-8f2ade1e6fdb",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["3b27480b-4b80-42dd-801a-6dd7b97eaee0"],
                },
              },
              {
                _uid: "3b27480b-4b80-42dd-801a-6dd7b97eaee0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "9b59a447-5287-466d-acb2-a0f450477d32_d73b8a97-5d86-4d97-950d-8f2ade1e6fdb",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f11d6700-9682-4b75-8738-d7f365fbea84",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "9.4 Media with cardholder data is securely stored, accessed, distributed, and destroyed",
                  "Note: For SAQ A, Requirements at 9.4 only apply to merchants with paper records (for example, receipts or printed reports) with account data, including primary account numbers (PANs).",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4c3f557d-062f-46f0-b03b-071e4ec85580",
                component: "col",
                label: "",
                simplifiedLabel: "9.4.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "b4275cb6-d1a0-4aad-962a-81eca6797a3d",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "All media with cardholder data is physically secured.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "bf86bc8a-7749-4e06-b3e1-aafea66e3776",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine documentation."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "99cc17e4-17d7-4109-becc-9064d032bd9b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["6cbb57e7-95b1-4fd2-877d-295a8bef66b4"],
                },
              },
              {
                _uid: "6cbb57e7-95b1-4fd2-877d-295a8bef66b4",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "84acaaf1-a5a5-4c3b-a749-f1d0c4c750df_99cc17e4-17d7-4109-becc-9064d032bd9b",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "23ffa6e0-e476-4657-8e49-f2cb57ad3160",
                component: "col",
                label: "",
                simplifiedLabel: "9.4.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "15bea25a-dee9-49a4-a13a-43d4e8d15833",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Offline media backups with cardholder data are stored in a secure location.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "9787c557-3cb0-4c01-81d2-1815e4a4245a",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented procedures",
                  "Examine logs or other documentation.",
                  "Interview responsible personnel at the storge location(s).",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ccb7da28-a7dc-4d17-afca-538b5a2623d6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["9d7c8138-1b5e-436d-b107-b32e3246e33f"],
                },
              },
              {
                _uid: "9d7c8138-1b5e-436d-b107-b32e3246e33f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "f58249c1-95b2-4dfd-92e4-bd8190dbc2d7_ccb7da28-a7dc-4d17-afca-538b5a2623d6",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0f840cb7-20c4-425e-8d84-28d7cf3b05c2",
                component: "col",
                label: "",
                simplifiedLabel: "9.4.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "7566d8bd-dc01-4126-abf7-d1c65c394911",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "All media with cardholder data is classified in accordance with the sensitivity of the data.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c8763cdf-8c1f-44ea-9947-326b82f4c5bf",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented procedures",
                  "Examine media logs or other documentation.",
                  "Examine files and system records on system components where account data is stored.",
                  "Observe the mechanisms used to render account data unrecoverable.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e719cb38-b7e2-4ba4-9fcf-d6fe507d6ce4",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["2d4d4c83-1815-47a0-9e97-16d70558c192"],
                },
              },
              {
                _uid: "2d4d4c83-1815-47a0-9e97-16d70558c192",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "a4cc0dfa-947a-425b-b79b-329e6ce3ddce_e719cb38-b7e2-4ba4-9fcf-d6fe507d6ce4",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "be442b22-f06d-405e-8dec-431533521ca2",
                component: "col",
                label: "",
                simplifiedLabel: "9.4.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "7f9c3bb5-a30d-4d00-95c5-ebdfea7dddc8",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Media with cardholder data sent outside the facility is secured as follows:",
                  "Bullet intentionally left blank for this SAQ",
                  "Media is sent by secured courier or other delivery method that can be accurately tracked.",
                  "Bullet intentionally left blank for this SAQ.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "b34e6135-e337-450c-ae2c-ea043cb8ae9d",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented procedures",
                  "Interview personnel.",
                  "Examine records.",
                  "Examine offsite tracking logs for all media.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "dd7593a7-d618-429a-b464-025e2535c248",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["bfa73c2f-7001-4c55-982d-f29f494d0969"],
                },
              },
              {
                _uid: "bfa73c2f-7001-4c55-982d-f29f494d0969",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "87e5202e-67ab-49b9-9f35-c3057fd67214_dd7593a7-d618-429a-b464-025e2535c248",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "81a4691f-6a9f-4633-a177-94fe569d4b93",
                component: "col",
                label: "",
                simplifiedLabel: "9.4.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "363845f6-6128-48e8-87ef-782991eacedd",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Management approves all media with cardholder data that is moved outside the facility (including when media is distributed to individuals)",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "94bbd7bf-cbe3-47a7-9894-8a3d47750e93",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented procedures",
                  "Examine offsite media tracking logs.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "948511ec-2a1e-45c1-b976-a3cce9f2c9f3",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["45a9876d-77c4-4520-9ca1-9acbbc1101cb"],
                },
              },
              {
                _uid: "45a9876d-77c4-4520-9ca1-9acbbc1101cb",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "186b4b62-0497-4eab-bbc7-6958249fc430_948511ec-2a1e-45c1-b976-a3cce9f2c9f3",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "cddc0d95-b2b5-4e47-b4ea-88b36ea362bb",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "Individuals approving media movements should have the appropriate level of management authority to grant this approval. However, it is not specifically required that such individuals have “manager” as part of their title.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 50
          {
            fields: [
              {
                _uid: "649db51c-4b88-4c99-9a3c-874bedd87a52",
                component: "col",
                label: "",
                simplifiedLabel: "9.4.6",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "2b90d8e7-6f69-4347-91bc-eede1b1de2ea",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Hard-copy materials with cardholder data are destroyed when no longer needed for business or legal reasons, as follows:",
                  "Materials are cross-cut shredded, incinerated, or pulped so that cardholder data cannot be reconstructed.",
                  "Materials are stored in secure storage containers prior to destruction.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "378422e9-6e23-4d6b-b78a-74f871487bbd",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine the periodic media destruction policy",
                  "Observe processes.",
                  "Interview personnel.",
                  "Observe storage containers.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "b23f3713-d931-41dc-a567-d0138d9850f7",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["ded23702-84be-405b-9b6c-dcb71b207a98"],
                },
              },
              {
                _uid: "ded23702-84be-405b-9b6c-dcb71b207a98",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "facda98e-e5aa-4a6e-9a61-181fdd172c2f_b23f3713-d931-41dc-a567-d0138d9850f7",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "9c669dfe-a5e0-417f-aafd-f7d568ffec31",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "These requirements for media destruction when that media is no longer needed for business or legal reasons are separate and distinct from PCI DSS Requirement 3.2.1, which is for securely deleting cardholder data when no longer needed per the entity’s cardholder data retention policies.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "cbcb71ef-7f0c-4c64-a6b5-091aa7d994b6",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for Requirements at 9.4 means that the merchant securely stores any paper media with account data, for example by storing the paper in a locked drawer, cabinet, or safe, and that the merchant destroys such paper when no longer needed for business purposes. This includes a written document or policy for employees, so they know how to secure paper with account data and how to destroy the paper when no longer needed.",
                  "If the merchant never stores any paper with account data, mark this requirement as Not Applicable and complete Appendix C: Explanation of Requirements Noted as Not Applicable.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 51
          {
            fields: [
              {
                _uid: "d35dfffe-7841-4a04-8610-9a9d30998cd2",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "9.5 Point-of-interaction (POI) devices are protected from tampering and unauthorized substitution.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2df529fc-2681-41e6-aa5d-dc6bf3ce9b22",
                component: "col",
                label: "",
                simplifiedLabel: "9.5.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "c0838b9b-b5ec-488d-bf7b-5b168a886c9a",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "POI devices that capture payment card data via  direct physical interaction with the payment card  form factor are protected from tampering and  unauthorized substitution, including the following:",
                  "Maintaining a list of POI devices. ",
                  "Periodically inspecting POI devices to look for  tampering or unauthorized substitution.",
                  "Training personnel to be aware of suspicious  behavior and to report tampering or unauthorized  substitution of devices",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "aeee10df-685f-4e29-a112-73240f12948d",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented policies and  procedures.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c0076a59-585a-46a2-a716-dca7afe832d9",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["02328d86-5b2d-429a-81ab-1041c7c093f3"],
                },
              },
              {
                _uid: "02328d86-5b2d-429a-81ab-1041c7c093f3",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "bfa06bcf-fb4e-43c2-b0ac-79b4d6cb5767_c0076a59-585a-46a2-a716-dca7afe832d9",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "74eec7be-e990-40fe-a558-50d2ea92ae11",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "These requirements apply to deployed POI devices used in card-present transactions (that is,  a payment card form factor such as a card that is swiped, tapped, or dipped). This requirement  is not intended to apply to manual PAN key-entry components such as computer keyboards.",
                  "This requirement is recommended, but not required, for manual PAN key-entry components  such as computer keyboards.",
                  "This requirement does not apply to commercial off-the-shelf (COTS) devices (for example,  smartphones or tablets), which are mobile merchant-owned devices designed for mass-market  distribution.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "191ece1d-9dce-4030-b0f7-4f3d4b39389e",
                component: "col",
                label: "",
                simplifiedLabel: "9.5.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "3edaeabf-ab05-4f43-b036-5fdc6f62f7d9",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "An up-to-date list of POI devices is maintained,  including:",
                  " Make and model of the device.  ",
                  "Location of device",
                  "Device serial number or other methods of unique  identification",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "5a9f9d29-4936-4746-b2c6-358f71283775",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine the list of POI devices",
                  "Observe POI devices and device locations",
                  "Interview personnel. ",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "97495965-1f0d-403e-8105-d1bb414d5d4c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["37923e72-cb5a-4fb8-a6bd-d2ec82a0278e"],
                },
              },
              {
                _uid: "37923e72-cb5a-4fb8-a6bd-d2ec82a0278e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "fbd1b5c2-2af1-4253-a149-6259fd46ddcb_97495965-1f0d-403e-8105-d1bb414d5d4c",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2a3d5e1f-02ea-4fa1-b81a-53fdcfb7b835",
                component: "col",
                label: "",
                simplifiedLabel: "9.5.1.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "e2f24060-204e-4e35-9e5b-5406d2a78822",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "POI device surfaces are periodically inspected to  detect tampering and unauthorized substitution.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "849401d3-ee9f-41c3-abf4-904f5bd637b9",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented procedures. ",
                  "Interview responsible personnel.",
                  "Observe inspection processes.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "0d82b1eb-2d9a-458f-930b-a8f6573484c8",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["9bebe301-04bf-45cb-8a88-e0147e06b9ea"],
                },
              },
              {
                _uid: "9bebe301-04bf-45cb-8a88-e0147e06b9ea",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "e96eba94-b3d1-4c18-9277-a959c80252ac_0d82b1eb-2d9a-458f-930b-a8f6573484c8",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 52
          {
            fields: [
              {
                _uid: "d3d8a72f-8498-4416-849f-a536b4deade4",
                component: "col",
                label: "",
                simplifiedLabel: "9.5.1.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "d39c7ede-6718-4b64-8d06-b911502802f3",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Training is provided for personnel in POI  environments to be aware of attempted tampering or  replacement of POI devices, and includes:",
                  "Verifying the identity of any third-party persons  claiming to be repair or maintenance personnel,  before granting them access to modify or  troubleshoot devices.",
                  "Procedures to ensure devices are not installed,  replaced, or returned without verification.",
                  "Being aware of suspicious behavior around  devices.",
                  "Reporting suspicious behavior and indications of  device tampering or substitution to appropriate  personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "f94e32b7-7fb4-4978-884e-9335322de0df",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Review training materials for  personnel in POI environments.",
                  "Interview responsible personnel",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "8c2a9724-e048-41f1-96dc-0d54756726f6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["8f9a9b1c-c354-42a1-b3f9-0f9400477676"],
                },
              },
              {
                _uid: "8f9a9b1c-c354-42a1-b3f9-0f9400477676",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "7329c05a-acf5-4018-9eb6-32c2c687b75d_8c2a9724-e048-41f1-96dc-0d54756726f6",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6ec34fab-3ae4-4409-b0bb-285f3566aff9",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for Requirements at 9.5 means that the merchant has policies and procedures in place for Requirements 9.5.1,  9.5.1.1, 9.5.1.2, and 9.5.1.3, and that they maintain a current list of devices, conduct periodic device inspections, and train employees about what to look for to  detect tampered or substituted devices.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 53
          {
            fields: [
              {
                _uid: "e0e759d9-3d8b-436a-93eb-6c74916e8f8b",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: [
                  "Regularly Monitor and Test Networks",
                  "Requirement 10: Log and Monitor All Access to System Components and Cardholder Data",
                  "10.1 Processes and mechanisms for logging and monitoring all access to system components and cardholder data are defined and documented.",
                ],
                subBoldLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d7980d5c-52ef-4e88-b4fa-60c5e519c1bb",
                component: "col",
                label: "",
                simplifiedLabel: "10.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "18f96243-6a7f-45ef-a1a6-1d1c785e0f20",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "All security policies and operational procedures that are identified in Requirement 10 are:",
                  "Documented.",
                  "Kept up to date.",
                  "In use.",
                  "Known to all affected parties.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "f1c06d79-774f-4578-8ac7-72f33759f2ae",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documentation.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6f49fdbb-ad9f-4d7a-ae40-2f1a61c2c947",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["30182585-5055-4209-9e5b-e54795fd955a"],
                },
              },
              {
                _uid: "30182585-5055-4209-9e5b-e54795fd955a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "ca5920c5-2bb8-4ead-9fad-8a6d3af1cc45_6f49fdbb-ad9f-4d7a-ae40-2f1a61c2c947",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "121324d0-1f1e-451a-b698-bdf026b8fe10",
                component: "col",
                label: "",
                boldLabel: [
                  "10.2 Audit logs are implemented to support the detection of anomalies and suspicious activity, and the forensic analysis of events",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "431e00e8-9f35-4d97-9d18-a0185d6c02a5",
                component: "col",
                label: "",
                simplifiedLabel: "10.2.1.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "3979f38a-0ec7-4a1c-97a3-d02f6ecd2e0d",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Audit logs capture all actions taken by any individual with administrative access, including any interactive use of application or system accounts.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "2a092b0f-52f5-4ad3-9e17-689836c3b539",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine audit log configurations.",
                  "Examine audit log data.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "0924deaa-c9e0-43d1-9629-284bcabb556d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["d1b52425-d0d5-42f0-b007-e1d8f47e9f3d"],
                },
              },
              {
                _uid: "d1b52425-d0d5-42f0-b007-e1d8f47e9f3d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "d0bfd09c-b744-4c11-b3bb-51ef97482257_0924deaa-c9e0-43d1-9629-284bcabb556d",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1d21a70c-38f3-4ea0-92c2-01d16a04667b",
                component: "col",
                label: "",
                simplifiedLabel: "10.2.1.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "eadf3587-f82b-4d05-99ef-bf1082264d6b",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Audit logs capture all invalid logical access attempts.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "d3f10a6d-beb2-4d51-8319-07e14b492f2d",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine audit log configurations.",
                  "Examine audit log data.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "af2dc40d-9bff-4941-b487-21efcd512176",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["587d5e6b-83ca-4979-8808-a7bff802da8a"],
                },
              },
              {
                _uid: "587d5e6b-83ca-4979-8808-a7bff802da8a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "d370e915-1b01-4395-aad2-ecf73ce9a208_af2dc40d-9bff-4941-b487-21efcd512176",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "fa9ab642-5cef-4d4c-8e9b-80fd5300ccc5",
                component: "col",
                label: "",
                simplifiedLabel: "10.2.1.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "fb388928-d662-4ccf-9e67-cdba513c6851",
                component: "col",
                label: [],
                simplifiedLabel: [],
                labelWithUl: {
                  label: "",
                  simplifiedLabel:
                    "Audit logs capture all changes to identification and authentication credentials including, but not limited to:",
                  ul: [
                    "Creation of new accounts.",
                    "• Elevation of privileges",
                    "All changes, additions, or deletions to accounts with administrative access.",
                  ],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "3713db85-7a7a-4f59-82ca-4c07906bcbf8",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine audit log configurations.",
                  "Examine audit log data.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e25036e0-9f23-407e-aacd-b3cb14a13b90",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["2d8d9108-c5b4-43b4-b815-51179a27eb2d"],
                },
              },
              {
                _uid: "2d8d9108-c5b4-43b4-b815-51179a27eb2d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "ad4a06b3-3364-49f8-8a3d-6d54d1675cd0_e25036e0-9f23-407e-aacd-b3cb14a13b90",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 54
          {
            fields: [
              {
                _uid: "2eba8df1-efa1-410b-982d-ca6af9547121",
                component: "col",
                label: "",
                simplifiedLabel: "10.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "b0f9ff05-84ca-4dca-9590-5a82173401ae",
                component: "col",
                label: [],
                simplifiedLabel: [""],
                labelWithUl: {
                  label: "",
                  simplifiedLabel:
                    "Audit logs record the following details for each auditable event:",
                  ul: [
                    "User identification.",
                    "Type of event",
                    "Date and time.",
                    "Success and failure indication",
                    "Origination of event.",
                    "• Identity or name of affected data, system component, resource, or service (for example, name and protocol).",
                  ],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "793b0905-9e7f-47f3-8545-53da7b4a373b",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Interview responsible personnel",
                  "Examine audit log configurations.",
                  "Examine audit log data.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "0989a337-8e20-4704-b727-a45c44c2a9f3",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["7a819644-5368-41c5-aefc-a708a5e300b0"],
                },
              },
              {
                _uid: "7a819644-5368-41c5-aefc-a708a5e300b0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "f0f3de91-e63e-4de9-9ece-534fbb7e305e_0989a337-8e20-4704-b727-a45c44c2a9f3",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "38c6b643-8e88-4fc9-b780-6c239ef904b5",
                component: "col",
                label: "",
                boldLabel: [
                  "10.3 Audit logs are protected from destruction and unauthorized modifications",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b6faad0b-ba25-47f7-91e6-d824452c15da",
                component: "col",
                label: "",
                simplifiedLabel: "10.3.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "6441ecf7-e30a-4cfc-a988-c78152e7c024",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Read access to audit logs files is limited to those with a job-related need.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "86033a0f-6704-4397-98d1-b18f154941eb",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Interview system administrators.",
                  "Examine system configurations and privileges",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "2b114170-0532-4a0a-90e6-ae6a8f652b0d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["e74472ef-85eb-4e4f-b801-215988e79dbf"],
                },
              },
              {
                _uid: "e74472ef-85eb-4e4f-b801-215988e79dbf",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "646dcd19-cf74-48f6-86b4-110c8f63af24_2b114170-0532-4a0a-90e6-ae6a8f652b0d",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e55bbfac-1de5-4894-8fe1-acf529120f1d",
                component: "col",
                label: "",
                simplifiedLabel: "10.3.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "a829c51e-37d2-4386-8b49-30a57ed1f5c7",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Audit log files are protected to prevent modifications by individuals.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "cd974290-7777-47a0-8271-43c9590a0755",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine system configurations and privileges",
                  "Interview system administrators.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e90db5e6-004f-44c9-a10c-f1f8546f78c1",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["d1ff014c-1fb9-40a8-9d3d-9bae2e5c29d0"],
                },
              },
              {
                _uid: "d1ff014c-1fb9-40a8-9d3d-9bae2e5c29d0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "646dcd19-cf74-48f6-86b4-110c8f63af24_e90db5e6-004f-44c9-a10c-f1f8546f78c1",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5e9c8d01-5cbd-4355-9c46-ee2f650e12f2",
                component: "col",
                label: "",
                simplifiedLabel: "10.3.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "a829c51e-37d2-4386-8b49-30a57ed1f5c7",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Audit log files, including those for external-facing technologies, are promptly backed up to a secure, central, internal log server(s) or other media that is difficult to modify.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "cd974290-7777-47a0-8271-43c9590a0755",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine backup configurations or log files"],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "5ac8d604-b11c-4106-b3df-f2bcc32f8c1a",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["574743cb-8875-49e5-b7f8-05bd17c3da6a"],
                },
              },
              {
                _uid: "574743cb-8875-49e5-b7f8-05bd17c3da6a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "19a49034-c268-49fc-ab30-203317e9fbae_5ac8d604-b11c-4106-b3df-f2bcc32f8c1a",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b990bfd4-1a23-4113-9340-8ea45ebf723a",
                component: "col",
                label: "",
                simplifiedLabel: "10.3.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "81379e17-8eac-493f-95de-3fa3d789e8ed",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "File integrity monitoring or change-detection mechanisms is used on audit logs to ensure that existing log data cannot be changed without generating alerts.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "25ef34c0-854e-4b61-8640-753728d8ea63",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine system settings.",
                  "Examine monitored files. • Examine results from monit",
                  "Examine results from monitoring activities",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "577eb8b3-4785-4de3-8873-458c81bedea6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["582d6b28-6d27-4762-be39-e563195f1b1f"],
                },
              },
              {
                _uid: "582d6b28-6d27-4762-be39-e563195f1b1f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "7a39040f-4a4f-4cb7-be8c-64f7d3740b62_577eb8b3-4785-4de3-8873-458c81bedea6",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 55
          {
            fields: [
              {
                _uid: "2e9cd614-5acb-40fc-b835-b2a30f5acd29",
                component: "col",
                label: "",
                boldLabel: [
                  "10.4 Audit logs are reviewed to identify anomalies or suspicious activity.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5e71be1e-eac7-446e-8f46-fb69fa14c4ff",
                component: "col",
                label: "",
                simplifiedLabel: "10.4.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "0ab1775b-9c48-4f3a-a230-54132e60b7d4",
                component: "col",
                label: [],
                simplifiedLabel: [],
                labelWithUl: {
                  label: "",
                  simplifiedLabel:
                    "The following audit logs are reviewed at least once daily:",
                  ul: [
                    "All security events. ",
                    "Logs of all system components that store, process, or transmit CHD and/or SAD.",
                    "Logs of all critical system components.",
                    "Logs of all servers and system components that perform security functions (for example, network security controls, intrusion-detection systems/intrusion-prevention systems (IDS/IPS), authentication servers).",
                  ],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "213f5993-6dde-40f7-acd3-05510b933f27",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine security policies and procedures.",
                  "Observe processes.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "95efcd76-f7d7-45b2-b2cd-fc26b6a370a7",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["ec91bd42-ad86-4727-a136-ef40a4cae306"],
                },
              },
              {
                _uid: "ec91bd42-ad86-4727-a136-ef40a4cae306",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "c0e319c2-ef13-412f-9a58-c2c2130287d1_95efcd76-f7d7-45b2-b2cd-fc26b6a370a7",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "04a44cf4-8b98-439d-964e-ef9476f966e1",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: "Applicability Notes for 10.4.1.1",
                subBoldLabel: [
                  "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "9ec91589-5d30-489e-8cb5-83ae0f62014d",
                component: "col",
                label: "",
                simplifiedLabel: "10.4.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "1e7dd178-197c-4c23-9800-27f2d8105569",
                component: "col",
                label: [],
                simplifiedLabel: [],
                labelWithUl: {
                  label: "",
                  simplifiedLabel:
                    "Automated mechanisms are used to perform audit log reviews.",
                  ul: [],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "af53b33a-d07d-4d1c-a60c-c86e4e441daf",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine log review mechanisms",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "a8121f0b-fcce-4b32-98f1-83b7cca5f5d5",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["9430d525-a165-45a3-9753-35f0c0498c69"],
                },
              },
              {
                _uid: "9430d525-a165-45a3-9753-35f0c0498c69",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "680c3789-f76d-4604-b5da-6d1e4c4ed0bd_a8121f0b-fcce-4b32-98f1-83b7cca5f5d5",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d0b3ee1e-2392-4d98-9d66-9868490f4a6d",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: "Applicability Notes for 10.4.2",
                subBoldLabel: [
                  "This requirement is applicable to all other in-scope system components not included in Requirement 10.4.1.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7f1bee72-ef13-492b-beca-9f39222e2e87",
                component: "col",
                label: "",
                simplifiedLabel: "10.4.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "8f0a0a98-dc50-4011-8771-88f0a7004ddb",
                component: "col",
                label: [],
                simplifiedLabel: [],
                labelWithUl: {
                  label: "",
                  simplifiedLabel:
                    "Logs of all other system components (those not specified in Requirement 10.4.1) are reviewed periodically.",
                  ul: [],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "815866f0-28b8-4784-a328-3f8a0e93d342",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine security policies and procedures.",
                  "Examine documented results of log reviews",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "1b1cd8ef-34cc-4abd-8bfc-bc00150c7424",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["05922ca2-7b75-41b9-9a08-6783a3272a0b"],
                },
              },
              {
                _uid: "05922ca2-7b75-41b9-9a08-6783a3272a0b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "84695b43-2799-4d2b-9563-669a60a72c48_1b1cd8ef-34cc-4abd-8bfc-bc00150c7424",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 56
          {
            fields: [
              {
                _uid: "df5ac485-8381-427e-b27a-5968e2441988",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: "Applicability Notes for 10.4.2.1",
                subBoldLabel: [
                  "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "abe4603b-66ae-4b17-b2d9-e5a29280e6c3",
                component: "col",
                label: "",
                simplifiedLabel: "10.4.2.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "843fd7ee-4350-4cd1-9b96-860389afc7c8",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "The frequency of periodic log reviews for all other system components (not defined in Requirement 10.4.1) is defined in the entity’s targeted risk analysis, which is performed according to all elements specified in Requirement 12.3.1.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "323ce01f-5fdc-42fd-96f1-7cbe6188886e",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine the targeted risk analysis",
                  "• Examine documented results of periodic log reviews.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "abc72c86-8f45-43ed-9391-2b139ade85a8",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["e29544b8-f280-4cf6-b8fb-3506ac69135f"],
                },
              },
              {
                _uid: "e29544b8-f280-4cf6-b8fb-3506ac69135f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "636a0ce3-a8a8-479a-aa81-d2878fc51ab2_abc72c86-8f45-43ed-9391-2b139ade85a8",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ffdcac76-644f-4bd1-9780-09f4aabd9abb",
                component: "col",
                label: "",
                simplifiedLabel: "10.4.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "60f4e930-7474-40b7-9494-1f2f9962c973",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Exceptions and anomalies identified during the review process are addressed.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "43e7107e-74c7-414f-96ea-1bf2be25e6cf",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine security policies and procedures.",
                  "Observe processes",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "af84ab2d-5d17-4aee-9026-0ec1cf7d7d2b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["7b897dd5-d3fa-494e-bfb0-81552145d9a5"],
                },
              },
              {
                _uid: "7b897dd5-d3fa-494e-bfb0-81552145d9a5",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "772038da-c4c4-4180-a822-a105ed0306eb_af84ab2d-5d17-4aee-9026-0ec1cf7d7d2b",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5d411ea8-9667-4767-8a79-b7d0a967a2ca",
                component: "col",
                label: "",
                boldLabel: [
                  "10.5 Audit log history is retained and available for analysis.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4d323a5e-ae84-4383-b991-0ca8d5e87e4d",
                component: "col",
                label: "",
                simplifiedLabel: "10.5.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "46d41bdd-ac0c-45c7-b22d-5a977a381c2a",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Retain audit log history for at least 12 months, with at least the most recent three months immediately available for analysis.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c13aa19d-7c3d-45e2-8f1f-7e8f4d7aa06e",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented audit log retention policies and procedures",
                  "Examine configurations of audit log history.",
                  "Examine audit logs.",
                  "Interview personnel.",
                  "Observe processes",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "1d1b4acd-fd8e-4851-8646-6f7b6f123973",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["aa232693-e542-444f-bfdc-8bf3679f4ebb"],
                },
              },
              {
                _uid: "aa232693-e542-444f-bfdc-8bf3679f4ebb",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "b8eb3093-b3ba-4eb5-b9f9-fa39527fb457_1d1b4acd-fd8e-4851-8646-6f7b6f123973",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "eb509213-34c1-4308-b721-fc8be6794bac",
                component: "col",
                label: "",
                boldLabel: [
                  "10.6 Time-synchronization mechanisms support consistent time settings across all systems.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c8a04713-99e1-4899-82e8-92cad9ced0c9",
                component: "col",
                label: "",
                simplifiedLabel: [],
                boldLabel: "Applicability Notes for 10.6.1",
                subBoldLabel: [
                  "Keeping time-synchronization technology current includes managing vulnerabilities and patching the technology according to PCI DSS Requirements 6.3.1 and 6.3.3.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "99baf295-a6a6-43e0-8a83-484901cde2b2",
                component: "col",
                label: "",
                simplifiedLabel: "10.6.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "aca14e6f-e21b-4123-8d96-1529d59ca472",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "System clocks and time are synchronized using timesynchronization technology.",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel: "",
                  ul: [],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "a7fb4ce1-3924-4250-9f74-10db50064aad",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine system configuration settings."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "23f6546f-4be5-47bd-b8df-694da76df679",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["c41db651-ede3-4a3b-9f40-2bb5406f93f7"],
                },
              },
              {
                _uid: "c41db651-ede3-4a3b-9f40-2bb5406f93f7",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "dd67c98b-4adb-4981-a116-f0d87c8877f7_23f6546f-4be5-47bd-b8df-694da76df679",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 57
          {
            fields: [
              {
                _uid: "c1476d29-5eda-4c9c-a576-80245f5d6ee7",
                component: "col",
                label: "",
                simplifiedLabel: "10.6.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "064fd482-4c94-4419-8cd3-03f4f3d1ee70",
                component: "col",
                label: [],
                simplifiedLabel: [],
                labelWithUl: {
                  label: "",
                  simplifiedLabel:
                    "Systems are configured to the correct and consistent time as follows:",
                  ul: [
                    "One or more designated time servers are in use.",
                    "Only the designated central time server(s) receives time from external sources.",
                    "Time received from external sources is based on International Atomic Time or Coordinated Universal Time (UTC).",
                    "The designated time server(s) accept time updates only from specific industry-accepted external sources.",
                    "Where there is more than one designated time server, the time servers peer with one another to keep accurate time.",
                    "Internal systems receive time information only from designated central time server(s).",
                  ],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "6eeb51ec-c24d-4880-a38c-d397c6acd802",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine system configuration settings for acquiring, distributing, and storing the correct time",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "2c0a4a78-54fd-4720-b9b4-463b13219f9c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["fa716d9f-924a-4e5f-96a3-2aadbe958da7"],
                },
              },
              {
                _uid: "fa716d9f-924a-4e5f-96a3-2aadbe958da7",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "e6c25841-f1d0-41e2-964d-4951e6a36f05_2c0a4a78-54fd-4720-b9b4-463b13219f9c",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e534e06b-d4c1-4da3-8fc2-f5581b7c50c4",
                component: "col",
                label: "",
                simplifiedLabel: "10.6.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "2586bd19-65f7-476e-8e44-36d2d455add8",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Time synchronization settings and data are protected as follows:",
                ],
                labelWithUl: {
                  label: "",
                  simplifiedLabel:
                    "Systems are configured to the correct and consistent time as follows:",
                  ul: [
                    "Access to time data is restricted to only personnel with a business need.",
                    "Any changes to time settings on critical systems are logged, monitored, and reviewed.",
                  ],
                },
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "45f6797e-c8b0-4b70-b1b4-f652ddb24500",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine system configurations and time-synchronization settings and logs",
                  "Observe processes.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "41bc93a6-1d29-4ccb-b19a-9999803dc362",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["1f3af8ea-0a72-4005-bce0-9aed267f1f60"],
                },
              },
              {
                _uid: "1f3af8ea-0a72-4005-bce0-9aed267f1f60",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "cbe63c83-c790-491c-a7da-60b736e70263_41bc93a6-1d29-4ccb-b19a-9999803dc362",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 58
          {
            fields: [
              {
                _uid: "c17a4ed8-380e-4481-9221-6b7ee9ab3df3",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "11.2 Wireless access points are identified and monitored, and unauthorized wireless access points are addressed.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "16d92b4d-4aa8-45b2-9240-cfcae5492043",
                component: "col",
                label: "",
                simplifiedLabel: "11.2.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "437d8d32-9aa5-4232-b9ec-652b0a6bb130",
                component: "col",
                label: [],

                simplifiedLabel: [
                  "Authorized and unauthorized wireless access points are managed as follows: ",
                  "The presence of wireless (Wi-Fi) access points is tested for.",
                  "All authorized and unauthorized wireless access points are detected and identified.",
                  "Testing, detection, and identification occurs at least once every three months.",
                  " If automated monitoring is used, personnel are notified via generated alerts",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "f341e9fe-199b-4abb-b40e-bd18d8c3f7f0",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine the methodology(ies) in use and the resulting documentation.",
                  "Interview personnel.",
                  "Examine wireless assessment results.",
                  "Examine configuration settings.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "dba398e2-396a-4dbe-b373-52e791412d62",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["125a6934-7a23-447e-aeae-d796bde693ed"],
                },
              },
              {
                _uid: "125a6934-7a23-447e-aeae-d796bde693ed",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "a888501a-c9f7-43e7-85a9-ff6a5bf97951_dba398e2-396a-4dbe-b373-52e791412d62",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "74389fec-83f5-4070-998c-e3915d1c3954",
                component: "col",
                label: "",
                boldLabel: ["Applicability Notes"],
                simplifiedLabel: [
                  "The requirement applies even when a policy exists that prohibits the use of wireless technology since attackers do not read and follow company policy.",
                  "Methods used to meet this requirement must be sufficient to detect and identify both authorized and unauthorized devices, including unauthorized devices attached to devices that themselves are authorized.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "db539bdf-48f4-4469-aca3-1dd0ae7c24e0",
                component: "col",
                label: "",
                simplifiedLabel: "11.2.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "9b330da6-53c0-4410-84ef-3b91dcc0b158",
                component: "col",
                label: [],

                simplifiedLabel: [
                  "An inventory of authorized wireless access points is maintained, including a documented business justification.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "54266553-67a3-47f4-9c76-e5db45b17da7",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine documentation."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "a70d4ce5-9cdd-4543-80ec-b7f8403b6ac6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["0d04ea0d-6857-435b-9ebc-88cb52d0a748"],
                },
              },
              {
                _uid: "0d04ea0d-6857-435b-9ebc-88cb52d0a748",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "52a0309b-07ab-409a-aead-407a35de711f_a70d4ce5-9cdd-4543-80ec-b7f8403b6ac6",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 59
          {
            fields: [
              {
                _uid: "70603f1b-7346-4ef6-a2ad-95b190125fe8",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "11.3 External and internal vulnerabilities are regularly identified, prioritized, and addressed.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1b2cde64-d17b-4581-b282-f78c6dc4a01d",
                component: "col",
                label: "",
                simplifiedLabel: "11.3.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "6e30624a-a7bb-4139-874d-8deb80b90c90",
                component: "col",
                label: [],

                simplifiedLabel: [
                  "Internal vulnerability scans are performed as follows:",
                  "At least once every three months.",
                  "High-risk and critical vulnerabilities (per the entity’s vulnerability risk rank",
                  "Rescans are performed that confirm all high-risk and critical vulnerabilities as noted above) have been resolved.",
                  "Scan tool is kept up to date with latest vulnerability information.",
                  "Scans are performed by qualified personnel and organizational independence of the tester exists.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "3eda9b87-038e-410f-9547-1a2d2e115f02",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine internal scan report results.",
                  "Examine scan tool configurations",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "76e4a34a-50ed-43e7-a0bc-8ba848261abb",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["720fb0d4-e0b7-4055-accd-0828c1be18c9"],
                },
              },
              {
                _uid: "720fb0d4-e0b7-4055-accd-0828c1be18c9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "7d91fee8-0ae5-42c1-af1f-7624a5faacaa_76e4a34a-50ed-43e7-a0bc-8ba848261abb",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f710705d-efc1-4f7e-8f56-834bc2b6ea2d",
                component: "col",
                label: "",
                boldLabel: ["Applicability Notes"],
                simplifiedLabel: [
                  "It is not required to use a QSA or ASV to conduct internal vulnerability scans.",
                  "Internal vulnerability scans can be performed by qualified, internal staff that are reasonably independent of the system component(s) being scanned (for example, a network administrator should not be responsible for scanning the network), or an entity may choose to have internal vulnerability scans performed by a firm specializing in vulnerability scanning.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8037de20-7bf3-40f2-8dbd-f06e10110347",
                component: "col",
                label: "",
                simplifiedLabel: "11.3.1.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "9b8c1874-bea7-47ba-85f0-a7b61c424f49",
                component: "col",
                label: [],

                simplifiedLabel: [
                  "Internal vulnerability scans are performed after any significant change as follows:",
                  "High-risk and critical vulnerabilities (per the entity’s vulnerability risk rankings defined at Requirement 6.3.1) are resolved.",
                  "Rescans are conducted as needed",
                  "Scans are performed by qualified personnel and organizational independence of the tester exists (not required to be a QSA or ASV).",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7945f560-223f-452d-90d1-7f21327a6290",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine change control documentation.",
                  "Interview personnel.",
                  "Examine internal scan and rescan report as applicable.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "47ec580f-b2c3-4e38-a73e-0ab534bf317e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["de9ff331-028c-471b-9d41-32e02b420fac"],
                },
              },
              {
                _uid: "de9ff331-028c-471b-9d41-32e02b420fac",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "951a2d75-0127-4ee0-ba0d-10d0e09b1c60_47ec580f-b2c3-4e38-a73e-0ab534bf317e",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "733200bc-eefd-457f-a72c-ce22320e51e0",
                component: "col",
                label: "",
                boldLabel: ["Applicability Notes"],
                simplifiedLabel: [
                  "Applicability Note intentionally left blank for this SAQ.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 60
          {
            fields: [
              {
                _uid: "7288bbf0-60d8-4a36-897b-735c94a66596",
                component: "col",
                label: "",
                simplifiedLabel: "11.3.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "6e30624a-a7bb-4139-874d-8deb80b90c90",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "External vulnerability scans are performed as follows:",
                  "At least once every three months.",
                  "By PCI SSC Approved Scanning Vendor (ASV).",
                  "Vulnerabilities are resolved and ASV Program Guide requirements for a passing scan are met.",
                  "Rescans are performed as needed to confirm that vulnerabilities are resolved per the ASV Program Guide requirements for a passing scan.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "66875b2e-3fc8-4364-9498-8fb3bdff349a",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine ASV scan reports."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e2d203c9-1b3b-4f9c-9b94-0e0fefb53642",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["d13ee76d-f01a-401d-9a22-b353542b8119"],
                },
              },
              {
                _uid: "d13ee76d-f01a-401d-9a22-b353542b8119",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "79b24d5b-165d-49e2-b5d5-2843dc948c35_e2d203c9-1b3b-4f9c-9b94-0e0fefb53642",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7288bbf0-60d8-4a36-897b-735c94a66596",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "For initial PCI DSS compliance, it is not required that four passing scans be completed within 12 months if the assessor verifies: 1) the most recent scan result was a passing scan, 2) the entity has documented policies and procedures requiring scanning at least once every three months, and 3) vulnerabilities noted in the scan results have been corrected as shown in a re-scan(s).",
                  "However, for subsequent years after the initial PCI DSS assessment, passing scans at least every three months must have occurred.",
                  "ASV scanning tools can scan a vast array of network types and topologies. Any specifics about the target environment (for example, load balancers, third-party providers, ISPs, specific configurations, protocols in use, scan interference) should be worked out between the ASV and scan customer.",
                  "Refer to the ASV Program Guide published on the PCI SSC website for scan customer responsibilities, scan preparation, etc.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0db7d5b7-8537-43e3-9746-1329ed95ff77",
                component: "col",
                label: "",
                simplifiedLabel: "11.3.2.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "deaa3d47-31a8-42b6-bd2a-70a8e248b539",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "External vulnerability scans are performed after any significant change as follows:",
                  "Vulnerabilities that are scored 4.0 or higher by the CVSS are resolved.",
                  "Rescans are conducted as needed.",
                  "Scans are performed by qualified personnel and organizational independence of the tester exists (not required to be a QSA or ASV).",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "0eca287e-74a1-46bd-80f7-4758b7a87737",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine change control documentation.",
                  "Interview personnel.",
                  "Examine external scan, and as applicable rescan reports.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "36b4ac54-08d6-4c41-8a8d-02ef8e554c8e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["871dc2d0-3b04-422e-aaf6-25cb249636cb"],
                },
              },
              {
                _uid: "871dc2d0-3b04-422e-aaf6-25cb249636cb",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "46c6eaf5-1768-453a-86db-64c76ef47dd7_36b4ac54-08d6-4c41-8a8d-02ef8e554c8e",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 61
          {
            fields: [
              {
                _uid: "c59990af-d4f1-4783-bdd8-a3bbd8a0cc35",
                component: "col",
                label: "",
                simplifiedLabel:
                  "11.4 External and internal penetration testing is regularly performed, and exploitable vulnerabilities and security weaknesses are corrected.",
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: "5",
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "40e29b01-d613-42e4-9e6c-4095e7bd59b0",
                component: "col",
                label: "",
                simplifiedLabel: "11.4.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "f4fd7449-8177-4c06-ae0d-94f4dc9f3ae9",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "If segmentation is used to isolate the CDE from other networks, penetration tests are performed on segmentation controls as follows:",
                  "At least once every 12 months and after any changes to segmentation controls/methods.",
                  "Covering all segmentation controls/methods in use.",
                  "According to the entity’s defined penetration testing methodology.",
                  "Confirming that the segmentation controls/methods are operational and effective, and isolate the CDE from all out-of-scope systems.",
                  "Confirming effectiveness of any use of isolation to separate systems with differing security levels (see Requirement 2.2.3).",
                  "Performed by a qualified internal resource or qualified external third party.",
                  "Organizational independence of the tester exists (not required to be a QSA or ASV).",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "2edd3e31-9a1e-4c3e-8f05-7eb2f6411bfc",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine segmentation controls.",
                  "Review penetration-testing methodology.",
                  "Examine the results from the most recent penetration test.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "b06a9af6-6718-49a3-8e57-9d5ce1578b59",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["57f0f713-9675-4140-988e-c2fb14ffec91"],
                },
              },
              {
                _uid: "57f0f713-9675-4140-988e-c2fb14ffec91",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "b6818945-0bb6-4a14-a90e-98aaa9acc387_b06a9af6-6718-49a3-8e57-9d5ce1578b59",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "bccc14f5-48f0-4094-a06b-6cf6cec4d456",
                component: "col",
                label: "",
                simplifiedLabel:
                  "11.5 Network intrusions and unexpected file changes are detected and responded to.",
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: "5",
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2d4d7216-6f13-4cb4-a389-3d507fd85538",
                component: "col",
                label: "",
                simplifiedLabel: "11.5.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "714ebdf6-cdbc-4f1f-a77b-f7b76840bf24",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "A change-detection mechanism (for example, file integrity monitoring tools) is deployed as follows:",
                  "To alert personnel to unauthorized modification (including changes, additions, and deletions) of critical files.",
                  "To perform critical file comparisons at least once weekly.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "579be970-6603-4a0d-bbc2-07164ed41e85",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine system settings for the change-detection mechanism.",
                  "Examine monitored files.",
                  "Examine results from monitoring activities.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c1258e5f-ce0f-4285-8cca-15ea685ab432",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["833db74e-3c16-4d5e-b9b8-213d13e2dc90"],
                },
              },
              {
                _uid: "833db74e-3c16-4d5e-b9b8-213d13e2dc90",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "45abe556-0e72-4f2b-add8-33033661624f_c1258e5f-ce0f-4285-8cca-15ea685ab432",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c161c3db-51a4-4034-b73c-85f7a5873710",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "For change-detection purposes, critical files are usually those that do not regularly change, but the modification of which could indicate a system compromise or risk of compromise. Changedetection mechanisms such as file integrity monitoring products usually come pre-configured with critical files for the related operating system. Other critical files, such as those for custom applications, must be evaluated and defined by the entity (that is, the merchant or service provider).",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: "5",
                width: "100%",
              },
            ],
          },
          // 62 NA
          // 63
          {
            fields: [
              {
                _uid: "6dd7b146-10e9-4d4f-9048-e9f77d80dd61",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Maintain an Information Security Policy ",
                  "Requirement 12: Support Information Security with Organizational Policies and Programs",
                  "Note: Requirement 12 specifies that merchants have information security policies for their personnel, but these policies can be as simple or complex as needed for the size and complexity of the merchant’s operations. The policy document must be provided to all personnel, so they are aware of their responsibilities for protecting payment terminals, any paper documents with account data, etc. If a merchant has no employees, then it is expected that the merchant understands and acknowledges their responsibility for security within their store(s).",
                  "12.1 A comprehensive information security policy that governs and provides direction for protection of the entity’s information assets is known and current.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "9f7bfbea-c236-4a45-bb82-bdd5992db13d",
                component: "col",
                label: "",
                simplifiedLabel: "12.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "dc8a701d-5d4e-4eab-ba5e-5e16dad06bdf",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "An overall information security policy is:",
                  "Established.",
                  "Published.",
                  "Maintained.",
                  "Disseminated to all relevant personnel, as well as to relevant vendors and business partners.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "b2478530-4596-4892-a82e-1fb096625a93",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine the information security policy.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "55903b10-e7da-4d62-b274-02c9818868ea",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["15058b10-aa73-40c1-b228-17c921368cb7"],
                },
              },
              {
                _uid: "15058b10-aa73-40c1-b228-17c921368cb7",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "4db4bb06-7b67-41eb-8bad-48aee4f96e37_55903b10-e7da-4d62-b274-02c9818868ea",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "62183b4a-1273-4869-9441-c580cc766ec0",
                component: "col",
                label: "",
                simplifiedLabel: "12.1.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "42bbd809-fef6-447a-9cf7-60879829f17c",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "The information security policy is:",
                  "Reviewed at least once every 12 months.",
                  "Updated as needed to reflect changes to business objectives or risks to the environment.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "9626341d-b28e-4a9b-a309-4272df1c3cab",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine the information security policy.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "8341e3bc-9f2f-4fef-910a-284f63611735",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["63869559-eebe-461b-9869-c971184b9465"],
                },
              },
              {
                _uid: "63869559-eebe-461b-9869-c971184b9465",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "a5ae8af7-5372-43a2-a923-c18b311f0087_8341e3bc-9f2f-4fef-910a-284f63611735",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f03ac641-721b-4f97-b625-801fa4ab24d7",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for Requirements 12.1.1 and 12.1.2 means that the merchant has a security policy that is reasonable for the size and complexity of the merchant’s operations, and that the policy is reviewed at least once every 12 months and updated if needed.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 64
          {
            fields: [
              {
                _uid: "0b1cb061-16b0-4f7e-b322-0a4d16c8ac27",
                component: "col",
                label: "",
                simplifiedLabel: "12.1.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "389028ab-c7fa-407f-95ee-58130ebf02e3",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "The security policy clearly defines information security roles and responsibilities for all personnel, and all personnel are aware of and acknowledge their information security responsibilities.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "e77fd33b-5de4-4e76-98ab-238a21eba4ff",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine the information security policy.",
                  "Interview responsible personnel.",
                  "Examine documented evidence.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "4ea0321a-a184-4484-9210-3e3dab854b3d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["256cc24f-0f7e-4766-b03c-023897e2821b"],
                },
              },
              {
                _uid: "256cc24f-0f7e-4766-b03c-023897e2821b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "9738ca8e-87ff-4821-96f8-499549069f2b_4ea0321a-a184-4484-9210-3e3dab854b3d",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4dd76e90-3d78-4858-9005-6f7159216f06",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for Requirement 12.1.3 means that the merchant’s security policy defines basic security responsibilities for all personnel, consistent with the size and complexity of the merchant’s operations. For example, security responsibilities could be defined according to basic responsibilities by employee levels, such as the responsibilities expected of a manager/owner and those expected of clerks.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d1e592d7-090e-44cf-a292-b4e576e12be8",
                component: "col",
                label: "",
                simplifiedLabel: "12.1.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "26baf9de-cf9e-4e1d-90c3-009872b9589c",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Responsibility for information security is formally assigned to a Chief Information Security Officer or other information security knowledgeable member of executive management.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "4f9ab6d8-5952-437d-a9b5-bc787e7ba049",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine the information security policy."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "a2f3e53c-aef6-4f8e-8d1c-b9dfd514ef09",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["7862fd23-b272-4da6-aff4-25bccbdc43ec"],
                },
              },
              {
                _uid: "7862fd23-b272-4da6-aff4-25bccbdc43ec",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "3bbc771d-0a79-455e-abc4-4cde7cef39c6_a2f3e53c-aef6-4f8e-8d1c-b9dfd514ef09",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 65
          {
            fields: [
              {
                _uid: "fcbd86db-5e4d-435b-82dd-9299ada5917c",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "12.3 Risks to the cardholder data environment are formally identified, evaluated, and managed.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0a97befc-98c4-497f-b069-05e69a3497cf",
                component: "col",
                label: "",
                simplifiedLabel: "12.3.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "29d8625f-9321-4390-a7a6-3c88f5e22c06",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Each PCI DSS requirement that provides flexibility for how frequently it is performed (for example, requirements to be performed periodically) is supported by a targeted risk analysis that is documented and includes:",
                  "Identification of the assets being protected",
                  "Identification of the threat(s) that the requirement is protecting against.",
                  "Identification of factors that contribute to the likelihood and/or impact of a threat being realized.",
                  "Resulting analysis that determines, and includes justification for, how frequently the requirement must be performed to minimize the likelihood of the threat being realized.",
                  "Review of each targeted risk analysis at least once every 12 months to determine whether the results are still valid or if an updated risk analysis is needed.",
                  "Review of each targeted risk analysis at least once every 12 months to determine whether the results are still valid or if an updated risk analysis is needed.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "b168760e-0f29-4584-9f17-4fba1c108432",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented policies and procedures.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ffca3e33-de1d-441c-adc6-c8fa4821205f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["a8919011-18af-4f5a-810c-11e82dbff64d"],
                },
              },
              {
                _uid: "a8919011-18af-4f5a-810c-11e82dbff64d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "8f76449d-080e-442b-a691-2ce5691a5811_ffca3e33-de1d-441c-adc6-c8fa4821205f",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "873c40ef-f0b2-4e05-a2ee-1237c4e69c67",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 66
          {
            fields: [
              {
                _uid: "c1afa99d-ad6d-4461-9139-f341e5833b0d",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "12.6 Security awareness education is an ongoing activity.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "083ffed5-ff71-44f5-92bc-fcb1f3a04984",
                component: "col",
                label: "",
                simplifiedLabel: "12.6.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "81ae63ca-e228-4b67-8091-c2496eefe51c",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "A formal security awareness program is implemented to make all personnel aware of the entity’s information security policy and procedures, and their role in protecting the cardholder data.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "690a3893-8e57-427d-9bdb-97d71543c236",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine the security awareness program."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6c4632ed-6148-4812-a77a-88a2bda3c51c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["7f8d2c8d-c196-4c0b-a2d2-d9d7366e6bba"],
                },
              },
              {
                _uid: "7f8d2c8d-c196-4c0b-a2d2-d9d7366e6bba",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "dbea4bea-cfaa-4fb4-9cd4-2f7fc941782d_6c4632ed-6148-4812-a77a-88a2bda3c51c",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7798b136-a68c-4003-857c-696f35a287c5",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for Requirement 12.6.1 means that the merchant has a security awareness program in place, consistent with the size and complexity of the merchant’s operations. For example, a simple awareness program could be a flyer posted in the back office, or a periodic e-mail sent to all employees. Examples of awareness program messaging include descriptions of security tips all employees should follow, such as how to lock doors and storage containers.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5874316d-23a3-4684-82db-80f7b1b4f4da",
                component: "col",
                label: "",
                simplifiedLabel: "12.6.3.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "00c1f941-b9d1-438d-b698-2de36cf9a9d0",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Security awareness training includes awareness of threats and vulnerabilities that could impact the security of the CDE, including but not limited to:",
                  "Phishing and related attacks.",
                  "Social engineering.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "f6bfd3d1-587a-444c-ba39-4e76758be004",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine security awareness training content.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ebe3785c-2511-472c-9bbe-e666e3ff4165",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["de7ed07d-3162-4d1e-816d-99c7f704921a"],
                },
              },
              {
                _uid: "de7ed07d-3162-4d1e-816d-99c7f704921a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "e663ed59-1cf0-44b2-b6ab-41c27f5c2007_ebe3785c-2511-472c-9bbe-e666e3ff4165",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b94f216f-b0e8-43c8-bd16-daf47acec034",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "See Requirement 5.4.1 in PCI DSS for guidance on the difference between technical and automated controls to detect and protect users from phishing attacks, and this requirement for providing users security awareness training about phishing and social engineering. These are two separate and distinct requirements, and one is not met by implementing controls required by the other one.",
                  "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 67
          {
            fields: [
              {
                _uid: "96b8eb3f-59ca-442b-8bd9-2ebeb9f72a9a",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "12.8 Risk to information assets associated with third-party service provider (TPSP) relationships is managed.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "cc5339ec-0c9f-4993-8e81-356e1e3fd060",
                component: "col",
                label: "",
                simplifiedLabel: "12.8.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "77750b12-f26e-4a06-8a86-60b23e7c0506",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "A list of all third-party service providers (TPSPs) with which account data is shared or that could affect the security of account data is maintained, including a description for each of the services provided.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "49c99066-16d7-4180-af4c-5f4286ebce7b",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine list of TPSPs.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6513c7da-3894-4c92-ba89-bf75834c1b21",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["33370b6f-8461-41d8-ad6d-3061f80a4103"],
                },
              },
              {
                _uid: "33370b6f-8461-41d8-ad6d-3061f80a4103",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "8bb4cc1d-ae6b-4d26-b468-2c605db60a1b_6513c7da-3894-4c92-ba89-bf75834c1b21",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "30eee53d-e324-4335-b5d7-ef8e70b81e37",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "The use of a PCI DSS compliant TPSP does not make an entity PCI DSS compliant, nor does it remove the entity’s responsibility for its own PCI DSS compliance.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "93c2b8d3-1684-47ad-9f1d-6c7f99d64797",
                component: "col",
                label: "",
                simplifiedLabel: "12.8.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "0d26a7c8-27e5-49a5-b1ed-7b389ed75e1f",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Written agreements with TPSPs are maintained as follows:",
                  "Written agreements are maintained with all TPSPs with which account data is shared or that could affect the security of the CDE.",
                  "Written agreements include acknowledgments from TPSPs that they are responsible for the security of account data the TPSPs possess or otherwise store, process, or transmit on behalf of the entity, or to the extent that they could impact the security of the entity’s CDE.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "5598f7ca-0246-4e5e-9c78-d6a4d7c24123",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine written agreements with TPSPs.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "63fff20d-a022-42b9-8c16-bfec89f01384",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["172fb8df-2d5a-4fa8-9f2d-411e93dc6bd7"],
                },
              },
              {
                _uid: "172fb8df-2d5a-4fa8-9f2d-411e93dc6bd7",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "3abb8bce-42fa-4b9b-b1fb-f2b092511beb_63fff20d-a022-42b9-8c16-bfec89f01384",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6de5cd7f-12c3-42a8-897c-2074683b3215",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "The exact wording of an acknowledgment will depend on the agreement between the two parties, the details of the service being provided, and the responsibilities assigned to each party. The acknowledgment does not have to include the exact wording provided in this requirement.",
                  "Evidence that a TPSP is meeting PCI DSS requirements (for example, a PCI DSS Attestation of Compliance (AOC) or a declaration on a company’s website) is not the same as a written agreement specified in this requirement.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "13257d1f-e538-4fe9-92c2-91ab87cfaa6f",
                component: "col",
                label: "",
                simplifiedLabel: "12.8.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "6ef366ed-51a1-4b28-b96c-4f269458a0cc",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "An established process is implemented for engaging TPSPs, including proper due diligence prior to engagement.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "856d5de2-514c-42df-b12a-b212d63033f9",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine evidence.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c33690f2-0813-4a47-80f3-bc1fc453cb67",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["8159ad20-54db-4a0f-a16c-f82fa1910fd6"],
                },
              },
              {
                _uid: "8159ad20-54db-4a0f-a16c-f82fa1910fd6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "248c3931-0589-458e-9e59-81d1ca87c002_c33690f2-0813-4a47-80f3-bc1fc453cb67",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 68
          {
            fields: [
              {
                _uid: "50dbe4dd-86e6-4815-a3c7-1cc0c1842a55",
                component: "col",
                label: "",
                simplifiedLabel: "12.8.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "f24d027b-b146-48ba-9509-364e8f9f3f1f",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "A program is implemented to monitor TPSPs’ PCI DSS compliance status at least once every 12 months.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "36952c44-2fbb-414f-90aa-193929fb7294",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine documentation.",
                  "Interview responsible personnel",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "384945ff-bca6-4ca0-948c-6168ceefda51",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["ebfcc76b-1a58-4965-bc53-d0e875f6bb82"],
                },
              },
              {
                _uid: "ebfcc76b-1a58-4965-bc53-d0e875f6bb82",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "54e0d5f9-af39-4778-94d3-b5af0b66e43a_384945ff-bca6-4ca0-948c-6168ceefda51",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "774c1f7d-7c04-486e-815c-56283c619f46",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "Where an entity has an agreement with a TPSP for meeting PCI DSS requirements on behalf of the entity (for example, via a firewall service), the entity must work with the TPSP to make sure the applicable PCI DSS requirements are met. If the TPSP does not meet those applicable PCI DSS requirements, then those requirements are also “not in place” for the entity.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "47421d6e-80d9-4f9d-82a6-eed98c922da6",
                component: "col",
                label: "",
                simplifiedLabel: "12.8.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "27bcb2b1-4c35-4603-82cc-e20e710675a1",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Information is maintained about which PCI DSS requirements are managed by each TPSP, which are managed by the entity, and any that are shared between the TPSP and the entity.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "40b3b7e2-6a9c-448f-a1ab-1db76ac672c8",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine documentation.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "686e307f-e890-4567-8c1c-b945bdfd80f5",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["4ccf9f6c-1fc1-4051-83b7-aef8743772a4"],
                },
              },
              {
                _uid: "4ccf9f6c-1fc1-4051-83b7-aef8743772a4",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "5c6dc296-1ea5-4bc8-ba21-33b75cd4d804_686e307f-e890-4567-8c1c-b945bdfd80f5",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6e729e7c-a260-464a-b7b8-b2bfd8c387e8",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for requirements at 12.8.1 through 12.8.5 means that the merchant has a list of, and agreements with, service providers they share account data with or that could impact the security of the merchant’s cardholder data environment. For example, such agreements would be applicable if a merchant uses a document-retention company to store paper documents that include account data or if a merchant’s vendor accesses merchant systems remotely to perform maintenance.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 69
          {
            fields: [
              {
                _uid: "ed1ce795-0360-48fe-9201-6b1c682853d2",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "12.10 Suspected and confirmed security incidents that could impact the CDE are responded to immediately",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "9cafc999-3882-4b03-8bae-b36313d53667",
                component: "col",
                label: "",
                simplifiedLabel: "12.10.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "8f084807-7ff6-4659-9176-39e5792403a3",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "An incident response plan exists and is ready to be activated in the event of a suspected or confirmed security incident. The plan includes, but is not limited to:",
                  "Roles, responsibilities, and communication and contact strategies in the event of a suspected or confirmed security incident, including notification of payment brands and acquirers, at a minimum.",
                  "Incident response procedures with specific containment and mitigation activities for different types of incidents",
                  "Business recovery and continuity procedures.",
                  "Data backup processes",
                  "Analysis of legal requirements for reporting compromises.",
                  "Coverage and responses of all critical system components.",
                  "Reference or inclusion of incident response procedures from the payment brands.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "ed76e428-eaa9-4bbc-aa28-be7a31741ef7",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine the incident response plan.",
                  "Interview personnel.",
                  "Examine documentation from previously reported incidents.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "854f7ce6-3090-466c-ae10-9fdf2a4bd70f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["b6cd6b63-5105-4556-bfde-5e0f4ec5f21c"],
                },
              },
              {
                _uid: "b6cd6b63-5105-4556-bfde-5e0f4ec5f21c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "8cd1e1f0-6783-410c-bc91-ebc5cafa0def_854f7ce6-3090-466c-ae10-9fdf2a4bd70f",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6c5c4f93-c07c-444d-9845-8a5d5b03e319",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for Requirement 12.10.1 means that the merchant has documented an incident response and escalation plan to be used for emergencies, consistent with the size and complexity of the merchant’s operations. For example, such a plan could be a simple document posted in the back office that lists who to call in the event of various situations with an annual review to confirm it is still accurate, but could extend all the way to a full incident response plan including backup “hotsite” facilities and thorough annual testing. This plan should be readily available to all personnel as a resource in an emergency",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "83f59732-c00c-4f11-996b-bbd7e380f8ff",
                component: "col",
                label: "",
                simplifiedLabel: "12.10.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "13482860-2fe5-4c66-8269-f35a05192792",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Specific personnel are designated to be available on a 24/7 basis to respond to suspected or confirmed security incidents.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "2006801c-9de3-4b8e-a151-7cb828c9dc86",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Interview responsible personnel.",
                  "Examine documentation.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "bbd3ab16-680b-4614-8e42-570fcc6ac9a5",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["c99261e4-aa18-4ff8-a610-3791de0b117f"],
                },
              },
              {
                _uid: "c99261e4-aa18-4ff8-a610-3791de0b117f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "fb1245e2-3525-4a1f-a34d-00dcb434144f_bbd3ab16-680b-4614-8e42-570fcc6ac9a5",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          // 70
          {
            fields: [
              {
                _uid: "ecb46c96-dce1-4e5b-af37-dc4c59c56b23",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "A2.1 POI terminals using SSL and/or early TLS are not susceptible to known SSL/TLS exploits.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b2ca492c-fd87-4563-a00e-c722ec667ab0",
                component: "col",
                label: "",
                simplifiedLabel: "A2.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "41545ce9-d67f-47c6-a529-7f980c6ef095",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Where POS POI terminals at the merchant or payment acceptance location use SSL and/or early TLS, the entity confirms the devices are not susceptible to any known exploits for those protocols",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "b07c53c5-6b14-48d4-9221-23b069f1787f",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documentation (for example, vendor documentation, system/network configuration details) that verifies the devices are not susceptible to any known exploits for SSL/early TLS",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "98448179-791f-40be-bc4c-6f75ae3b37e3",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_place_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_place_with_CCW", "not_in_place"],
                  _uids: ["df866f76-df82-46da-ad55-4add38698241"],
                },
              },
              {
                _uid: "df866f76-df82-46da-ad55-4add38698241",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "df866f76-df82-46da-ad55-4add38698241_98448179-791f-40be-bc4c-6f75ae3b37e3",
                },
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "873c40ef-f0b2-4e05-a2ee-1237c4e69c67",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "This requirement is intended to apply to the entity with the POS POI terminal, such as a merchant. This requirement is not intended for service providers who serve as the termination or connection point to those POS POI terminals. Requirements A2.1.2 and A2.1.3 apply to POS POI service providers.",
                  "The allowance for POS POI terminals that are not currently susceptible to exploits is based on currently known risks. If new exploits are introduced to which POS POI terminals are susceptible, the POS POI terminals will need to be updated immediately.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
        ],
      },
    ],
  },
  // page 71 - NA
  // page 72
  {
    _uid: "ab090c5b-c4a4-4402-b4ee-a257de494906",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: "Appendix B: Compensating Controls Worksheet",
    fields: [
      {
        _uid: "2c986d3d-4b67-4717-ab01-0ffc54577dc7",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: [],
        simplifiedCaption: [
          "This Appendix must be completed to define compensating controls for any requirement where In Place with CCW was selected.",
          "Note: Only entities that have a legitimate and documented technological or business constraint can consider the use of compensating controls to achieve compliance",
          "Refer to Appendices B and C in PCI DSS for information about compensating controls and guidance on how to complete this worksheet.",
        ],
        headers: ["", "Information Required", "Explanation"],
        fields: [
          {
            fields: [
              {
                _uid: "de0a670f-733d-499c-aaf3-1809dd7d9ee1",
                component: "col",
                label: [""],
                simplifiedLabel: ["1. Constraints"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "2df3921b-4bd8-46e0-93df-cee6f553d10d",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Document the legitimate technical or business constraints precluding compliance with the original requirement.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "b3ee3795-ee26-415b-a8aa-a6588c865240",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1c9d2277-a966-49d2-bfe8-7a4da7021bbc",
                component: "col",
                label: [""],
                simplifiedLabel: ["2. Definition of Compensating Controls"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "e3a355b8-3029-49c7-a568-54e487c7c180",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Define the compensating controls: explain how they address the objectives of the original control and the increased risk, if any. ",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "7e1b04e8-df1d-4da2-8823-22aa1c320979",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d129bc2d-ac70-4a90-aaa9-fa67079fc9d4",
                component: "col",
                label: [""],
                simplifiedLabel: ["3. Objective"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "8550df3e-a85b-4626-94ba-926cad8e90eb",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Define the objective of the original control.",
                ],

                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "f9c58331-4a0f-40c1-aa7c-d6a8c2667eb5",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "85",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a3002bd4-018b-440c-a9e6-4421c5b0d0a1",
                component: "col",
                label: [""],
                simplifiedLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "2569f646-950a-4dcd-a3bd-da4796ef3dcf",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Identify the objective met by the compensating control.",
                  "Note: This can be, but is not required to be, the stated Customized Approach Objective listed for this requirement in PCI DSS.",
                ],

                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "67668de8-de9e-40d0-9fb8-6dbdd3f058a5",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "85",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7be7c412-2a06-412c-9301-93332666efb1",
                component: "col",
                label: [""],
                simplifiedLabel: ["4. Identified Risk"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "552846eb-13ed-470a-a794-d60f73ebc110",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Identify any additional risk posed by the lack of the original control.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "09d82031-e509-4730-b09e-c748b4445050",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "85",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "95e41bd3-f17f-4913-8586-8ec91b525370",
                component: "col",
                label: ["5. Validation of Compensating Controls"],
                simplifiedLabel: ["5. Validation of Compensating Controls"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "3385059a-2a84-4c17-8fa6-71415e4fd63f",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Define how the compensating controls were validated and tested.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "275d5b08-cd5d-4fac-a9a7-dcedd56bbb45",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "145",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7579bd14-4a0e-45fe-96a2-580c3633c55e",
                component: "col",
                label: [""],
                simplifiedLabel: ["6. Maintenance"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "ee1d386c-8f68-477a-8d0c-f21049dc48d1",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Define process(es) and controls in place to maintain compensating controls.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "f1b079bf-3df6-4939-891a-574c0fb4e583",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "85",
              },
            ],
          },
        ],
      },
    ],
  },
  // page 73 - NA
  // page 74 - NA
  // page 75
  {
    _uid: "7e83a74e-5401-4afb-a7f8-102d9735de70",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: "Section 3: Validation and Attestation Details",
    fields: [
      {
        _uid: "c7270999-95f6-4d2e-a907-046872e56fd7",
        component: "table",
        label: "",
        simplifiedLabel: "Part 3. PCI DSS Validation",
        type: "table",
        caption: [],
        simplifiedCaption: [
          "Part 3. PCI DSS Validation",
          "This AOC is based on results noted in SAQ A (Section 2), dated (Self-assessment completion date YYYY-MM-DD).",
          "Based on the results documented in the SAQ A noted above, each signatory identified in any of Parts 3b−3d, as applicable, assert(s) the following compliance status for the merchant identified in Part 2 of this document.",
          "Select one:",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "7c7cc5b3-ff97-4bc7-9298-bbf8da13e3d6",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
              },
              {
                _uid: "c8b0e1e8-e107-4932-83ec-80b74330a20a",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Compliant: All sections of the PCI DSS SAQ are complete and all requirements are marked as being either 1) In Place, 2) In Place with CCW, or 3) Not Applicable, resulting in an overall COMPLIANT rating; thereby (Merchant Company Name) has demonstrated compliance with all PCI DSS requirements included in this SAQ.",
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1fcd7a57-9df1-4900-8925-e81fdb116f05",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "Compliant",
                width: "20%",
              },
              {
                _uid: "c266fb46-9282-4ad8-bd7c-112265d8503f",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Non-Compliant: Not all sections of the PCI DSS SAQ are complete, or one or more requirements are marked as Not in Place, resulting in an overall NON-COMPLIANT rating; thereby (Merchant Company Name) has not demonstrated compliance with the PCI DSS requirements included in this SAQ",
                  "Target Date for Compliance: YYYY-MM-DD",
                  "A merchant submitting this form with a Non-Compliant status may be required to complete the Action Plan in Part 4 of this document. Confirm with the entity to which this AOC will be submitted before completing Part 4.",
                ],
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                component: "checkbox",
                type: "checkbox",
                value: "yes",
                width: "20%",
                col: "12",
                resetFields: {
                  value: "",
                  _uids: [
                    "ba5792dd-b17b-449e-b2aa-1c619eed20df",
                    "5006af3f-fcdc-4c04-a002-aa05456e3984",
                    "e6b79503-be2a-403f-8636-ca57d9f9c3bc",
                    "1f559e4b-02e3-4443-a846-837debacbd65",
                    "602ec636-86d6-4944-932b-ddd81d0b0b75",
                    "92df6dc3-c01f-4170-809b-ff5ea0f189c4",
                    "715bb739-794d-46f4-9e82-a6b909a5b326",
                    "e0920ac6-43fb-4bd4-ba44-723aa59322c6",
                  ],
                },
              },
              {
                _uid: "2439ba3c-a98f-4259-8ecd-4d574697c1fe",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Compliant but with Legal exception: One or more requirements in the PCI DSS SAQ are marked as Not in Place due to a legal restriction that prevents the requirement from being met and all other requirements are marked as being either 1) In Place, 2) In Place with CCW, or 3) Not Applicable, resulting in an overall COMPLIANT BUT WITH LEGAL EXCEPTION rating; thereby (Merchant Company Name) has demonstrated compliance with all PCI DSS requirements included in this SAQ except those noted as Not in Place due to a legal restriction.",
                  "Target Date for Compliance: YYYY-MM-DD",
                  "This option requires additional review from the entity to which this AOC will be submitted. If selected, complete the following:",
                ],
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ba5792dd-b17b-449e-b2aa-1c619eed20df",
                component: "text",
                label: "",
                simplifiedLabel: "Affected Requirement",
                type: "",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "11ab4969-da83-4b14-94ea-65ec33e4cfce_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                width: "50%",
              },
              {
                _uid: "5006af3f-fcdc-4c04-a002-aa05456e3984",
                component: "text",
                label: "",
                simplifiedLabel:
                  "Details of how legal constraint prevents requirement being met",
                type: "",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "1c2ed136-0cb6-47b7-a403-ebd93ca5a285_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                width: "50%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e6b79503-be2a-403f-8636-ca57d9f9c3bc",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "65971a55-9857-4899-a784-c01abb0fa044_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "25",
              },
              {
                _uid: "1f559e4b-02e3-4443-a846-837debacbd65",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "d5867ec6-cbf8-454e-b7b3-017ad7913a2c_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "70",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "602ec636-86d6-4944-932b-ddd81d0b0b75",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "3848c469-8c36-4bcd-9b87-9a32434151b4_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "25",
              },
              {
                _uid: "92df6dc3-c01f-4170-809b-ff5ea0f189c4",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "698387bc-14c6-4005-859c-9da0c41dd5b8_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "70",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "715bb739-794d-46f4-9e82-a6b909a5b326",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "7333d173-4c53-4d4a-89a4-f9f556d8bd36_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "25",
              },
              {
                _uid: "e0920ac6-43fb-4bd4-ba44-723aa59322c6",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "60350b4b-15b4-4dc0-8a32-cfaf1afa3369_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "70",
              },
            ],
          },
        ],
      },
    ],
  },
  // page - 76
  {
    _uid: "f7c40153-fe36-4570-82dd-520eae2fba93",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: "",
    fields: [
      {
        _uid: "3703ad33-f778-4bd8-b560-3398cb1513bb",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: [],
        simplifiedCaption: [
          "Part 3a. Merchant Acknowledgement",
          "Signatory(s) confirms:",
          "(Select all that apply)",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "a63691e9-9567-4925-820d-8752abe6b612",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
              },
              {
                _uid: "ece6b93a-7d16-46da-8138-36ba3dc12eca",
                component: "col",
                label: "",
                simplifiedLabel:
                  "PCI DSS Self-Assessment Questionnaire A, Version 4.0, was completed according to the instructions therein.",
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "38e7ba32-6b9e-4fc0-9d61-88fcd54ac6f5",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
              },
              {
                _uid: "e1d37b77-af21-404a-b097-f590e080d2fb",
                component: "col",
                label: "",
                simplifiedLabel:
                  "All information within the above-referenced SAQ and in this attestation fairly represents the results of the merchant’s assessment in all material respects.",
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f7a669dc-9758-48d4-82b9-e6722b0c7702",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
              },
              {
                _uid: "e6471716-6d26-4d89-b774-02143b7dc6ed",
                component: "col",
                label: "",
                simplifiedLabel:
                  "PCI DSS controls will be maintained at all times, as applicable to the merchant’s environment.",
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
        ],
      },
      {
        _uid: "8f34029d-61d7-4367-aa3e-12f699040a34",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "Part 3b. Merchant Attestation",
        fields: [
          {
            fields: [
              {
                _uid: "3ef29462-9468-467a-8d33-668475e19187",
                component: "col",
                label: ["Signature of Merchant Executive Officer"],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "text",
                col: "12",
                colSpan: "2",
                width: "60%",
              },
              {
                _uid: "b3e0e859-b26d-4b43-83fa-66ba717c8e2a",
                component: "col",
                label: ["Date: YYYY-MM-DD"],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                colSpan: "2",
                width: "40%",
                maxLength: "28",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b89c195b-c9b3-4ce2-b42e-8ada2e40452e",
                component: "col",
                label: [""],
                simplifiedLabel: ["Signature of Merchant Executive Officer"],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: "2",
                width: "60%",
              },
              {
                _uid: "faed680a-fdae-491b-8709-482415861e49",
                component: "col",
                label: [""],
                simplifiedLabel: ["Date: YYYY-MM-DD"],
                type: "",
                col: "12",
                colSpan: 2,
                width: "40%",
                maxLength: "28",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8ccbfc40-c74c-44c9-a7c9-c7a287f5541b",
                component: "col",
                label: [""],
                simplifiedLabel: ["Merchant Executive Officer Name: "],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "0089362f-b884-452d-9776-f263fdd3c854",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "14b71baa-67ec-487c-b3ad-550a01c8bae6",
                component: "col",
                label: [""],
                simplifiedLabel: ["Title"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "5b418f20-5a39-47cd-8461-547185b91a05",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                width: "35%",
                maxLength: "28",
              },
            ],
          },
        ],
      },
      {
        _uid: "6d65f61b-3db3-4dc2-bbf6-7aab1f08d25c",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption:
          "Part 3c. Qualified Security Assessor (QSA)Acknowledgement",
        fields: [
          {
            fields: [
              {
                _uid: "2bec4c53-6aef-41d8-9742-f87afea4130a",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "If a QSA was involved or assisted with this assessment, indicate the role performed:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: "4",
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "342c7f00-e529-4caa-b61b-eadc43297e95",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
              },
              {
                _uid: "bd573f0c-ea66-42be-8361-f5d544c925b6",
                component: "col",
                label: "",
                simplifiedLabel: "QSA performed testing procedures.",
                type: "",
                width: "80%",
                col: "12",
                colSpan: "3",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f37d68dc-b295-4e6e-a257-d756f885ab53",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
                resetFields: {
                  value: "",
                  _uids: [
                    "3486fa5b-95b4-4231-be8d-562ac05cfe5f",
                    "35f6ff12-551f-411c-9f09-5262a8bc9882",
                    "5286fbaf-d360-4fb0-a048-bd7e1bc315df",
                    "e5b153e5-c7cc-4ccd-a9d0-e5bbe989d107",
                    "71803f94-14e3-4aa0-9d62-16a2e3ee8086",
                    "945d2fc4-1f37-4597-93c8-d63dc498d4bd",
                    "0f3b652b-9c77-408d-8b9e-3b2e5bb62a2d",
                    "dd263f82-7859-497a-9bc1-e8ef0fe96ad4",
                    "e57da8a6-cefc-4283-bab1-dc2bbaa452bc",
                    "af9fceed-d116-496d-abe6-e7364f54bc54",
                    "7feaaf13-2e3f-47b5-b10e-0ba4747f5ff0",
                    "a16d9f36-c251-418f-ae30-09a81476075c",
                    "b6beebfb-5547-452e-8ade-bf1b5c55cbb9",
                    "a3aa4592-abf0-446b-b9f4-2a254494befe",
                  ],
                },
              },
              {
                _uid: "ae4da7e1-24d5-4500-81ed-f48ec5fffe81",
                component: "col",
                label: "",
                simplifiedLabel:
                  "QSA provided other assistance. If selected, describe all role(s) performed:",
                type: "",
                width: "80%",
                col: "12",
                colSpan: "3",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "3486fa5b-95b4-4231-be8d-562ac05cfe5f",
                component: "col",
                label: ["Signature of Lead QSA"],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "text",
                col: "12",
                colSpan: "2",
                width: "50%",
                conditional: {
                  value: "yes",
                  field:
                    "c52e2f18-f82c-4430-83af-7a1f504ec37a_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "35f6ff12-551f-411c-9f09-5262a8bc9882",
                component: "col",
                label: ["Date: YYYY-MM-DD"],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                colSpan: "2",
                width: "50%",
                maxLength: "28",
                conditional: {
                  value: "yes",
                  field:
                    "d03ca81e-8fc0-40bb-8779-221afdca5777_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5286fbaf-d360-4fb0-a048-bd7e1bc315df",
                component: "col",
                label: [""],
                simplifiedLabel: ["Signature of Lead QSA"],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: "2",
                width: "50%",
                conditional: {
                  value: "yes",
                  field:
                    "618009f8-60f2-4b71-ae30-ccc32ff61f9d_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "e5b153e5-c7cc-4ccd-a9d0-e5bbe989d107",
                component: "col",
                label: [""],
                simplifiedLabel: ["Date: YYYY-MM-DD"],
                type: "",
                col: "12",
                colSpan: "2",
                width: "50%",
                maxLength: "28",
                conditional: {
                  value: "yes",
                  field:
                    "2e9289f6-2dd2-4a57-951e-8922ce0d230f_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "71803f94-14e3-4aa0-9d62-16a2e3ee8086",
                component: "col",
                label: [""],
                simplifiedLabel: ["Lead QSA Name: "],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: "2",
                width: "50%",
                conditional: {
                  value: "yes",
                  field:
                    "f78aa84f-c10e-4245-90b3-8a77fa04bf48_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "945d2fc4-1f37-4597-93c8-d63dc498d4bd",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                colSpan: "2",
                width: "50%",
                maxLength: "28",
                conditional: {
                  value: "yes",
                  field:
                    "24ff9345-8cde-42ef-bd4e-a9c8f08bd200_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0f3b652b-9c77-408d-8b9e-3b2e5bb62a2d",
                component: "col",
                label: ["Signature of Duly Authorized Officer of QSA Company"],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "text",
                col: "12",
                colSpan: 2,
                width: "50%",
                conditional: {
                  value: "yes",
                  field:
                    "d8b5ada2-e0bf-4c66-a7db-df659113c503_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "dd263f82-7859-497a-9bc1-e8ef0fe96ad4",
                component: "col",
                label: ["Date: YYYY-MM-DD"],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                colSpan: 2,
                width: "50%",
                maxLength: "28",
                conditional: {
                  value: "yes",
                  field:
                    "0081a7e9-4a50-4471-a122-1838914e2bc4_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e57da8a6-cefc-4283-bab1-dc2bbaa452bc",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Signature of Duly Authorized Officer of QSA Company",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 2,
                width: "50%",
                conditional: {
                  value: "yes",
                  field:
                    "0bf50a7d-1cae-437b-bc3b-d68d3ffbc2f0_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "af9fceed-d116-496d-abe6-e7364f54bc54",
                component: "col",
                label: [""],
                simplifiedLabel: ["Date: YYYY-MM-DD"],
                type: "",
                col: "12",
                colSpan: 2,
                width: "50%",
                maxLength: "28",
                conditional: {
                  value: "yes",
                  field:
                    "37e9409a-415a-4ab6-bcdc-e52e4f182d62_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7feaaf13-2e3f-47b5-b10e-0ba4747f5ff0",
                component: "col",
                label: [""],
                simplifiedLabel: ["Duly Authorized Officer Name: "],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
                conditional: {
                  value: "yes",
                  field:
                    "0dd0847a-6c4d-4084-8b9d-589a11e48f33_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "a16d9f36-c251-418f-ae30-09a81476075c",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                width: "25%",
                maxLength: "28",
                conditional: {
                  value: "yes",
                  field:
                    "635a5887-6188-4ce1-8cf1-077188312f19_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "b6beebfb-5547-452e-8ade-bf1b5c55cbb9",
                component: "col",
                label: [""],
                simplifiedLabel: ["QSA Company:"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
                conditional: {
                  value: "yes",
                  field:
                    "0c0ca787-57d6-42a0-ac0d-a21218e17384_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "a3aa4592-abf0-446b-b9f4-2a254494befe",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                width: "30%",
                maxLength: "28",
                conditional: {
                  value: "yes",
                  field:
                    "a4c9e942-883a-4ddd-9657-a1b59cb7d73e_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
            ],
          },
        ],
      },
      {
        _uid: "7dcf3b0b-4a10-4ab7-ad8c-0444a9e88f7b",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption:
          "Part 3d. PCI SSC Internal Security Assessor (ISA) Involvement",
        fields: [
          {
            fields: [
              {
                _uid: "57354855-b0ab-4f2d-8fcb-2609c472678e",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "If an ISA(s) was involved or assisted with this assessment, indicate the role performed:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: "4",
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "88542f99-4c83-4291-b18d-282e2b0632ee",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
              },
              {
                _uid: "ecf60fad-172b-48b7-af42-55583f2a3171",
                component: "col",
                label: "",
                simplifiedLabel: "ISA(s) performed testing procedures.",
                type: "",
                width: "80%",
                col: "12",
                colSpan: "3",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e2c67566-11eb-4f56-b495-8ea89f703fa9",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
                resetFields: {
                  value: "",
                  _uids: ["6bbfebb8-6022-4ccb-aa16-4249a6d38e02"],
                },
              },
              {
                _uid: "2462213e-afc6-4e28-9c7c-4d5cf4c2c54a",
                component: "col",
                label: "",
                simplifiedLabel:
                  "ISA(s) provided other assistance. If selected, describe all role(s) performed:",
                type: "",
                width: "80%",
                col: "12",
                colSpan: "3",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6bbfebb8-6022-4ccb-aa16-4249a6d38e02",
                component: "col",
                label: "",
                simplifiedLabel: "",
                placeholder: "Describe all role(s) performed",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                colSpan: 4,
                conditional: {
                  value: "yes",
                  field:
                    "7a710f1f-871f-4e23-b074-c2c0389ab984_e2c67566-11eb-4f56-b495-8ea89f703fa9",
                },
                width: "100%",
                maxLength: "320",
              },
            ],
          },
        ],
      },
    ],
  },
  // page - 77
  {
    _uid: "6703f7b8-d620-4566-ba6b-57e9c2d3af2b",
    layout: "form",
    component: "page",
    label: "",
    simplifiedCaption: "",
    fields: [
      {
        _uid: "ad8680c0-ba56-4145-83bc-f20850f511f5",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: [],
        simplifiedCaption: [],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "a1bda2de-e162-424b-a4f1-30c43cf001ab",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                boldLabel: "Part 4. Action Plan for Non-Compliant Requirements",
                subBoldLabel: [
                  "Only complete Part 4 upon request of the entity to which this AOC will be submitted, and only if the Assessment has a Non-Compliant status noted in Section 3.",
                  "If asked to complete this section, select the appropriate response for “Compliant to PCI DSS Requirements” for each requirement below. For any “No” responses, include the date the merchant expects to be compliant with the requirement and a brief description of the actions being taken to meet the requirement.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
            ],
          },
        ],
      },
      {
        _uid: "afb88315-dfc5-483e-b1d6-d727d7d569d6",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: [],
        simplifiedCaption: [],
        headers: [
          "PCI DSS Requirement*",
          "Description of Requirement",
          "Compliant to PCI DSS Requirements",
          "Remediation Date and Actions (If “NO” selected for any Requirement)",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "09ed17e4-d7c2-4c1a-9635-d75f43c6ef56",
                component: "col",
                label: [""],
                simplifiedLabel: ["1"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "5b32c777-7921-484d-9d11-cf35e528cf98",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Install and maintain network security controls",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "9404507d-01cc-44c3-b92f-1698e361e7a3",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["1f162e1f-99ba-46fe-9e39-2e19c5eefaea"],
                },
              },
              {
                _uid: "1f162e1f-99ba-46fe-9e39-2e19c5eefaea",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field:
                    "998dfb9a-a74d-4b2c-be5a-ce3b59c69b66_9404507d-01cc-44c3-b92f-1698e361e7a3",
                },
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a1bda2de-e162-424b-a4f1-30c43cf001ab",
                component: "col",
                label: [""],
                simplifiedLabel: ["2"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "8fd97f10-d533-4004-a6ed-e4cad018e190",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Apply secure configurations to all system components",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "3de2fb2a-abeb-4d2a-8480-638084717840",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["0d523bb5-d058-402f-8abb-7f05a1d77a8e"],
                },
              },
              {
                _uid: "0d523bb5-d058-402f-8abb-7f05a1d77a8e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field:
                    "84f6b0b5-4187-4cb3-a2e6-3caeb9122eda_3de2fb2a-abeb-4d2a-8480-638084717840",
                },
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4a799130-aef0-401e-8f88-a243cb56b628",
                component: "col",
                label: [""],
                simplifiedLabel: ["3"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7af99412-1790-49b0-80f3-8452bc7086d2",
                component: "col",
                label: [""],
                simplifiedLabel: ["Protect stored account data"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "c03217d3-7e28-4aaa-96de-5d246e84b703",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["7a0eca31-d1df-4d1c-92c7-9841be86d4bc"],
                },
              },
              {
                _uid: "7a0eca31-d1df-4d1c-92c7-9841be86d4bc",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field:
                    "24b994f6-efac-43d7-ab03-bce46757fe95_c03217d3-7e28-4aaa-96de-5d246e84b703",
                },
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5b297358-233c-4c5b-a62b-8258c1d53858",
                component: "col",
                label: [""],
                simplifiedLabel: ["4"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "663133c3-d25c-4794-919c-a8dbc7f28794",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Protect cardholder data with strong cryptography during transmission over open, public networks",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "99164538-358d-4dd4-9fe4-5418ba9fd53e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["a8610dd8-67cc-4878-9bcf-5b55a57597bc"],
                },
              },
              {
                _uid: "a8610dd8-67cc-4878-9bcf-5b55a57597bc",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field:
                    "c4e6ee76-a639-4c03-98c4-df41ace82e27_99164538-358d-4dd4-9fe4-5418ba9fd53e",
                },
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "de255f00-67b9-4653-b803-8e8f7ed65dcb",
                component: "col",
                label: [""],
                simplifiedLabel: ["5"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "b6440702-3c40-46ba-89ae-0e57b24edc8b",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Protect all systems and networks from malicious software",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "b603aa66-d295-4857-94a9-6d31164d4327",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["c852df55-3b4f-40d5-848d-9f04dddfa2ab"],
                },
              },
              {
                _uid: "c852df55-3b4f-40d5-848d-9f04dddfa2ab",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field:
                    "c5e90795-a214-425d-b351-823f3956edb6_b603aa66-d295-4857-94a9-6d31164d4327",
                },
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7d909157-3e85-402c-afc9-9687534cc37e",
                component: "col",
                label: [""],
                simplifiedLabel: ["6"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "5aab4319-f9df-4a5a-b2ea-5d6c94adc638",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Develop and maintain secure systems and software",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "e80f7abe-0ad9-4cdf-8a81-c48e33bb9e8c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["d218a370-bedf-4c06-ab0c-c3593d20ef19"],
                },
              },
              {
                _uid: "d218a370-bedf-4c06-ab0c-c3593d20ef19",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field:
                    "a1678c93-fcc2-43e8-9b43-0380a5d4b931_e80f7abe-0ad9-4cdf-8a81-c48e33bb9e8c",
                },
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "dbc41201-0bb0-49d7-a574-d372248177a1",
                component: "col",
                label: [""],
                simplifiedLabel: ["7"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "1e11bbe3-5422-4c0c-9acd-421efb0b2178",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Restrict access to system components and cardholder data by business need to know",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "d001f65c-23dd-448c-8cbb-c84fd236f0d9",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["dc744b62-f7df-4bea-a35d-cba35dd1e23a"],
                },
              },
              {
                _uid: "dc744b62-f7df-4bea-a35d-cba35dd1e23a",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field:
                    "3d155a39-fd87-42ad-9981-3e8462e07a31_d001f65c-23dd-448c-8cbb-c84fd236f0d9",
                },
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ed73014a-a854-4649-876e-0cf100b71974",
                component: "col",
                label: [""],
                simplifiedLabel: ["8"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "5743ddfe-e0f4-4be0-b769-c499ea77d1c0",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Identify users and authenticate access to system components",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "d91076ae-a1e6-4aca-8f77-f4b61721f355",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["1206feba-b01d-4284-871f-6b56114cc49b"],
                },
              },
              {
                _uid: "1206feba-b01d-4284-871f-6b56114cc49b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field:
                    "37c917dd-1c63-4bbb-86a9-2205b056b248_d91076ae-a1e6-4aca-8f77-f4b61721f355",
                },
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6d4ad0b7-0ba7-4c8b-80c6-a2a28e610800",
                component: "col",
                label: [""],
                simplifiedLabel: ["9"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "eabb273e-9804-4ea8-860a-7cef8b416ed6",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Restrict physical access to cardholder data",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "1120c4c9-880b-4787-a77c-d854d94c1501",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["48fdc1a5-b71e-44dc-a3a9-8425ea492c6a"],
                },
              },
              {
                _uid: "48fdc1a5-b71e-44dc-a3a9-8425ea492c6a",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field:
                    "533b6281-8811-4282-ad80-fced4ac1b119_1120c4c9-880b-4787-a77c-d854d94c1501",
                },
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "3459a4e6-7b51-407a-b0a8-7843891f7534",
                component: "col",
                label: [""],
                simplifiedLabel: ["10"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c2c106bf-acb7-4285-8c80-e6fbbab39866",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Log and monitor all access to system components and cardholder data",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "dc3d0d5d-ef27-4e5b-8cfc-482311b6c4e2",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["5fbe169a-8069-47df-bda3-7f099bfe6ec1"],
                },
              },
              {
                _uid: "5fbe169a-8069-47df-bda3-7f099bfe6ec1",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field:
                    "dc24adda-e9fc-4d0a-b759-b4ca5bef8e9a_dc3d0d5d-ef27-4e5b-8cfc-482311b6c4e2",
                },
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "dea416ea-1090-4822-a15b-0245c4d48062",
                component: "col",
                label: [""],
                simplifiedLabel: ["11"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "6c7c3e23-4fda-4ce8-8842-e2b23e879a26",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Test security systems and networks regularly",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "8542b132-8ccb-4a81-9b79-f820bc26ff56",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["a165d774-a674-435b-98c8-833d28279384"],
                },
              },
              {
                _uid: "a165d774-a674-435b-98c8-833d28279384",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field:
                    "a5d977a0-a124-4031-9d86-8624afe29381_8542b132-8ccb-4a81-9b79-f820bc26ff56",
                },
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "93106548-c28e-4007-9f0f-6567043bbda6",
                component: "col",
                label: [""],
                simplifiedLabel: ["12"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "66c5df27-b83a-404e-9d01-a8f2beb5fda2",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Support information security with organizational policies and programs",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "b5435e94-84f6-42b5-ae06-298bcf5ecbcd",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["50377fbd-8c89-4199-8ff4-30ad491f04a9"],
                },
              },
              {
                _uid: "50377fbd-8c89-4199-8ff4-30ad491f04a9",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field:
                    "4f90be87-24af-42b3-85f5-16ccba3819d5_b5435e94-84f6-42b5-ae06-298bcf5ecbcd",
                },
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "867df57b-d1f5-4f80-89fd-36dce5f72563",
                component: "col",
                label: [""],
                simplifiedLabel: ["Appendix A2"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "698e4365-6455-4cae-8c34-d74e015b71b4",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Additional PCI DSS Requirements for Entities using SSL/Early TLS for CardPresent POS POI Terminal Connections.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "5fe71f3d-d5a8-4acf-ac55-9577ee0d3839",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["bc47ddd8-60f5-4b33-9794-2115f6d44cee"],
                },
              },
              {
                _uid: "bc47ddd8-60f5-4b33-9794-2115f6d44cee",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field:
                    "fc7b0668-822e-4a01-8ec5-0bf7d8a93ef9_5fe71f3d-d5a8-4acf-ac55-9577ee0d3839",
                },
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
        ],
      },
    ],
  },
];
